export const TextLang: any = {
    us: {
        shop1: 'Earn every time you order.',
        warranty1: 'You got 1000 EcoCredits by registering a product.',
        profile1: 'You got 1000 EcoCredits by completing your profile.',
        referral1: "Get EcoCredits for each friend's successful registration.",
        ins: 'You got 100 EcoCredits by following us on Instagram.',
        x: 'You got 100 EcoCredits by following us on X.',
        youtube: 'You got 100 EcoCredits by following us on YouTube.',
        facebook: 'You got 100 EcoCredits by following us on Facebook.',
        line: 'You earned 100 EcoCredits by registering as a friend on LINE.',
        joininfacebook: 'You got 100 EcoCredits by joining us on Facebook.',
        clock_in: 'Check-in',
        seo_title: 'Join The EcoCredits Loyalty Program',
        seo_desc: 'Join the EcoCredits Loyalty Program at EcoFlow today and start earning rewards now! Get a 500-EcoCredits reward just for signing up.',
        join_title: 'Join the EcoCredits reward program',
        join_subTitle: 'Become a member now and get EcoCredits for cash deductions and exclusive rewards.',
        join_now: 'JOIN NOW',
        login: 'LOG IN',
        login_capital_letters: 'Log in',
        login_capital_letters1: 'Log in',
        subscribe1: 'You got 500 EcoCredits by subscribing.',
        welcome_title: 'Hi {username}',
        welcome_sub_title: 'Welcome to the EcoCredits reward program.',
        welcome_text: 'Earn more EcoCredits and upgrade to PLUS Membership to enjoy more exclusive rewards.',
        welcome_text_plus: 'The upgraded exclusive benefits allow you to save and experience even more with us!',
        summary_text: 'Your EcoCredits Summary',
        membership: 'MEMBER',
        current_tier: 'Current Tier',
        points: 'EcoCredits',
        points_balance: 'EcoCredits Balance',
        points_progress_tips: 'EcoCredits Needed to Reach {plus}: {points} EcoCredits',
        coming_soon: 'Coming Soon',
        expires_in_one_month: 'Expires in One Month',
        redeem_now: 'REDEEM NOW',
        points_activity: 'POINTS ACTIVITY',
        how_it_works: 'How It Works',
        sign_up: 'Sign Up',
        sign_up_desc: 'Create an account for free and start your membership journey.',
        earn_points: 'Earn & Use',
        earn_points_desc: 'Complete tasks for EcoCredits to use as cash or redeem rewards.',
        redeem_points: 'Enjoy More',
        redeem_points_desc: 'Get 6000 EcoCredits and upgrade to a PLUS Membership for more.',
        more_benefits: 'MORE BENEFITS',
        more_benefits_desc: 'Upgrade to PLUS Member to save more.',
        more_benefits_question: 'Once you have 6,000 EcoCredits in your account, you can upgrade to PLUS Membership.',
        sign_up_desc_1: 'Create an account and get 800 EcoCredits reward.',
        already_member: 'Already a member?',
        already_member1: 'Already a member?',
        sign_up1: 'You got 500 EcoCredits by signing up.',
        sign_up1_1: 'You got 700 EcoCredits by signing up.',
        sign_up_desc_h: 'Sign up for Membership for 500 EcoCredits.',
        sign_up_desc_h_1: 'Sign up for Membership for 700 EcoCredits.',
        earn_points_title: 'Ways to Earn EcoCredits',
        sign_up_text: '500 EcoCredits upon joining',
        completed_text: 'You have already achieved this reward.',
        subscribe: 'Subscribe',
        subscribe_capital_letters: 'Subscribe',
        subscribe_text: 'Subscribe to get the latest EcoFlow news.',
        subscribe_hover: 'Earn 500 EcoCredits when you join.',
        subscribe_now: 'Subscribe Now',
        email_address: 'Email Address',
        shop: 'Shop',
        shop_capital_letters: 'Shop',
        earn_point_by_order: 'Earn EcoCredits every time you shop. （$1=1EcoCredits）',
        earn_point_rule_shop: 'Get 1 EcoCredits for every $1 you spend.',
        shop_to_earn_points: 'Shop To Earn EcoCredits',
        warranty: 'Warranty',
        warranty_capital_letters: 'Warranty Registration',
        warranty_desc1: 'Register a newly received product for 1000 EcoCredits.',
        warranty_desc2: 'Register a newly received product for 1000 EcoCredits.',
        profile: 'Complete Profile',
        profile_desc1: 'Completing your profile for up to 1000 EcoCredits.',
        profile_desc2: 'Get up to 1000 EcoCredits for adding your details.',
        complete_profile: 'Complete Profile',
        referral: 'Invited A Friend',
        referral_desc: "Get EcoCredits for each friend's successful registration.",
        referral_btn: 'Join Now',
        birthday: 'BIRTHDAY',
        birthday_desc1: 'Add your birthday for EcoCredits.',
        birthday_desc2: 'Earn {points} EcoCredits when you add your date of birth.',
        add_your_birthday: 'Add Your Birthday',
        birthday_placeholder: 'MM / DD / YY',
        add_my_birthday: 'Add My Birthday',
        ins_title: 'Follow Us On Instagram',
        ins_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        ins_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        follow_button: 'Follow Now',
        follow_button_ins: '',
        follow_button_x: '',
        follow_button_youtube: '',
        follow_button_facebook: '',
        x_title: 'Follow Us On X',
        x_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        x_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        youtube_title: 'Follow Us On YouTube',
        youtube_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        youtube_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        facebook_title: 'Follow Us On Facebook',
        facebook_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        facebook_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        joininfacebook_title: 'Join Us On Facebook',
        joininfacebook_desc1: 'Earn {points} EcoCredits when you join for the first time.',
        joininfacebook_desc2: 'Earn {points} EcoCredits when you join for the first time.',
        community_post_title: 'Post Daily',
        community_post_desc1: 'Earn {points} EcoCredits when you post in the community.',
        community_post_desc2: 'Earn {points} EcoCredits when you post in the community.',
        community_post_btn: 'Post Now',
        community_comment_title: 'Comment Daily',
        community_comment_desc1: 'Earn {points} EcoCredits when you comment in the community.',
        community_comment_desc2: 'Earn {points} EcoCredits when you comment in the community.',
        community_comment_btn: 'Comment Now',
        community_like_title: 'Like Daily',
        community_like_desc1: 'Earn {points} EcoCredits when you like posts in the community.',
        community_like_desc2: 'Earn {points} EcoCredits when you like posts in the community.',
        community_like_btn: 'Like Now',
        redeem_ecocredits_title: 'Redeem EcoCredits Rewards',
        have_points: 'You have <code>{points} EcoCredits</code>',
        view_all: 'View all',
        coupon: 'Discount code',
        discount: 'Discount',
        gift_card: 'Gift Card',
        redeemed_succ: 'Redeemed successfully!',
        copy_desc: 'You have copied the code, please go to the store to use it.',
        store: 'Shop Now',
        coupon_used_desc: 'Use this code at checkout to redeem your {amont} gift card.',
        rules: 'Rules',
        off: 'OFF',
        site_rules: 'For US store only.',
        days_rules: 'Valid for {days} days from redemption.',
        product_rules: 'For {product} only.',
        days_rules2: 'Valid from {data}.',
        rewards_redeemed: 'My Rewards',
        lucky_rewards_list: 'Rewards List',
        redeedmed_tab_name: 'Redeemed',
        issued_tab_name: 'Issued',
        available: 'Available',
        redeemed: 'Redeemed',
        expired: 'Expired',
        edeemed_rewards_note: 'Your redeemed rewards will appear here.',
        browse_ecocredits_rewards: 'Browse EcoCredits Rewards',
        used: 'Used',
        give_away: 'Give away',
        or_text: 'OR',
        send_your_friend: 'Send your {amont} gift card to a friend.',
        points_activity_a: 'My Activity',
        check_more: 'Check More',
        points_tab_name: 'EcoCredits Activity',
        rewards_tab_name: 'Rewards Activity',
        date: 'Date',
        action: 'Action',
        email: 'Email',
        rewards_title: 'Rewards',
        type_title: 'Type',
        discount_type: 'Discount',
        purchase: 'Purchase',
        profile_a: 'Profile',
        refund: 'Refund',
        registered: 'Registered',
        points_capital_letters: 'EcoCredits',
        status: 'Status',
        pending: 'Pending',
        received: 'Received',
        deducted: 'Deducted',
        view_more: 'View More',
        history_note: 'Your activity will appear here. Don’t see your activity yet? Your activity will update within 24 hours.',
        lucky_flop_start: 'Join Now',
        lucky_flop_congrat: 'Congratulations',
        lucky_flop_get: 'Claim',
        lucky_flop_open: 'OPEN',
        ecoflow_benefits: 'EcoCredits Benefits',
        membership_includes: 'MEMBERSHIP INCLUDES',
        benefits_item1: 'Earn EcoCredits for Every Purchase',
        benefits_item2: 'Redeem EcoCredits for Coupon',
        benefits_item3: 'Free Shipping on Most Products',
        benefits_item4: 'Redeem EcoCredits for Special Gifts',
        benefits_item5: 'Extended Warranty for Selected Products',
        benefits_item6: 'Member-Only Event',
        benefits_item7: 'Earn EcoCredits From Successful Friend Sign-ups',
        benefits_item8: 'Benefits From Our Partners',
        benefits_item9: 'Refer & Earn Up To $500 Cash Reward!',
        benefits_link_btn: 'Refer Now',
        see_t_c: 'See Terms and Conditions',
        manually_added: 'Manually Added',
        manually_deducted: 'Manually Deducted',
        faq_title: 'FAQ',
        earning_points: 'EARNING EcoCredits',
        network_error: 'Network Error',
        confirm_text: 'Are you sure you want to redeem? Cannot be undone.',
        confirm_btn: 'Confirm',
        no_enough_points: 'Redemption failed, your EcoCredits are not enough',
        no_history_note: 'Don’t see your EcoCredits yet? Your activity will update with in 24 hours.',
        no_coupon_note: 'No rewards redeemed yet.',
        minimum_price: 'Minimum purchase amount ({price}).',
        minimum_num: 'Minimum quantity of items({num} pcs).',
        stay_too_long: 'Your session has expired. Please refresh the page and try again.',
        order_rule: 'Only one discount code per order.',
        purchas_rule: 'Purchasing an item for less than the coupon(s), will forfeit the difference.',
        profile_birthday: 'Profile - birthday',
        profile_address: 'Profile - address',
        profile_username: 'Profile - username',
        profile_picture: 'Profile - picture',
        profile_contact: 'Profile - contact info',
        View_1_Explore_Article: 'View 1 Explore article',
        View_2_Explore_Article: 'View 2 Explore articles',
        View_3_Explore_Article: 'View 3 Explore articles',
        Enable_push_notifications: 'Enable push notifications',
        Try_the_energy_calculator_once: 'Try the energy calculator once',
        learn_more: 'Learn more',
        profile_detail:
            'Complete your profile for up to 1000 EcoCredits, including profile pic (200), user name (100), contact info (300), address (200), and birthday (200).',
        exceeded_counts: 'Failed to redeem. You have exceeded the redemption limit.',
        grab_title: 'Grab an EcoCredits Bonus',
        grab_sub_title: 'Exclusive limited-time offers for EcoCredit members. Click to claim now!',
        grab_btn_text: 'Grab My Bonus',
        grab_success_title: 'Congratulations',
        grab_success_text1: 'Bonus claimed successfully!\n Paste the code at checkout to get your discount.',
        grab_success_text2: 'Check your bonuses in <code>My Rewards</code>.',
        'no-grab-content-note': 'More offers coming soon!',
        copy_desc_2: 'You have copied the code.',
        city_validatino_error: 'Invalid city',
        product_text: 'Product',
        shipping_address_text: 'Shipping address',
        saved_address_text: 'Saved addresses',
        use_new_address: 'use a new address',
        spend_now: 'Spend Now',
        stock_left: '{stock} Left',
        no_stock_tip: 'Coming soon... Stay tuned!',
        order_text: 'Order',
        campaign_time_limit_text: 'Valid redemption period: {startTime} - {endTime}.',
        event_action_text: 'Event',
        warranty_minus_action_text: 'Warranty Deleted',
        question_correctly: 'Answer the question correctly',
        follow_instagram_text: 'Follow Instagram',
        follow_x_text: 'Follow X',
        follow_youtube_text: 'Follow YouTube',
        follow_facebook_text: 'Follow Facebook',
        join_facebook_text: 'Join Us On Facebook',
        referral_correctly: 'Referral program',
        confirm_btn_text: 'Close',
        lucky_turntable_title: 'Lucky Spin',
        join_lucky_with_points: 'It costs you {points} EcoCredits to do one round of Lucky Spin.',
        join_lucky_with_points2: 'It costs you {points} EcoCredits to play a round.',
        join_lucky_desc: 'Spin the wheel and get a great prize!',
        remaining_number: '<code></code> spins left',
        remaining_number2: '<code></code> flips left',
        learn_lucky_rule: 'Learn more about the rules',
        prize_coupon_title: 'Congratulations',
        prize_coupon_sub_title: 'The prize was claimed successfully! Use the code at checkout to save.',
        prize_coupon_action: 'Check your prizes in <code>My Rewards</code>.',
        prize_coupon_button: 'Shop Now',
        prize_points_title: 'Congratulations',
        prize_points_desc: 'Check the just-added EcoCredits in <code>My Activity</code>.',
        limit_times_in_day: 'You can spin the wheels <count></count> times in <day></day> days',
        limit_times_in_day2: 'You can flip the cards <count></count> times in <day></day> days',
        limit_times_in_active: 'During the event, you can spin the wheels up to <count></count> times.',
        without_limit_times: 'You can spin the wheels <count></count> times at any time.',
        without_limit_times2: 'You can flip the cards <count></count> times at any time.',
        active_is_unstart: 'This event is coming soon.',
        active_is_ended: 'This event has ended.',
        over_max_count: 'You have exceeded the number of spins available.',
        notice_title: 'Notice',
        points_cash: 'Points Redemption',
        Pending1: 'Pending',
        rollback: 'Returned',
        level_change_log: 'Tier Activity',
        deadline: 'Valid Until',
        history_refresh_member: 'Current Tier: Member',
        history_refresh_plus_member: 'Current Tier: PLUS Member',
        register: 'Register as a Member',
        upgrade: 'Upgrade to PLUS Member',
        demotion: 'Downgrade to Member',
        relegation: 'Maintain as PLUS Member',
        ecocredits_notice1:
            'We have updated the EcoCredits rules on Oct 17, 2024. Please carefully read our updated [<line1>EcoCredits rules</line1>] before using your EcoCredits.',

        ecoflowbenefits_title: 'EcoCredits Exclusive Benefits',
        ecoflowbenefits_savings: 'More Savings',
        ecoflowbenefits_support: 'More Support',
        ecoflowbenefits_experiences: 'More Experiences',
        ecoflowbenefits_tab_benefits: 'Benefits',
        ecoflowbenefits_tab_tier: 'Tier',
        ecoflowbenefits_tab_plus: 'PLUS MEMBER',
        ecoflowbenefits_tab_normal: 'MEMBER',
        ecoflowbenefits_savings1: 'Earn EcoCredits for Every Purchase',
        ecoflowbenefits_savings2: 'Earn EcoCredits From Successful Friend Sign-ups',
        ecoflowbenefits_savings3: 'Redeem EcoCredits for Discounts',
        ecoflowbenefits_savings4: 'Redeem EcoCredits for Special Gifts',
        ecoflowbenefits_savings5: 'Save 25% OFF at Harvest Hosts',
        ecoflowbenefits_savings5_link: 'Get the Code',
        ecoflowbenefits_savings6: 'Save 10% OFF at Winnebago gears',
        ecoflowbenefits_savings6_link: 'Get the Code',
        ecoflowbenefits_savings7: 'Refer & Earn Up To $500 Cash Reward!',
        ecoflowbenefits_savings7_link: 'Refer Now',
        ecoflowbenefits_savings8: 'Exclusive Birthday Coupon',
        ecoflowbenefits_savings9: 'PLUS Level-up Coupon',
        ecoflowbenefits_savings10: 'PLUS Exclusive Gifts ',
        ecoflowbenefits_savings11: 'Monthly Coupon Pack',
        ecoflowbenefits_savings21: 'Enjoy special Member-only prices (when available)',
        ecoflowbenefits_savings22: 'Use EcoCredits as cash for orders.',
        ecoflowbenefits_savings_tips1: 'Enjoy one free return within one month of purchase.',
        ecoflowbenefits_savings_tips2:
            'Receive a special discount on service charges for out-of-warranty repairs.\nEcoFlow reserves the right to determine the scope of repairs based on the actual situation.',
        ecoflowbenefits_savings_tips3:
            'If your product is irreparably damaged, you’re eligible for this exclusive benefit. Simply provide proof of shipment for the damaged item along with a screenshot of your PLUS Membership status. Once verified, we’ll send you a replacement right away—no need to wait for us to receive the broken item.',
        ecoflowbenefits_support1: 'Free Shipping on Most Products',
        ecoflowbenefits_support2: 'Extended Warranty for Selected Products',

        ecoflowbenefits_support3: 'Free Unconditional Return (1 Order)',
        ecoflowbenefits_support4: '12% Discount on Out-of-Warranty Service Charges',
        ecoflowbenefits_support5: 'Express Replacement Service',
        ecoflowbenefits_support6: 'Tier',

        ecoflowbenefits_experiences1: 'Benefits From Our Partners',
        ecoflowbenefits_experiences2: 'Member-Only Event',
        ecoflowbenefits_experiences3: 'New Product Trial Event (Coming Soon)',
        ecoflowbenefits_experiences4: 'Exclusive Early Bird Access (Coming Soon)',
        ecoflowbenefits_savings_message: 'Please check <line>here</line> to see how to claim vouchers for PLUS MEMBER.',
        ecoflowbenefits_savings_message_pop1: "1. Don't forget to log into your EcoFlow Account on the EcoCredits page.",
        ecoflowbenefits_savings_message_pop2: '2. You will see the pop-up right away if you have a new voucher to claim.',
        ecoflowbenefits_savings_message_pop3:
            "3. Don't worry if you missed it. Go to the 'gift' icon and check the voucher in \"My Rewards\". Don't forget to use it within the valid time.",
        ecoflowbenefits_support_message: 'Please contact <email>support@ecoflow.com</email> for assistance in using your benefits.',
        ecoflowbenefits_experiences_message: 'Stay tuned with us!',
        only_plus_member: 'Only PLUS Members can redeem the reward.',
        only_member: 'Only Members can redeem the reward.',

        plusbenefit: {
            ins_title: 'Follow Us On Instagram',
            ins_desc: 'Earn XX EcoCredits when you follow for the first time.',
        },
        date_of_event: 'Date of Event',
        expiration_date: 'Expiration Date',
        not_eligible: 'You are not eligible to participate in this event.',
        // 25年会员活动
        first_login_2025: 'First time logging in',
        know_brand_2025: 'Learn more about EcoFlow',
        know_member_2025: 'Learn more about Membership',
        share_story_2025: 'Share my story',
        first_order_2025: 'Complete a purchase',
        repeat_order_2025: 'Make an additional purchase',
    },
    uk: {
        shop1: 'Earn every time you order.',
        warranty1: 'You got 1000 EcoCredits by registering a product.',
        profile1: 'You got 1000 EcoCredits by completing your profile.',
        referral1: "Get EcoCredits for each friend's successful registration.",
        ins: 'You got 100 EcoCredits by following us on Instagram.',
        x: 'You got 100 EcoCredits by following us on X.',
        youtube: 'You got 100 EcoCredits by following us on YouTube.',
        facebook: 'You got 100 EcoCredits by following us on Facebook.',
        line: 'You earned 100 EcoCredits by registering as a friend on LINE.',
        joininfacebook: 'You got 100 EcoCredits by joining us on Facebook.',
        subscribe1: 'You got 500 EcoCredits by subscribing.',
        ecoflowbenefits_title: 'EcoCredits Exclusive Benefits',
        ecoflowbenefits_savings: 'More Savings',
        ecoflowbenefits_support: 'More Support',
        ecoflowbenefits_experiences: 'More Experiences',
        ecoflowbenefits_tab_benefits: 'Benefits',
        ecoflowbenefits_tab_tier: 'Tier',
        ecoflowbenefits_tab_plus: 'PLUS MEMBER',
        ecoflowbenefits_tab_normal: 'MEMBER',
        ecoflowbenefits_savings1: 'Earn EcoCredits for Every Purchase',
        ecoflowbenefits_savings2: 'Earn EcoCredits From Successful Friend Sign-ups',
        ecoflowbenefits_savings3: 'Redeem EcoCredits for Discounts',
        ecoflowbenefits_savings4: 'Redeem EcoCredits for Special Gifts',
        ecoflowbenefits_savings5: 'Save 25% OFF at Harvest Hosts',
        ecoflowbenefits_savings5_link: 'Get the Code',
        ecoflowbenefits_savings6: 'Save 10% OFF at Winnebago gears',
        ecoflowbenefits_savings6_link: 'Get the Code',
        ecoflowbenefits_savings7: 'Refer & Earn Up To £500 Cash Reward!',
        ecoflowbenefits_savings7_link: 'Refer Now',
        ecoflowbenefits_savings8: 'Exclusive Birthday Coupon',
        ecoflowbenefits_savings9: 'PLUS Level-up Coupon',
        ecoflowbenefits_savings10: 'PLUS Exclusive Gifts ',
        ecoflowbenefits_savings11: 'Monthly Coupon Pack',
        ecoflowbenefits_savings21: 'Enjoy special Member-only prices (when available)',
        ecoflowbenefits_savings22: 'Use EcoCredits as cash for orders.',
        ecoflowbenefits_savings_tips1: 'Enjoy one free return within one month of purchase.',
        ecoflowbenefits_savings_tips2:
            'Receive a special discount on service charges for out-of-warranty repairs.\nEcoFlow reserves the right to determine the scope of repairs based on the actual situation.',
        ecoflowbenefits_savings_tips3: 'Extend your replacement period to a total of 5 months, allowing you to replace faulty products with new ones.',
        ecoflowbenefits_savings_tips4:
            'If your product is irreparably damaged, you’re eligible for this exclusive benefit. Simply provide proof of shipment for the damaged item along with a screenshot of your PLUS Membership status. Once verified, we’ll send you a replacement right away—no need to wait for us to receive the broken item.\nNote: This service cannot be used together with the extra 4-month replacement benefit.',
        ecoflowbenefits_support1: 'Free Shipping on Most Products',
        ecoflowbenefits_support2: 'Extended Warranty for Selected Products',

        ecoflowbenefits_support3: 'Free Unconditional Return (1 Order)',
        ecoflowbenefits_support4: '12% Discount on Out-of-Warranty Service Charges',
        ecoflowbenefits_support5: 'Extended 4-Month Warranty Replacement',
        ecoflowbenefits_support6: 'Express Replacement Service',
        ecoflowbenefits_experiences1: 'Benefits From Our Partners',
        ecoflowbenefits_experiences2: 'Member-Only Event',
        ecoflowbenefits_experiences3: 'New Product Trial Event (Coming Soon)',
        ecoflowbenefits_experiences4: 'Exclusive Early Bird Access (Coming Soon)',
        ecoflowbenefits_savings_message: 'Please check <line>here</line> to see how to claim vouchers for PLUS MEMBER.',
        ecoflowbenefits_savings_message_pop1: "1. Don't forget to log into your EcoFlow Account on the EcoCredits page.",
        ecoflowbenefits_savings_message_pop2: '2. You will see the pop-up right away if you have a new voucher to claim.',
        ecoflowbenefits_savings_message_pop3:
            "3. Don't worry if you missed it. Go to the 'gift' icon and check the voucher in \"My Rewards\". Don't forget to use it within the valid time.",
        ecoflowbenefits_support_message: 'Please contact <email>support.eu@ecoflow.com</email> for assistance in using your benefits.',
        ecoflowbenefits_experiences_message: 'Stay tuned with us!',
        clock_in: 'Check-in',
        seo_title: 'Join The EcoCredits Loyalty Program',
        seo_desc: 'Join the EcoCredits Loyalty Program at EcoFlow today and start earning rewards now! Get a 500-EcoCredits reward just for signing up.',
        join_title: 'Join the EcoCredits reward program',
        join_subTitle: 'Become a member now and get EcoCredits for cash deductions and exclusive rewards.',
        join_now: 'JOIN NOW',
        login: 'LOG IN',
        login_capital_letters: 'Log in',
        login_capital_letters1: 'Log in',
        welcome_title: 'Hi {username}',
        welcome_sub_title: 'Welcome to the EcoCredits reward programme.',
        welcome_text: 'Earn more EcoCredits and upgrade to PLUS Membership to enjoy more exclusive rewards.',
        welcome_text_plus: 'The upgraded exclusive benefits allow you to save and experience even more with us!',
        summary_text: 'Your EcoCredits Summary',
        membership: 'MEMBER',
        current_tier: 'Current Tier',
        points: 'EcoCredits',
        points_balance: 'EcoCredits Balance',
        points_progress_tips: 'EcoCredits Needed to Reach {plus}: {points} EcoCredits',
        coming_soon: 'Coming Soon',
        expires_in_one_month: 'Expires in One Month',
        redeem_now: 'REDEEM NOW',
        points_activity: 'POINTS ACTIVITY',
        how_it_works: 'How It Works',
        sign_up: 'Sign Up',
        sign_up_desc: 'Create an account for free and start your membership journey.',
        earn_points: 'Earn & Use',
        earn_points_desc: 'Complete tasks for EcoCredits to use as cash or redeem rewards.',
        redeem_points: 'Enjoy More',
        redeem_points_desc: 'Get 6000 EcoCredits and upgrade to a PLUS Membership for more.',
        more_benefits: 'More BENEFITS',
        more_benefits_desc: 'Upgrade to PLUS Membership to save more.',
        more_benefits_question: 'Once you have 6,000 EcoCredits in your account, you can upgrade to PLUS Membership.',
        sign_up_desc_1: 'Create an account and get 800 EcoCredits reward.',
        already_member: 'Already a member?',
        already_member1: 'Already a member?',
        sign_up1: 'You got 500 EcoCredits by signing up.',
        sign_up1_1: 'You got 800 EcoCredits by signing up.',
        sign_up_desc_h: 'Sign up for Membership for 500 EcoCredits.',
        sign_up_desc_h_1: '800 EcoCredits when you join.',
        earn_points_title: 'Ways to Earn EcoCredits',
        sign_up_text: '500 EcoCredits upon joining',
        completed_text: 'You have already achieved this reward.',
        subscribe: 'Subscribe',
        subscribe_capital_letters: 'Subscribe',
        subscribe_text: 'Subscribe to get the latest EcoFlow news.',
        subscribe_hover: 'Earn 500 EcoCredits when you join.',
        subscribe_now: 'Subscribe Now',
        email_address: 'Email Address',
        shop: 'Shop',
        shop_capital_letters: 'Shop',
        earn_point_by_order: 'Earn EcoCredits every time you shop. （£1=1EcoCredits）',
        earn_point_rule_shop: 'Get 1 EcoCredits for every $1 you spend.',
        shop_to_earn_points: 'Shop To Earn EcoCredits',
        warranty: 'Warranty',
        warranty_capital_letters: 'Warranty Registration',
        warranty_desc1: 'Register a newly received product for 1000 EcoCredits.',
        warranty_desc2: 'Register a newly received product for 1000 EcoCredits.',
        profile: 'Complete Profile',
        profile_desc1: 'Completing your profile for up to 1000 EcoCredits.',
        profile_desc2: 'Get up to 1000 EcoCredits for adding your details.',
        complete_profile: 'Complete Profile',
        referral: 'Invited A Friend',
        referral_desc: "Get EcoCredits for each friend's successful registration.",
        referral_btn: 'Join Now',
        birthday: 'BIRTHDAY',
        birthday_desc1: 'Add your birthday for EcoCredits.',
        birthday_desc2: 'Earn {points} EcoCredits when you add your date of birth.',
        add_your_birthday: 'Add Your Birthday',
        birthday_placeholder: 'MM / DD / YY',
        add_my_birthday: 'Add My Birthday',
        ins_title: 'Follow Us On Instagram',
        ins_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        ins_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        follow_button: 'Follow Now',
        follow_button_ins: '',
        follow_button_x: '',
        follow_button_youtube: '',
        follow_button_facebook: '',
        x_title: 'Follow Us On X',
        x_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        x_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        youtube_title: 'Follow Us On YouTube',
        youtube_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        youtube_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        facebook_title: 'Follow Us On Facebook',
        facebook_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        facebook_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        joininfacebook_title: 'Join Us On Facebook',
        joininfacebook_desc1: 'Earn {points} EcoCredits when you join for the first time.',
        joininfacebook_desc2: 'Earn {points} EcoCredits when you join for the first time.',
        redeem_ecocredits_title: 'Redeem EcoCredits Rewards',
        have_points: 'You have <code>{points} EcoCredits</code>',
        view_all: 'View all',
        coupon: 'Discount code',
        discount: 'Discount',
        gift_card: 'Gift Card',
        redeemed_succ: 'Redeemed successfully!',
        copy_desc: 'You have copied the code, please go to the store to use it.',
        store: 'Shop Now',
        coupon_used_desc: 'Use this code at checkout to redeem your {amont} gift card.',
        rules: 'Rules',
        off: 'OFF',
        site_rules: 'For UK store only.',
        days_rules: 'Valid for {days} days from redemption.',
        product_rules: 'For {product} only.',
        days_rules2: 'Valid from {data}.',
        rewards_redeemed: 'My Rewards',
        lucky_rewards_list: 'Rewards List',
        redeedmed_tab_name: 'Redeemed',
        issued_tab_name: 'Issued',
        available: 'Available',
        redeemed: 'Redeemed',
        expired: 'Expired',
        edeemed_rewards_note: 'Your redeemed rewards will appear here.',
        browse_ecocredits_rewards: 'Browse EcoCredits Rewards',
        used: 'Used',
        give_away: 'Give away',
        or_text: 'OR',
        send_your_friend: 'Send your {amont} gift card to a friend.',
        points_activity_a: 'My Activity',
        check_more: 'Check More',
        points_tab_name: 'EcoCredits Activity',
        rewards_tab_name: 'Rewards Activity',
        date: 'Date',
        action: 'Action',
        email: 'Email',
        rewards_title: 'Rewards',
        type_title: 'Type',
        discount_type: 'Discount',
        purchase: 'Purchase',
        profile_a: 'Profile',
        refund: 'Refund',
        registered: 'Registered',
        points_capital_letters: 'EcoCredits',
        status: 'Status',
        pending: 'Pending',
        received: 'Received',
        deducted: 'Deducted',
        view_more: 'View More',
        history_note: 'Your activity will appear here. Don’t see your activity yet? Your activity will update within 24 hours.',
        lucky_flop_start: 'Join Now',
        lucky_flop_congrat: 'Congratulations',
        lucky_flop_get: 'Claim',
        lucky_flop_open: 'OPEN',
        ecoflow_benefits: 'EcoCredits Benefits',
        membership_includes: 'MEMBERSHIP INCLUDES',
        benefits_item1: 'Earn EcoCredits for Every Purchase',
        benefits_item2: 'Redeem EcoCredits for Coupon',
        benefits_item3: 'Free Shipping on Most Products',
        benefits_item4: 'Redeem EcoCredits for Special Gifts',
        benefits_item5: 'Extended Warranty for Selected Products',
        benefits_item6: 'Member-Only Event',
        benefits_item7: 'Earn EcoCredits From Successful Friend Sign-ups',
        benefits_item8: 'Benefits From Our Partners',
        benefits_item9: 'Refer & Earn Up To $500 Cash Reward!',
        benefits_link_btn: 'Refer Now',
        see_t_c: 'See Terms and Conditions',
        manually_added: 'Manually Added',
        manually_deducted: 'Manually Deducted',
        faq_title: 'FAQ',
        earning_points: 'EARNING EcoCredits',
        network_error: 'Network Error',
        confirm_text: 'Are you sure you want to redeem? Cannot be undone.',
        confirm_btn: 'Confirm',
        no_enough_points: 'Redemption failed, your EcoCredits are not enough',
        no_history_note: 'Don’t see your EcoCredits yet? Your activity will update with in 24 hours.',
        no_coupon_note: 'No rewards redeemed yet.',
        minimum_price: 'Minimum purchase amount ({price}).',
        minimum_num: 'Minimum quantity of items({num} pcs).',
        stay_too_long: 'Your session has expired. Please refresh the page and try again.',
        order_rule: 'Only one discount code per order.',
        purchas_rule: 'Purchasing an item for less than the coupon(s), will forfeit the difference.',
        profile_birthday: 'Profile - birthday',
        profile_address: 'Profile - address',
        profile_username: 'Profile - username',
        profile_picture: 'Profile - picture',
        profile_contact: 'Profile - contact info',
        View_1_Explore_Article: 'View 1 Explore article',
        View_2_Explore_Article: 'View 2 Explore articles',
        View_3_Explore_Article: 'View 3 Explore articles',
        Enable_push_notifications: 'Enable push notifications',
        Try_the_energy_calculator_once: 'Try the energy calculator once',
        learn_more: 'Learn more',
        profile_detail:
            'Complete your profile for up to 1000 EcoCredits, including profile pic (200), user name (100), contact info (300), address (200), and birthday (200).',
        exceeded_counts: 'Failed to redeem. You have exceeded the redemption limit.',
        grab_title: 'Grab an EcoCredits Bonus',
        grab_sub_title: 'Exclusive limited-time offers for EcoCredit members. Click to claim now!',
        grab_btn_text: 'Grab My Bonus',
        grab_success_title: 'Congratulations',
        grab_success_text1: 'Bonus claimed successfully!\n Paste the code at checkout to get your discount.',
        grab_success_text2: 'Check your bonuses in <code>My Rewards</code>.',
        'no-grab-content-note': 'More offers coming soon!',
        copy_desc_2: 'You have copied the code.',
        city_validatino_error: 'Invalid city',
        product_text: 'Product',
        shipping_address_text: 'Shipping address',
        saved_address_text: 'Saved addresses',
        use_new_address: 'use a new address',
        spend_now: 'Spend Now',
        stock_left: '{stock} Left',
        no_stock_tip: 'Coming soon... Stay tuned!',
        order_text: 'Order',
        campaign_time_limit_text: 'Valid redemption period: {startTime} - {endTime}.',
        event_action_text: 'Event',
        warranty_minus_action_text: 'Warranty Deleted',
        question_correctly: 'Answer the question correctly',
        follow_instagram_text: 'Follow Instagram',
        follow_x_text: 'Follow X',
        follow_youtube_text: 'Follow YouTube',
        follow_facebook_text: 'Follow Facebook',
        join_facebook_text: 'Join Us On Facebook',
        referral_correctly: 'Referral program',
        confirm_btn_text: 'Close',
        lucky_turntable_title: 'Lucky Spin',
        join_lucky_with_points: 'It costs you {points} EcoCredits to do one round of Lucky Spin.',
        join_lucky_with_points2: 'It costs you {points} EcoCredits to play a round.',
        join_lucky_desc: 'Spin the wheel and get a great prize!',
        remaining_number: '<code></code> spins left',
        remaining_number2: '<code></code> flips left',
        learn_lucky_rule: 'Learn more about the rules',
        prize_coupon_title: 'Congratulations',
        prize_coupon_sub_title: 'The prize was claimed successfully! Use the code at checkout to save.',
        prize_coupon_action: 'Check your prizes in <code>My Rewards</code>.',
        prize_coupon_button: 'Shop Now',
        prize_points_title: 'Congratulations',
        prize_points_desc: 'Check the just-added EcoCredits in <code>My Activity</code>.',
        limit_times_in_day: 'You can spin the wheels <count></count> times in <day></day> days',
        limit_times_in_day2: 'You can flip the cards <count></count> times in <day></day> days',
        limit_times_in_active: 'During the event, you can spin the wheels up to <count></count> times.',
        without_limit_times: 'You can spin the wheels <count></count> times at any time.',
        without_limit_times2: 'You can flip the cards <count></count> times at any time.',
        active_is_unstart: 'This event is coming soon.',
        active_is_ended: 'This event has ended.',
        over_max_count: 'You have exceeded the number of spins available.',
        notice_title: 'Notice',

        points_cash: 'Points Redemption',
        Pending1: 'Pending',
        rollback: 'Returned',
        level_change_log: 'Tier Activity',
        deadline: 'Valid Until',
        history_refresh_member: 'Current Tier: Member',
        history_refresh_plus_member: 'Current Tier: PLUS Member',
        register: 'Register as a Member',
        upgrade: 'Upgrade to PLUS Member',
        demotion: 'Downgrade to Member',
        relegation: 'Maintain as PLUS Member',
        ecocredits_notice1:
            'We have updated the EcoCredits rules on Oct 17, 2024. Please carefully read our updated [<line1>EcoCredits rules</line1>] before using your EcoCredits.',

        plusbenefit: {
            ins_title: 'Follow Us On Instagram',
            ins_desc: 'Earn XX EcoCredits when you follow for the first time.',
        },
        date_of_event: 'Date of Event',
        expiration_date: 'Expiration Date',
        only_plus_member: 'Only PLUS Members can redeem the reward.',
        only_member: 'Only Members can redeem the reward.',

        not_eligible: 'You are not eligible to participate in this event.',
        // 25年会员活动
        first_login_2025: 'First time logging in',
        know_brand_2025: 'Learn more about EcoFlow',
        know_member_2025: 'Learn more about Membership',
        share_story_2025: 'Share my story',
        first_order_2025: 'Complete a purchase',
        repeat_order_2025: 'Make an additional purchase',
    },
    au: {
        shop1: 'Earn every time you order.',
        warranty1: 'You got 1000 EcoCredits by registering a product.',
        profile1: 'You got 1000 EcoCredits by completing your profile.',
        referral1: "Get EcoCredits for each friend's successful registration.",
        ins: 'You got 100 EcoCredits by following us on Instagram.',
        x: 'You got 100 EcoCredits by following us on X.',
        youtube: 'You got 100 EcoCredits by following us on YouTube.',
        facebook: 'You got 100 EcoCredits by following us on Facebook.',
        line: 'You earned 100 EcoCredits by registering as a friend on LINE.',
        joininfacebook: 'You got 100 EcoCredits by joining us on Facebook.',
        subscribe1: 'You got 500 EcoCredits by subscribing.',
        clock_in: 'Check-in',
        seo_title: 'Join The EcoCredits Loyalty Program',
        seo_desc: 'Join the EcoCredits Loyalty Program at EcoFlow today and start earning rewards now! Get a 500-EcoCredits reward just for signing up.',
        join_title: 'Join the EcoCredits reward program',
        join_subTitle: 'Become a member now and get EcoCredits for cash deductions and exclusive rewards.',
        join_now: 'JOIN NOW',
        login: 'LOG IN',
        login_capital_letters: 'Log in',
        login_capital_letters1: 'Log in',
        welcome_title: 'Hi {username}',
        welcome_sub_title: 'Welcome to the EcoCredits reward program.',
        welcome_text: 'Earn more EcoCredits and upgrade to PLUS Membership to enjoy more exclusive rewards.',
        welcome_text_plus: 'The upgraded exclusive benefits allow you to save and experience even more with us!',
        summary_text: 'Your EcoCredits Summary',
        membership: 'MEMBER',
        current_tier: 'Current Tier',
        points: 'EcoCredits',
        points_balance: 'EcoCredits Balance',
        points_progress_tips: 'EcoCredits Needed to Reach {plus}: {points} EcoCredits',
        coming_soon: 'Coming Soon',
        expires_in_one_month: 'Expires in One Month',
        redeem_now: 'REDEEM NOW',
        points_activity: 'POINTS ACTIVITY',
        how_it_works: 'How It Works',
        sign_up: 'Sign Up',
        sign_up_desc: 'Create an account for free and start your membership journey.',
        earn_points: 'Earn & Use',
        earn_points_desc: 'Complete tasks for EcoCredits to use as cash or redeem rewards.',
        redeem_points: 'Enjoy More',
        redeem_points_desc: 'Get 6000 EcoCredits and upgrade to a PLUS Membership for more.',
        more_benefits: 'MORE BENEFITS',
        more_benefits_desc: 'Upgrade to PLUS Member to save more. ',
        more_benefits_question: 'Once you have 6,000 EcoCredits in your account, you can upgrade to PLUS Membership.',
        sign_up_desc_1: 'Create an account and get 800 EcoCredits reward.',
        already_member: 'Already a member?',
        already_member1: 'Already a member?',
        sign_up1: 'You got 500 EcoCredits by signing up.',
        sign_up1_1: 'You got 800 EcoCredits by signing up.',
        sign_up_desc_h: 'Sign up for Membership for 500 EcoCredits.',
        sign_up_desc_h_1: '800 EcoCredits when you join.',
        earn_points_title: 'Ways to Earn EcoCredits',
        sign_up_text: '500 EcoCredits upon joining',
        completed_text: 'You have already achieved this reward.',
        subscribe: 'Subscribe',
        subscribe_capital_letters: 'Subscribe',
        subscribe_text: 'Subscribe to get the latest EcoFlow news.',
        subscribe_hover: 'Earn 500 EcoCredits when you join.',
        subscribe_now: 'Subscribe Now',
        email_address: 'Email Address',
        shop: 'Shop',
        shop_capital_letters: 'Shop',
        earn_point_by_order: 'Earn EcoCredits every time you shop. （$1=1EcoCredits）',
        earn_point_rule_shop: 'Get 1 EcoCredits for every $1 you spend.',
        shop_to_earn_points: 'Shop To Earn EcoCredits',
        warranty: 'Warranty',
        warranty_capital_letters: 'Warranty Registration',
        warranty_desc1: 'Register a newly received product for 1000 EcoCredits.',
        warranty_desc2: 'Register a newly received product for 1000 EcoCredits.',
        profile: 'Complete Profile',
        profile_desc1: 'Completing your profile for up to 1000 EcoCredits.',
        profile_desc2: 'Get up to 1000 EcoCredits for adding your details.',
        complete_profile: 'Complete Profile',
        referral: 'Invited A Friend',
        referral_desc: "Get EcoCredits for each friend's successful registration.",
        referral_btn: 'Join Now',
        birthday: 'BIRTHDAY',
        birthday_desc1: 'Add your birthday for EcoCredits.',
        birthday_desc2: 'Earn {points} EcoCredits when you add your date of birth.',
        add_your_birthday: 'Add Your Birthday',
        birthday_placeholder: 'MM / DD / YY',
        add_my_birthday: 'Add My Birthday',
        ins_title: 'Follow Us On Instagram',
        ins_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        ins_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        follow_button: 'Follow Now',
        follow_button_ins: '',
        follow_button_x: '',
        follow_button_youtube: '',
        follow_button_facebook: '',
        facebook_title: 'Follow Us On Facebook',
        facebook_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        facebook_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        joininfacebook_title: 'Join Us On Facebook',
        joininfacebook_desc1: 'Earn {points} EcoCredits when you join for the first time.',
        joininfacebook_desc2: 'Earn {points} EcoCredits when you join for the first time.',
        redeem_ecocredits_title: 'Redeem EcoCredits Rewards',
        have_points: 'You have <code>{points} EcoCredits</code>',
        view_all: 'View all',
        coupon: 'Discount code',
        discount: 'Discount',
        gift_card: 'Gift Card',
        redeemed_succ: 'Redeemed successfully!',
        copy_desc: 'You have copied the code, please go to the store to use it.',
        store: 'Shop Now',
        coupon_used_desc: 'Use this code at checkout to redeem your {amont} gift card.',
        rules: 'Rules',
        off: 'OFF',
        site_rules: 'For AU store only.',
        days_rules: 'Valid for {days} days from redemption.',
        product_rules: 'For {product} only.',
        days_rules2: 'Valid from {data}.',
        rewards_redeemed: 'My Rewards',
        redeedmed_tab_name: 'Redeemed',
        issued_tab_name: 'Issued',
        available: 'Available',
        redeemed: 'Redeemed',
        expired: 'Expired',
        edeemed_rewards_note: 'Your redeemed rewards will appear here.',
        browse_ecocredits_rewards: 'Browse EcoCredits Rewards',
        used: 'Used',
        give_away: 'Give away',
        or_text: 'OR',
        send_your_friend: 'Send your {amont} gift card to a friend.',
        points_activity_a: 'My Activity',
        check_more: 'Check More',
        points_tab_name: 'EcoCredits Activity',
        rewards_tab_name: 'Rewards Activity',
        date: 'Date',
        action: 'Action',
        rewards_title: 'Rewards',
        type_title: 'Type',
        discount_type: 'Discount',
        purchase: 'Purchase',
        profile_a: 'Profile',
        refund: 'Refund',
        registered: 'Registered',
        points_capital_letters: 'EcoCredits',
        status: 'Status',
        pending: 'Pending',
        received: 'Received',
        deducted: 'Deducted',
        view_more: 'View More',
        history_note: 'Your EcoCredits activity will appear here. Don’t see your EcoCredits yet? Your activity will update within 24 hours.',
        lucky_flop_start: 'Join Now',
        lucky_flop_congrat: 'Congratulations',
        lucky_flop_get: 'Claim',
        lucky_flop_open: 'OPEN',
        ecoflow_benefits: 'EcoCredits Benefits',
        membership_includes: 'MEMBERSHIP INCLUDES',
        benefits_item1: 'Earn EcoCredits for Every Purchase',
        benefits_item2: 'Redeem EcoCredits for Coupon',
        benefits_item3: 'Free Shipping on Most Products',
        benefits_item4: 'Redeem EcoCredits for Special Gifts',
        benefits_item5: 'Extended Warranty for Selected Products',
        benefits_item6: 'Member-Only Event',
        benefits_item7: 'Earn EcoCredits From Successful Friend Sign-ups',
        benefits_item8: 'Benefits From Our Partners',
        benefits_item9: 'Refer & Earn Up To $500 Cash Reward!',
        benefits_link_btn: 'Refer Now',
        see_t_c: 'See Terms and Conditions',
        manually_added: 'Manually Added',
        manually_deducted: 'Manually Deducted',
        faq_title: 'Frequently Asked Questions',
        earning_points: 'EARNING EcoCredits',
        network_error: 'Network Error',
        confirm_text: 'Are you sure you want to redeem? Cannot be undone.',
        confirm_btn: 'Confirm',
        no_enough_points: 'Redemption failed, your EcoCredits are not enough',
        no_history_note: 'Don’t see your EcoCredits yet? Your activity will update with in 24 hours.',
        no_coupon_note: 'No rewards redeemed yet.',
        minimum_price: 'Minimum purchase amount ({price}).',
        minimum_num: 'Minimum quantity of items({num} pcs).',
        stay_too_long: 'Your session has expired. Please refresh the page and try again.',
        order_rule: 'Only one discount code per order.',
        purchas_rule: 'Purchasing an item for less than the coupon(s), will forfeit the difference.',
        profile_birthday: 'Profile - birthday',
        profile_address: 'Profile - address',
        profile_username: 'Profile - username',
        profile_picture: 'Profile - picture',
        profile_contact: 'Profile - contact info',
        View_1_Explore_Article: 'View 1 Explore article',
        View_2_Explore_Article: 'View 2 Explore articles',
        View_3_Explore_Article: 'View 3 Explore articles',
        Enable_push_notifications: 'Enable push notifications',
        Try_the_energy_calculator_once: 'Try the energy calculator once',
        learn_more: 'Learn more',
        profile_detail:
            'Complete your profile for up to 1000 EcoCredits, including profile pic (200), user name (100), contact info (300), address (200), and birthday (200).',
        exceeded_counts: 'Failed to redeem. You have exceeded the redemption limit.',
        grab_title: 'Grab an EcoCredits Bonus',
        grab_sub_title: 'Exclusive limited-time offers for EcoCredit members. Click to claim now!',
        grab_btn_text: 'Grab My Bonus',
        grab_success_title: 'Congratulations',
        grab_success_text1: 'Bonus claimed successfully!\n Paste the code at checkout to get your discount.',
        grab_success_text2: 'Check your bonuses in <code>My Rewards</code>.',
        'no-grab-content-note': 'More offers coming soon!',
        copy_desc_2: 'You have copied the code.',
        city_validatino_error: 'Invalid city',
        product_text: 'Product',
        shipping_address_text: 'Shipping address',
        saved_address_text: 'Saved addresses',
        use_new_address: 'use a new address',
        spend_now: 'Spend Now',
        stock_left: '{stock} Left',
        no_stock_tip: 'Coming soon... Stay tuned!',
        order_text: 'Order',
        campaign_time_limit_text: 'Valid redemption period: {startTime} - {endTime}.',
        event_action_text: 'Event',
        warranty_minus_action_text: 'Warranty Deleted',
        question_correctly: 'Answer the question correctly',
        follow_instagram_text: 'Follow Instagram',
        follow_x_text: 'Follow X',
        follow_youtube_text: 'Follow YouTube',
        follow_facebook_text: 'Follow Facebook',
        join_facebook_text: 'Join Us On Facebook',
        referral_correctly: 'Referral program',
        confirm_btn_text: 'Close',
        lucky_turntable_title: 'Lucky Spin',
        join_lucky_with_points: 'It costs you {points} EcoCredits to do one round of Lucky Spin.',
        join_lucky_with_points2: 'It costs you {points} EcoCredits to play a round.',
        join_lucky_desc: 'Spin the wheel and get a great prize!',
        remaining_number: '<code></code> spins left',
        remaining_number2: '<code></code> flips left',
        learn_lucky_rule: 'Learn more about the rules',
        prize_coupon_title: 'Congratulations',
        prize_coupon_sub_title: 'The prize was claimed successfully! Use the code at checkout to save.',
        prize_coupon_action: 'Check your prizes in <code>My Rewards</code>.',
        prize_coupon_button: 'Shop Now',
        prize_points_title: 'Congratulations',
        prize_points_desc: 'Check the just-added EcoCredits in <code>My Activity</code>.',
        limit_times_in_day: 'You can spin the wheels <count></count> times in <day></day> days',
        limit_times_in_day2: 'You can flip the cards <count></count> times in <day></day> days',
        limit_times_in_active: 'During the event, you can spin the wheels up to <count></count> times.',
        limit_times_in_active2: 'During the event, you can flip the cards up to <count></count> times.',
        without_limit_times: 'You can spin the wheels <count></count> times at any time.',
        without_limit_times2: 'You can flip the cards <count></count> times at any time.',
        active_is_unstart: 'This event is coming soon.',
        active_is_ended: 'This event has ended.',
        over_max_count: 'You have exceeded the number of spins available.',
        notice_title: 'Notice',
        points_cash: 'Points Redemption',
        Pending1: 'Pending',
        rollback: 'Returned',
        level_change_log: 'Tier Activity',
        deadline: 'Valid Until',
        history_refresh_member: 'Current Tier: Member',
        history_refresh_plus_member: 'Current Tier: PLUS Member',
        register: 'Register as a Member',
        upgrade: 'Upgrade to PLUS Member',
        demotion: 'Downgrade to Member',
        relegation: 'Maintain as PLUS Member',
        ecocredits_notice1:
            'We have updated the EcoCredits rules on 17 Oct 2024. Please carefully read our updated [<line1>EcoCredits rules</line1>] before using your EcoCredits.',
        ecoflowbenefits_title: 'EcoCredits Exclusive Benefits',
        ecoflowbenefits_savings: 'More Savings',
        ecoflowbenefits_support: 'More Support',
        ecoflowbenefits_experiences: 'More Experiences',
        ecoflowbenefits_tab_benefits: 'Benefits',
        ecoflowbenefits_tab_tier: 'Tier',
        ecoflowbenefits_tab_plus: 'PLUS MEMBER',
        ecoflowbenefits_tab_normal: 'MEMBER',
        ecoflowbenefits_savings1: 'Earn EcoCredits for Every Purchase',
        ecoflowbenefits_savings2: 'Earn EcoCredits From Successful Friend Sign-ups',
        ecoflowbenefits_savings3: 'Redeem EcoCredits for Discounts',
        ecoflowbenefits_savings4: 'Redeem EcoCredits for Special Gifts',
        ecoflowbenefits_savings5: 'Save 25% OFF at Harvest Hosts',
        ecoflowbenefits_savings5_link: 'Get the Code',
        ecoflowbenefits_savings6: 'Save 10% OFF at Winnebago gears',
        ecoflowbenefits_savings6_link: 'Get the Code',
        ecoflowbenefits_savings7: 'Refer & Earn Up To $500 Cash Reward!',
        ecoflowbenefits_savings7_link: 'Refer Now',
        ecoflowbenefits_savings8: 'Exclusive Birthday Coupon',
        ecoflowbenefits_savings9: 'PLUS Level-up Coupon',
        ecoflowbenefits_savings10: 'PLUS Exclusive Gifts',
        ecoflowbenefits_savings11: 'Monthly Coupon Pack',
        ecoflowbenefits_savings21: 'Enjoy special Member-only prices (when available)',
        ecoflowbenefits_savings22: 'Use EcoCredits as cash for orders.',
        ecoflowbenefits_savings_tips1: 'Enjoy one free return within one month of purchase.',
        ecoflowbenefits_savings_tips2:
            'Receive a special discount on service charges for out-of-warranty repairs.\nEcoFlow reserves the right to determine the scope of repairs based on the actual situation.',
        ecoflowbenefits_savings_tips3: 'Extend your replacement period to a total of 5 months, allowing you to replace faulty products with new ones.',
        ecoflowbenefits_savings_tips4:
            'If your product is irreparably damaged, you’re eligible for this exclusive benefit. Simply provide proof of shipment for the damaged item along with a screenshot of your PLUS Membership status. Once verified, we’ll send you a replacement right away—no need to wait for us to receive the broken item. \nNote: This service cannot be used together with the extra 4-month replacement benefit.',
        ecoflowbenefits_support1: 'Free Shipping on Most Products',
        ecoflowbenefits_support2: 'Extended Warranty for Selected Products',
        ecoflowbenefits_support3: 'Free Unconditional Return (1 Order)',
        ecoflowbenefits_support4: '12% Discount on Out-of-Warranty Service Charges',
        ecoflowbenefits_support5: 'Extended 4-Month Warranty Replacement',
        ecoflowbenefits_support6: 'Express Replacement Service ',
        ecoflowbenefits_experiences1: 'Benefits From Our Partners',
        ecoflowbenefits_experiences2: 'Member-Only Event',
        ecoflowbenefits_experiences3: 'New Product Trial Event (Coming Soon)',
        ecoflowbenefits_experiences4: 'Exclusive Early Bird Access (Coming Soon)',
        ecoflowbenefits_savings_message: 'Please check <line>here</line> to see how to claim vouchers for PLUS MEMBER.',
        ecoflowbenefits_savings_message_pop1: "1. Don't forget to log into your EcoFlow Account on the EcoCredits page.",
        ecoflowbenefits_savings_message_pop2: '2. You will see the pop-up right away if you have a new voucher to claim.',
        ecoflowbenefits_savings_message_pop3:
            "3. Don't worry if you missed it. Go to the 'gift' icon and check the voucher in \"My Rewards\". Don't forget to use it within the valid time.",
        ecoflowbenefits_support_message: 'Please contact <email>support.au@ecoflow.com</email> for assistance in using your benefits.',
        ecoflowbenefits_experiences_message: 'Stay tuned with us!',
        date_of_event: 'Date of Event',
        expiration_date: 'Expiration Date',
        only_plus_member: 'Only PLUS Members can redeem the reward.',
        only_member: 'Only Members can redeem the reward.',

        not_eligible: 'You are not eligible to participate in this event.',
        // 25年会员活动
        first_login_2025: 'First time logging in',
        know_brand_2025: 'Learn more about EcoFlow',
        know_member_2025: 'Learn more about Membership',
        share_story_2025: 'Share my story',
        first_order_2025: 'Complete a purchase',
        repeat_order_2025: 'Make an additional purchase',
    },
    ca: {
        shop1: 'Earn every time you order.',
        warranty1: 'You got 1000 EcoCredits by registering a product.',
        profile1: 'You got 1000 EcoCredits by completing your profile.',
        referral1: "Get EcoCredits for each friend's successful registration.",
        ins: 'You got 100 EcoCredits by following us on Instagram.',
        x: 'You got 100 EcoCredits by following us on X.',
        youtube: 'You got 100 EcoCredits by following us on YouTube.',
        facebook: 'You got 100 EcoCredits by following us on Facebook.',
        line: 'You earned 100 EcoCredits by registering as a friend on LINE.',
        joininfacebook: 'You got 100 EcoCredits by joining us on Facebook.',
        subscribe1: 'You got 500 EcoCredits by subscribing.',
        clock_in: 'Check-in',
        seo_title: 'Join The EcoCredits Loyalty Program',
        seo_desc: 'Join the EcoCredits Loyalty Program at EcoFlow today and start earning rewards now! Get a 500-EcoCredits reward just for signing up.',
        join_title: 'Join the EcoCredits reward program',
        join_subTitle: 'Become a member now and get EcoCredits for cash deductions and exclusive rewards.',
        join_now: 'JOIN NOW',
        login: 'LOG IN',
        login_capital_letters: 'Log in',
        login_capital_letters1: 'Log in',
        welcome_title: 'Hi {username}',
        welcome_sub_title: 'Welcome to the EcoCredits reward program.',
        welcome_text: 'Earn more EcoCredits and upgrade to PLUS Membership to enjoy more exclusive rewards.',
        welcome_text_plus: 'The upgraded exclusive benefits allow you to save and experience even more with us!',
        summary_text: 'Your EcoCredits Summary',
        membership: 'MEMBER',
        current_tier: 'Current Tier',
        points: 'EcoCredits',
        points_balance: 'EcoCredits Balance',
        points_progress_tips: 'EcoCredits Needed to Reach {plus}: {points} EcoCredits',
        coming_soon: 'Coming Soon',
        expires_in_one_month: 'Expires in One Month',
        redeem_now: 'REDEEM NOW',
        points_activity: 'POINTS ACTIVITY',
        how_it_works: 'How It Works',
        sign_up: 'Sign Up',
        sign_up_desc: 'Create an account for free and start your membership journey.',
        earn_points: 'Earn & Use',
        earn_points_desc: 'Complete tasks for EcoCredits to use as cash or redeem rewards.',
        redeem_points: 'Enjoy More',
        redeem_points_desc: 'Get 6000 EcoCredits and upgrade to a PLUS Membership for more.',
        more_benefits: 'MORE BENEFITS',
        more_benefits_desc: 'Upgrade to PLUS Member to save more.',
        more_benefits_question: 'Once you have 6,000 EcoCredits in your account, you can upgrade to PLUS Membership.',
        sign_up_desc_1: 'Create an account and get 800 EcoCredits reward.',
        already_member: 'Already a member?',
        already_member1: 'Already a member?',
        sign_up1: 'You got 500 EcoCredits by signing up.',
        sign_up1_1: 'You got 800 EcoCredits by signing up.',
        sign_up_desc_h: 'Sign up for Membership for 500 EcoCredits.',
        sign_up_desc_h_1: '800 EcoCredits when you join.',
        earn_points_title: 'Ways to Earn EcoCredits',
        sign_up_text: '500 EcoCredits upon joining',
        completed_text: 'You have already achieved this reward.',
        subscribe: 'Subscribe',
        subscribe_capital_letters: 'Subscribe',
        subscribe_text: 'Subscribe to get the latest EcoFlow news.',
        subscribe_hover: 'Earn 500 EcoCredits when you join.',
        subscribe_now: 'Subscribe Now',
        email_address: 'Email Address',
        shop: 'Shop',
        shop_capital_letters: 'Shop',
        earn_point_by_order: 'Earn EcoCredits every time you shop. （$1=1EcoCredits）',
        earn_point_rule_shop: 'Get 1 EcoCredits for every CAD1 you spend.',
        shop_to_earn_points: 'Shop To Earn EcoCredits',
        warranty: 'Warranty',
        warranty_capital_letters: 'Warranty Registration',
        warranty_desc1: 'Register a newly received product for 1000 EcoCredits.',
        warranty_desc2: 'Register a newly received product for 1000 EcoCredits.',
        profile: 'Complete Profile',
        profile_desc1: 'Completing your profile for up to 1000 EcoCredits.',
        profile_desc2: 'Get up to 1000 EcoCredits for adding your details.',
        complete_profile: 'Complete Profile',
        referral: 'Invited A Friend',
        referral_desc: "Get EcoCredits for each friend's successful registration.",
        referral_btn: 'Join Now',
        birthday: 'BIRTHDAY',
        birthday_desc1: 'Add your birthday for EcoCredits.',
        birthday_desc2: 'Earn {points} EcoCredits when you add your date of birth.',
        add_your_birthday: 'Add Your Birthday',
        birthday_placeholder: 'MM / DD / YY',
        add_my_birthday: 'Add My Birthday',
        ins_title: 'Follow Us On Instagram',
        ins_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        ins_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        follow_button: 'Follow Now',
        follow_button_ins: '',
        follow_button_x: '',
        follow_button_youtube: '',
        follow_button_facebook: '',
        x_title: 'Follow Us On X',
        x_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        x_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        youtube_title: 'Follow Us On YouTube',
        youtube_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        youtube_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        facebook_title: 'Follow Us On Facebook',
        facebook_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        facebook_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        joininfacebook_title: 'Join Us On Facebook',
        joininfacebook_desc1: 'Earn {points} EcoCredits when you join for the first time.',
        joininfacebook_desc2: 'Earn {points} EcoCredits when you join for the first time.',
        redeem_ecocredits_title: 'Redeem EcoCredits Rewards',
        have_points: 'You have <code>{points} EcoCredits</code>',
        view_all: 'View all',
        coupon: 'Discount code',
        discount: 'Discount',
        gift_card: 'Gift Card',
        redeemed_succ: 'Redeemed successfully!',
        copy_desc: 'You have copied the code, please go to the store to use it.',
        store: 'Shop Now',
        coupon_used_desc: 'Use this code at checkout to redeem your {amont} gift card.',
        rules: 'Rules',
        off: 'OFF',
        site_rules: 'For CA store only.',
        days_rules: 'Valid for {days} days from redemption.',
        product_rules: 'For {product} only.',
        days_rules2: 'Valid from {data}.',
        rewards_redeemed: 'My Rewards',
        lucky_rewards_list: 'Rewards List',
        redeedmed_tab_name: 'Redeemed',
        issued_tab_name: 'Issued',
        available: 'Available',
        redeemed: 'Redeemed',
        expired: 'Expired',
        edeemed_rewards_note: 'Your redeemed rewards will appear here.',
        browse_ecocredits_rewards: 'Browse EcoCredits Rewards',
        used: 'Used',
        give_away: 'Give away',
        or_text: 'OR',
        send_your_friend: 'Send your {amont} gift card to a friend.',
        points_activity_a: 'My Activity',
        check_more: 'Check More',
        points_tab_name: 'EcoCredits Activity',
        rewards_tab_name: 'Rewards Activity',
        date: 'Date',
        action: 'Action',
        email: 'Email',
        rewards_title: 'Rewards',
        type_title: 'Type',
        discount_type: 'Discount',
        purchase: 'Purchase',
        profile_a: 'Profile',
        refund: 'Refund',
        registered: 'Registered',
        points_capital_letters: 'EcoCredits',
        status: 'Status',
        pending: 'Pending',
        received: 'Received',
        deducted: 'Deducted',
        view_more: 'View More',
        history_note: 'Your activity will appear here. Don’t see your activity yet? Your activity will update within 24 hours.',
        lucky_flop_start: 'Join Now',
        lucky_flop_congrat: 'Congratulations',
        lucky_flop_get: 'Claim',
        lucky_flop_open: 'OPEN',
        ecoflow_benefits: 'EcoCredits Benefits',
        membership_includes: 'MEMBERSHIP INCLUDES',
        benefits_item1: 'Earn EcoCredits for Every Purchase',
        benefits_item2: 'Redeem EcoCredits for Coupon',
        benefits_item3: 'Free Shipping on Most Products',
        benefits_item4: 'Redeem EcoCredits for Special Gifts',
        benefits_item5: 'Extended Warranty for Selected Products',
        benefits_item6: 'Member-Only Event',
        benefits_item7: 'Earn EcoCredits From Successful Friend Sign-ups',
        benefits_item8: 'Benefits From Our Partners',
        benefits_item9: 'Refer & Earn Up To $500 Cash Reward!',
        benefits_link_btn: 'Refer Now',
        see_t_c: 'See Terms and Conditions',
        manually_added: 'Manually Added',
        manually_deducted: 'Manually Deducted',
        faq_title: 'FAQ',
        earning_points: 'EARNING EcoCredits',
        network_error: 'Network Error',
        confirm_text: 'Are you sure you want to redeem? Cannot be undone.',
        confirm_btn: 'Confirm',
        no_enough_points: 'Redemption failed, your EcoCredits are not enough',
        no_history_note: 'Don’t see your EcoCredits yet? Your activity will update with in 24 hours.',
        no_coupon_note: 'No rewards redeemed yet.',
        minimum_price: 'Minimum purchase amount ({price}).',
        minimum_num: 'Minimum quantity of items({num} pcs).',
        stay_too_long: 'Your session has expired. Please refresh the page and try again.',
        order_rule: 'Only one discount code per order.',
        purchas_rule: 'Purchasing an item for less than the coupon(s), will forfeit the difference.',
        profile_birthday: 'Profile - birthday',
        profile_address: 'Profile - address',
        profile_username: 'Profile - username',
        profile_picture: 'Profile - picture',
        profile_contact: 'Profile - contact info',
        View_1_Explore_Article: 'View 1 Explore article',
        View_2_Explore_Article: 'View 2 Explore articles',
        View_3_Explore_Article: 'View 3 Explore articles',
        Enable_push_notifications: 'Enable push notifications',
        Try_the_energy_calculator_once: 'Try the energy calculator once',
        learn_more: 'Learn more',
        profile_detail:
            'Complete your profile for up to 1000 EcoCredits, including profile pic (200), user name (100), contact info (300), address (200), and birthday (200).',
        exceeded_counts: 'Failed to redeem. You have exceeded the redemption limit.',
        grab_title: 'Grab an EcoCredits Bonus',
        grab_sub_title: 'Exclusive limited-time offers for EcoCredit members. Click to claim now!',
        grab_btn_text: 'Grab My Bonus',
        grab_success_title: 'Congratulations',
        grab_success_text1: 'Bonus claimed successfully!\n Paste the code at checkout to get your discount.',
        grab_success_text2: 'Check your bonuses in <code>My Rewards</code>.',
        'no-grab-content-note': 'More offers coming soon!',
        copy_desc_2: 'You have copied the code.',
        city_validatino_error: 'Invalid city',
        product_text: 'Product',
        shipping_address_text: 'Shipping address',
        saved_address_text: 'Saved addresses',
        use_new_address: 'use a new address',
        spend_now: 'Spend Now',
        stock_left: '{stock} Left',
        no_stock_tip: 'Coming soon... Stay tuned!',
        order_text: 'Order',
        campaign_time_limit_text: 'Valid redemption period: {startTime} - {endTime}.',
        event_action_text: 'Event',
        warranty_minus_action_text: 'Warranty Deleted',
        question_correctly: 'Answer the question correctly',
        follow_instagram_text: 'Follow Instagram',
        follow_x_text: 'Follow X',
        follow_youtube_text: 'Follow YouTube',
        follow_facebook_text: 'Follow Facebook',
        join_facebook_text: 'Join Us On Facebook',
        referral_correctly: 'Referral program',
        confirm_btn_text: 'Close',
        lucky_turntable_title: 'Lucky Spin',
        join_lucky_with_points: 'It costs you {points} EcoCredits to do one round of Lucky Spin.',
        join_lucky_with_points2: 'It costs you {points} EcoCredits to play a round.',
        join_lucky_desc: 'Spin the wheel and get a great prize!',
        remaining_number: '<code></code> spins left',
        remaining_number2: '<code></code> flips left',
        learn_lucky_rule: 'Learn more about the rules',
        prize_coupon_title: 'Congratulations',
        prize_coupon_sub_title: 'The prize was claimed successfully! Use the code at checkout to save.',
        prize_coupon_action: 'Check your prizes in <code>My Rewards</code>.',
        prize_coupon_button: 'Shop Now',
        prize_points_title: 'Congratulations',
        prize_points_desc: 'Check the just-added EcoCredits in <code>My Activity</code>.',
        limit_times_in_day: 'You can spin the wheels <count></count> times in <day></day> days',
        limit_times_in_day2: 'You can flip the cards <count></count> times in <day></day> days',
        limit_times_in_active: 'During the event, you can spin the wheels up to <count></count> times.',
        limit_times_in_active2: 'During the event, you can flip the cards up to <count></count> times.',
        without_limit_times: 'You can spin the wheels <count></count> times at any time.',
        without_limit_times2: 'You can flip the cards <count></count> times at any time.',
        active_is_unstart: 'This event is coming soon.',
        active_is_ended: 'This event has ended.',
        over_max_count: 'You have exceeded the number of spins available.',
        notice_title: 'Notice',
        points_cash: 'Points Redemption',
        Pending1: 'Pending',
        rollback: 'Returned',
        level_change_log: 'Tier Activity',
        deadline: 'Valid Until',
        history_refresh_member: 'Current Tier: Member',
        history_refresh_plus_member: 'Current Tier: PLUS Member',
        register: 'Register as a Member',
        upgrade: 'Upgrade to PLUS Member',
        demotion: 'Downgrade to Member',
        relegation: 'Maintain as PLUS Member',
        ecocredits_notice1:
            'We have updated the EcoCredits rules on Oct 17, 2024. Please carefully read our updated [<line1>EcoCredits rules</line1>] before using your EcoCredits.',
        ecoflowbenefits_title: 'EcoCredits Exclusive Benefits',
        ecoflowbenefits_savings: 'More Savings',
        ecoflowbenefits_support: 'More Support',
        ecoflowbenefits_experiences: 'More Experiences',
        ecoflowbenefits_tab_benefits: 'Benefits',
        ecoflowbenefits_tab_tier: 'Tier',
        ecoflowbenefits_tab_plus: 'PLUS MEMBER',
        ecoflowbenefits_tab_normal: 'MEMBER',
        ecoflowbenefits_savings1: 'Earn EcoCredits for Every Purchase',
        ecoflowbenefits_savings2: 'Earn EcoCredits From Successful Friend Sign-ups',
        ecoflowbenefits_savings3: 'Redeem EcoCredits for Discounts',
        ecoflowbenefits_savings4: 'Redeem EcoCredits for Special Gifts',
        ecoflowbenefits_savings5: 'Save 25% OFF at Harvest Hosts',
        ecoflowbenefits_savings5_link: 'Get the Code',
        ecoflowbenefits_savings6: 'Save 10% OFF at Winnebago gears',
        ecoflowbenefits_savings6_link: 'Get the Code',
        ecoflowbenefits_savings7: 'Refer & Earn Up To $500 Cash Reward!',
        ecoflowbenefits_savings7_link: 'Refer Now',
        ecoflowbenefits_savings8: 'Exclusive Birthday Coupon',
        ecoflowbenefits_savings9: 'PLUS Level-up Coupon',
        ecoflowbenefits_savings10: 'PLUS Exclusive Gifts ',
        ecoflowbenefits_savings11: 'Monthly Coupon Pack',
        ecoflowbenefits_savings21: 'Enjoy special Member-only prices (when available)',
        ecoflowbenefits_savings22: 'Use EcoCredits as cash for orders.',
        ecoflowbenefits_savings_tips1: 'Enjoy one free return within one month of purchase.',
        ecoflowbenefits_savings_tips2:
            'Receive a special discount on service charges for out-of-warranty repairs.\nEcoFlow reserves the right to determine the scope of repairs based on the actual situation.',
        ecoflowbenefits_savings_tips3:
            'If your product is irreparably damaged, you’re eligible for this exclusive benefit. Simply provide proof of shipment for the damaged item along with a screenshot of your PLUS Membership status. Once verified, we’ll send you a replacement right away—no need to wait for us to receive the broken item.',
        ecoflowbenefits_support1: 'Free Shipping on Most Products',
        ecoflowbenefits_support2: 'Extended Warranty for Selected Products',

        ecoflowbenefits_support3: 'Free Unconditional Return (1 Order)',
        ecoflowbenefits_support4: '12% Discount on Out-of-Warranty Service Charges',
        ecoflowbenefits_support5: 'Express Replacement Service',
        ecoflowbenefits_support6: 'Tier',

        ecoflowbenefits_experiences1: 'Benefits From Our Partners',
        ecoflowbenefits_experiences2: 'Member-Only Event',
        ecoflowbenefits_experiences3: 'New Product Trial Event (Coming Soon)',
        ecoflowbenefits_experiences4: 'Exclusive Early Bird Access (Coming Soon)',
        ecoflowbenefits_savings_message: 'Please check <line>here</line> to see how to claim vouchers for PLUS MEMBER.',
        ecoflowbenefits_savings_message_pop1: "1. Don't forget to log into your EcoFlow Account on the EcoCredits page.",
        ecoflowbenefits_savings_message_pop2: '2. You will see the pop-up right away if you have a new voucher to claim.',
        ecoflowbenefits_savings_message_pop3:
            "3. Don't worry if you missed it. Go to the 'gift' icon and check the voucher in \"My Rewards\". Don't forget to use it within the valid time.",
        ecoflowbenefits_support_message: 'Please contact <email>support@ecoflow.com</email> for assistance in using your benefits.',
        ecoflowbenefits_experiences_message: 'Stay tuned with us!',
        date_of_event: 'Date of Event',
        expiration_date: 'Expiration Date',

        only_plus_member: 'Only PLUS Members can redeem the reward.',
        only_member: 'Only Members can redeem the reward.',
        not_eligible: 'You are not eligible to participate in this event.',
        // 25年会员活动
        first_login_2025: 'First time logging in',
        know_brand_2025: 'Learn more about EcoFlow',
        know_member_2025: 'Learn more about Membership',
        share_story_2025: 'Share my story',
        first_order_2025: 'Complete a purchase',
        repeat_order_2025: 'Make an additional purchase',
    },
    de: {
        shop1: 'Für jeden Euro Ihres Bestellwerts erhalten Sie 1 EcoCredit.',
        warranty1: 'Sie haben 1 000 EcoCredits für die Registrierung eines Produkts erhalten.',
        profile1: 'Sie haben 1 000 EcoCredits für die Vervollständigung Ihres Profils erhalten.',
        referral1: 'Für jede erfolgreiche Registrierung eines Freundes EcoCredits erhalten.',
        ins: 'Sie haben 100 EcoCredits erhalten, weil Sie uns auf Instagram folgen',
        x: 'Sie haben 100 EcoCredits erhalten, weil Sie uns auf X folgen.',
        youtube: 'Sie haben 100 EcoCredits erhalten, weil Sie uns auf YouTube folgen.',
        facebook: 'Sie haben 100 EcoCredits erhalten, weil Sie uns auf Facebook folgen.',
        line: 'Sie haben 100 EcoCredits durch die Registrierung als Freund auf LINE gesammelt.',
        joininfacebook: 'Sie haben 100 EcoCredits erhalten, weil Sie uns auf Facebook beigetreten sind.',
        subscribe1: 'Sie haben 500 EcoCredits für Ihr Abonnement erhalten.',
        clock_in: 'Check-in',
        seo_title: 'EcoCredits-Prämienprogramm',
        seo_desc: 'Jetzt beim EcoCredits-Prämienprogramm Mitglied werden und bei jedem Einkauf EcoCredits und exklusive Prämien erhalten.',
        how_it_works: 'So funktioniert’s',
        sign_up: 'Anmelden',
        sign_up_desc: 'Erstellen Sie ein kostenloses Konto und starten Sie Ihre Mitgliedschaft.',
        earn_points: 'Verdienen & Einlösen',
        earn_points_desc: 'Aufgaben abschließen, EcoCredits verdienen und wie Bargeld nutzen oder gegen Geschenke eintauschen.',
        redeem_points: 'Mehr genießen',
        redeem_points_desc: '6 000 EcoCredits erhalten und auf PLUS-Mitgliedschaft upgraden.',
        more_benefits: 'Weitere \nVergünstigungen',
        more_benefits_desc: 'Werden Sie PLUS Mitglied für weitere Vergünstigungen.',
        more_benefits_question: 'Sobald sich 6 000 EcoCredits auf Ihrem Konto befinden, können Sie auf die PLUS-Mitgliedschaft upgraden.',
        sign_up_desc_1: 'Erstellen Sie ein Konto und erhalten Sie 800 EcoCredits.',
        sign_up1: 'Sie haben 500 EcoCredits für Ihre Registrierung erhalten.',
        sign_up1_1: 'Sie haben 800 EcoCredits für Ihre Registrierung erhalten.',
        copy_desc: 'Sie haben den Code kopiert. Sie können jetzt zum Shop gehen und ihn benutzen.',
        welcome_text: 'Sammeln Sie noch mehr EcoCredits und werden Sie PLUS Mitglied und sichern Sie sich weitere exklusive Prämien.',
        welcome_text_plus: 'Mit den erweiterten Exklusivvorteilen können Sie bei uns noch mehr sparen und erleben!',
        see_t_c: 'Siehe AGB',
        join_subTitle: 'Werden Sie jetzt Mitglied und sammeln Sie EcoCredits für Barabzüge und exklusive Prämien.',
        send_your_friend: 'Senden Sie Ihren {amont}-Gutschein einem Freund.',
        purchase: 'Kauf',
        coupon: 'Coupon',
        login_capital_letters: 'Anmelden',
        login_capital_letters1: 'Anmelden',
        received: 'Erhalten',
        subscribe_capital_letters: 'Abonnieren',
        birthday_placeholder: 'MM/TT/JJ',
        shop_capital_letters: 'Einkaufen',
        shop: 'Einkaufen',
        ecoflow_benefits: 'EcoCredits-Vorteile',
        complete_profile: 'Profil vervollständigen',
        referral: 'Freundschaftswerbung',
        referral_desc: 'Für jede erfolgreiche Registrierung eines Freundes EcoCredits erhalten.',
        referral_btn: 'Jetzt teilnehmen',
        warranty: 'Garantie',
        points_activity_a: 'Meine Aktivität',
        check_more: 'Mehr entdecken',
        points_tab_name: 'EcoCreditsaktivität',
        rewards_tab_name: 'Belohnungsaktivität',
        coupon_used_desc: 'Benutzen Sie diesen Code beim Auschecken, um Ihren {amont}-Gutschein einzulösen.',
        email_address: 'Mailadresse',
        give_away: 'Verschenken',
        add_my_birthday: 'Meinen Geburtstag hinzufügen',
        ins_title: 'Folgen Sie uns auf Instagram',
        ins_desc1: 'Sie erhalten {points} EcoCredits, wenn Sie uns zum ersten Mal folgen.',
        ins_desc2: 'Sie erhalten {points} EcoCredits, wenn Sie uns zum ersten Mal folgen.',
        follow_button: 'Jetzt folgen',
        follow_button_ins: '',
        follow_button_x: '',
        follow_button_youtube: '',
        follow_button_facebook: '',
        youtube_title: 'Folgen Sie uns auf YouTube',
        youtube_desc1: 'Sie erhalten {points} EcoCredits, wenn Sie uns zum ersten Mal folgen.',
        youtube_desc2: 'Sie erhalten {points} EcoCredits, wenn Sie uns zum ersten Mal folgen.',
        facebook_title: 'Folgen Sie uns auf Facebook',
        facebook_desc1: 'Sie erhalten {points} EcoCredits, wenn Sie uns zum ersten Mal folgen.',
        facebook_desc2: 'Sie erhalten {points} EcoCredits, wenn Sie uns zum ersten Mal folgen.',
        joininfacebook_title: 'Facebook Gruppe beitreten',
        joininfacebook_desc1: 'Sie erhalten {points} EcoCredits, wenn Sie uns zum ersten Mal folgen.',
        joininfacebook_desc2: 'Sie erhalten {points} EcoCredits, wenn Sie uns zum ersten Mal folgen.',
        subscribe: 'Abonnieren',
        welcome_top_bar: 'EcoCredits Aktionswoche x Xmax.\n Jetzt bestellen >>',
        welcome_title: 'Hallo {username}',
        welcome_sub_title: 'Willkommen beim EcoCredits Prämienprogramm.',
        profile: 'Profil vervollständigen',
        status: 'Status',
        refund: 'Rückerstattung',
        points_balance: 'EcoCredits-Guthaben',
        points_progress_tips: 'Benötigte EcoCredits zum Erreichen der {plus}: {points} EcoCredits',
        available: 'Verfügbar',
        sign_up_text: '500 EcoCredits für die Registrierung als neues Mitglied',
        redeemed_succ: 'Das Einlösen war erfolgreich!',
        current_tier: 'Aktuelle Tier',
        subscribe_now: 'Jetzt abonnieren',
        date: 'Datum',
        used: 'Verwendet',
        edeemed_rewards_note: 'Hier werden Ihre eingelösten Prämien angezeigt.',
        warranty_capital_letters: 'Garantie Registrierung',
        days_rules2: 'Gültig ab {data}.',
        redeem_now: 'JETZT EINLÖSEN',
        product_rules: 'Nur für {product}',
        membership_includes: 'IN DER MITGLIEDSCHAFT IST ENTHALTEN',
        browse_ecocredits_rewards: 'EcoCredits-Prämien durchsuchen',
        discount: 'Rabatt',
        view_more: 'Mehr anzeigen',
        profile_desc1: 'Profil vervollständigen und bis zu 1 000 EcoCredits erhalten.',
        profile_desc2: 'Erhalten Sie 1 000 EcoCredits, indem Sie Ihre Daten hinzufügen.',
        points_capital_letters: 'EcoCredits',
        history_note:
            'Ihre EcoCreditsaktivität wird hier angezeigt. Ihre EcoCredits werden noch nicht angezeigt? Ihre EcoCreditsaktivität wird innerhalb von 24 Stunden aktualisiert.',
        lucky_flop_start: 'Jetzt teilnehmen',
        lucky_flop_congrat: 'Herzlichen Glückwunsch',
        lucky_flop_get: 'Preis beanspruchen',
        lucky_flop_open: 'umdrehen',
        rules: 'Regeln',
        completed_text: 'Diese EcoCredits haben Sie bereits erhalten.',
        completed_text2: 'Sie haben bereits so viele EcoCredits gesammelt.',
        redeemed: 'Eingelöst',
        birthday: 'GEBURTSTAG',
        summary_text: 'Ihre EcoCredits-Übersicht',
        deducted: 'Abgezogen',
        site_rules: 'Nur für DE-Shop.',
        subscribe_hover: 'Sie erhalten 500 EcoCredits, wenn Sie ihn abonnieren.',
        subscribe_text: 'Abonnieren und aktuelle News von EcoFlow erhalten.',
        store: 'Jetzt kaufen',
        membership: 'MITGLIED',
        join_now: 'JETZT BEITRETEN',
        gift_card: 'Geschenkkarte',
        rewards_redeemed: 'Meine Belohnungen',
        redeedmed_tab_name: 'Eingelöst',
        issued_tab_name: 'Ausgegeben',
        expired: 'Abgelaufen',
        login: 'ANMELDEN',
        earn_points_title: 'So sammeln Sie EcoCredits',
        have_points: 'Sie haben <code>{points} EcoCredits</code>',
        view_all: 'Alle sehen',
        add_your_birthday: 'Geburtstag hinzufügen',
        earn_point_rule_shop: 'Für jeden Euro Ihres Bestellwerts erhalten Sie 1 EcoCredit.',
        off: 'RABATTE',
        earn_point_by_order: 'Verdienen Sie EcoCredits bei jedem Einkauf. (1 € = 1 EcoCredit)',
        registered: 'Registriert',
        birthday_desc2: 'Sie erhalten {points} EcoCredits, wenn Sie Ihr Geburtsdatum hinzufügen.',
        sign_up_desc_h: 'Mitgliedschaft anmelden für 500 EcoCredits.',
        sign_up_desc_h_1: 'Erstellen Sie ein Konto und erhalten Sie 800 EcoCredits.',
        birthday_desc1: 'Fügen Sie Ihren Geburtstag hinzu und erhalten Sie EcoCredits.',
        or_text: 'ODER',
        profile_a: 'Profil',
        days_rules: 'Gültig für {days} Tage ab Einlösung',
        join_title: 'Machen Sie mit beim EcoCredits Prämienprogramm',
        pending: 'In Bearbeitung',
        coming_soon: 'Bald verfügbar',
        expires_in_one_month: 'Läuft in einem Monat ab',
        shop_to_earn_points: 'Kaufen Sie ein und erhalten Sie EcoCredits',
        action: 'Aktion',
        rewards_title: 'Belohnungen',
        question_title: 'Quiz spielen',
        type_title: 'Art',
        discount_type: 'Rabatt',
        already_member: 'Sind Sie bereits Mitglied?',
        already_member1: 'Sind Sie bereits Mitglied?',
        points_activity: 'ECOCREDITSAKTIVITÄT',
        use_this_code_note: 'Benutzen Sie diesen Code beim Auschecken, um Ihren <PI1/>-Gutschein einzulösen.',
        warranty_desc2: 'Für die Registrierung Ihres Produkts erhalten Sie 1 000 EcoCredits.',
        warranty_desc1: 'Neu erhaltenes Produkt registrieren und 1 000 EcoCredits sichern.',
        redeem_ecocredits_title: 'Prämien erhalten',
        redeem_ecocredits_title_next: 'Neue Produktprämien und Rabatte stehen zum Einlösen bereit. Nicht verpassen!',
        member_exclusive: '',
        redeem_ecocredits_subtitle_next: 'Registrieren Sie sich jetzt und sichern Sie sich Zubehör für Ihr Balkonkraftwerk mit 50% Prämienvorteil!',
        redeem_ecocredits_rules_title1: 'Einführung zum Event:',
        redeem_ecocredits_rules_title2: 'Event Modus:',
        redeem_ecocredits_rules_desc1:
            'Nehmen Sie zwischen dem 20. und 23. Oktober 2023 an unseren Pop-up-Events teil, um EcoCredits mit Rabatten einzulösen. Während dieser Termine erscheinen Pop-Ups nach dem Zufallsprinzip!',
        redeem_ecocredits_rules_desc2:
            '1. Überraschungen frühzeitig freischalten: Melden Sie sich an und seien Sie unter den Ersten, die über die überraschenden Startzeiten für die EcoCredits Rewards-Veranstaltungen informiert werden.',
        redeem_ecocredits_rules_desc3:
            '2. Machen Sie das Beste aus Ihren EcoCredits: Bei jedem Pop-Up Event können Sie von einem Rabatt von bis zu 50 % auf den Punktetausch profitieren. Aber handeln Sie schnell! Die Anzahl der beteiligten Produkte ist begrenzt. Jeden Tag stehen vier einzigartige Produkte im Mittelpunkt der Aktion, von denen jeweils maximal 100 Stück verfügbar sind.',
        points: 'EcoCredits',
        benefits_item1: 'EcoCredits bei jedem Kauf verdienen',
        benefits_item2: 'EcoCredits für Gutscheine einlösen',
        benefits_item3: 'Kostenloser Versand für die meisten Produkte',
        benefits_item4: 'EcoCredits für besondere Geschenke einlösen',
        benefits_item5: 'Erweiterte Garantie für ausgewählte Produkte',
        benefits_item6: 'Events nur für Mitglieder',
        benefits_item7: 'EcoCredits bei der erfolgreichen Registrierung von Freunden verdienen',
        benefits_item8: 'Vorteile von unseren Partnern',
        benefits_item9: 'Freunde werben und bis zu 500 € Bargeld erhalten!',
        benefits_link_btn: 'Jetzt weiterempfehlen',
        network_error: 'Netzwerkfehler',
        manually_added: 'Manuell hinzugefügt',
        confirm_text: 'Möchten Sie wirklich einlösen? Dieser Vorgang kann nicht rückgängig gemacht werden.',
        manually_deducted: 'Manuell abgezogen',
        earning_points: 'ECOCREDITS SAMMELN',
        confirm_btn: 'Bestätigen',
        faq_title: 'Häufig gestellte Fragen',
        no_enough_points: 'Aufgrund unzureichender EcoCredits ist das Einlösen fehlgeschlagen.',
        no_history_note: 'Ihre EcoCredits werden noch nicht angezeigt? Es kann bis zu 24 Stunden dauern, bis Ihre Aktivität angezeigt wird.',
        no_coupon_note: 'Noch keine Gutscheine eingelöst.',
        minimum_price: 'Mindestausgaben ({price}).',
        minimum_num: 'Mindestmenge an Artikeln ({num} Stück).',
        stay_too_long: 'Ihre Session ist abgelaufen. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut.',
        order_rule: 'Für jede Bestellung kann nur ein Gutscheincode verwendet werden.',
        purchas_rule: 'Wenn Sie einen Artikel für weniger als den/die Gutschein(e) kaufen, verfällt der Differenzbetrag.',
        profile_birthday: 'Profil - Geburtstag',
        profile_address: 'Profil - Adresse',
        profile_username: 'Profil- Benutzername',
        profile_picture: 'Profil - Bild',
        profile_contact: 'Profil - Kontaktinformationen',
        View_1_Explore_Article: 'Lies 1 Explore-Artikel',
        View_2_Explore_Article: 'Lies 2 Explore-Artikel',
        View_3_Explore_Article: 'Lies 3 Explore-Artikel',
        Enable_push_notifications: 'Push-Benachrichtigungen aktivieren',
        Try_the_energy_calculator_once: 'Teste einmal den Energie-Rechner',
        learn_more: 'Mehr Erfahren',
        profile_detail:
            'Vervollständige Ihr Profil für bis zu 1000 EcoCredits, einschließlich Profilbild (200), Benutzername (100), Kontaktinformationen (300), Adresse (200) und Geburtstag (200).',
        exceeded_counts: 'Die Einlösung ist gescheitert. Sie haben das Einlöselimit überschritten.',
        grab_title: 'Holen Sie sich EcoCredits-Belohnungen',
        grab_sub_title: 'Exklusive, zeitlich begrenzte Angebote für EcoCredit-Mitglieder. Klicken Sie jetzt, um davon zu profitieren!',
        grab_btn_text: 'Meinen Belohnungen holen',
        grab_success_title: 'Herzlichen Glückwunsch',
        grab_success_text1: 'Belohnungen erfolgreich eingelöst!\n Geben Sie den Code an der Kasse ein, um Ihren Rabatt zu erhalten.',
        grab_success_text2: 'Prüfen Sie Ihre Belohnungen unter <code>"Meine Belohnungen"</code>.',
        'no-grab-content-note': 'Weitere Angebote folgen in Kürze!',
        copy_desc_2: 'Sie haben den Code kopiert.',
        city_validatino_error: 'Ungültige Ort',
        product_text: 'Produkt',
        shipping_address_text: 'Lieferadresse',
        saved_address_text: 'Gespeicherte Adressen',
        use_new_address: 'Eine neue Adresse verwenden',
        spend_now: 'Jetzt ausgeben',
        stock_left: '{stock} übrig',
        no_stock_tip: 'Bald verfügbar... Bleiben Sie dran!',
        order_text: 'Bestellung',
        campaign_time_limit_text: 'Gültiger Einlösungszeitraum:  {startTime} - {endTime}.',
        event_action_text: 'Event',
        warranty_minus_action_text: 'Garantie gelöscht',
        question_correctly: 'Beantworte die Frage korrekt',
        follow_instagram_text: 'Auf Instagram folgen',
        follow_youtube_text: 'Auf YouTube folgen',
        follow_facebook_text: 'Auf Facebook folgen',
        join_facebook_text: 'Facebook Gruppe beitreten',
        referral_correctly: 'Empfehlungsprogramms',
        confirm_btn_text: 'Schließen',
        lucky_turntable_title: 'Gewinnspiel',
        lucky_turntable_title2: 'Glücksziehung ',
        join_lucky_with_points: 'Für eine Runde Lucky Spin brauchen Sie {points} EcoCredits.',
        join_lucky_with_points2: 'Eine Spielrunde kostet {points} EcoCredits.',
        join_lucky_desc: 'Drehen Sie das Rad und holen Sie sich einen tollen Preis!',
        remaining_number: 'Noch <code></code> Drehungen übrig',
        remaining_number2: '<code></code> dreht links um',
        learn_lucky_rule: 'Mehr zu den Regeln',
        prize_coupon_title: 'Herzlichen Glückwunsch',
        prize_coupon_sub_title: 'Der Preis wurde erfolgreich beansprucht! Für Rabatte den Code an der Kasse verwenden.',
        prize_coupon_action: 'Überprüfen Sie Ihre Gewinne unter <code>Meine Belohnungen</code>.',
        prize_coupon_button: 'Jetzt einkaufen',
        prize_points_title: 'Herzlichen Glückwunsch',
        prize_points_desc: 'Überprüfen Sie die hinzugefügten EcoCredits in <code>Meine Aktivitäten</code>.',
        limit_times_in_day: 'Sie können das Rad <count></count> Mal in <day></day> Tagen drehen',
        limit_times_in_day2: 'Sie können die Karten <count></count> mal in <day></day> Tagen umdrehen',
        limit_times_in_active: 'Während der Veranstaltung können Sie das Rad bis zu <count></count> Mal drehen.',
        limit_times_in_active2: 'Während des Events können die Karten bis zu <count></count>mal umgedreht werden.',
        without_limit_times: 'Sie können das Rad jederzeit <count></count> mal drehen.',
        without_limit_times2: 'Sie können die Karten jederzeit <count></count> Mal umdrehen.',
        active_is_unstart: 'Dieses Event beginnt in Kürze.',
        active_is_ended: 'Dieses Event ist beendet.',
        over_max_count: 'Sie haben die Anzahl der verfügbaren Drehungen überschritten.',
        notice_title: 'Hinweis',
        members_nav: 'Mitgliederpreise',
        referral_nav: 'Einen Freund werben',
        points_cash: 'Punkteeinlösung',
        Pending1: 'In Bearbeitung',
        rollback: 'Zurückgegeben',
        level_change_log: 'Aktivitätsstufe',
        deadline: 'Gültig bis',
        history_refresh_member: 'Mitglied',
        history_refresh_plus_member: 'PLUS Mitglied',
        register: 'Als Mitglied registrieren',
        upgrade: 'Upgrade zum PLUS Mitglied',
        demotion: 'Mitgliedsstatus zurückstufen',
        relegation: 'PLUS Mitglied bleiben',
        product_hot_title: 'Top Angebote',
        product_hot_desc: 'Beim Kauf von EcoFlow DELTA Pro 3 und erhalten Sie eine Transportkarre GRATIS!',
        product_refurbished_title: 'Generalüberholte Produkte – Bessere Deals für kurze Zeit!',
        product_refurbished_desc: '17. Okt., 9:00 Uhr (MEZ) - 28. Okt., 8:59 Uhr (MEZ) ',

        ecoflowbenefits_nav: 'Exklusive Vorteile',
        ecoflowbenefits_title: 'EcoCredits Exklusivvorteile',
        ecoflowbenefits_savings: 'Weitere Vergünstigungen',
        ecoflowbenefits_support: 'Weitere Unterstützung',
        ecoflowbenefits_experiences: 'Weitere Vorteile',
        ecoflowbenefits_tab_benefits: 'Vorteile',
        ecoflowbenefits_tab_tier: 'Status',
        ecoflowbenefits_tab_plus: 'PLUS MITGLIED',
        ecoflowbenefits_tab_normal: 'MITGLIED',
        ecoflowbenefits_savings1: 'EcoCredits bei jedem Kauf sammeln',
        ecoflowbenefits_savings2: 'EcoCredits bei erfolgreicher Freundschaftswerbung sammeln',
        ecoflowbenefits_savings3: 'EcoCredits für Gutscheine einlösen',
        ecoflowbenefits_savings4: 'EcoCredits für besondere Geschenke einlösen',
        ecoflowbenefits_savings5: 'Save 25% OFF at Harvest Hosts',
        ecoflowbenefits_savings5_link: 'Get the Code',
        ecoflowbenefits_savings6: 'Save 10% OFF at Winnebago gears',
        ecoflowbenefits_savings6_link: 'Get the Code',
        ecoflowbenefits_savings7: 'Freunde werben und bis zu 500 € Bargeld erhalten!',
        ecoflowbenefits_savings7_link: 'Jetzt weiterempfehlen',
        ecoflowbenefits_savings8: 'Exklusiver Geburtstagsgutschein',
        ecoflowbenefits_savings9: 'PLUS Upgrade Gutschein',
        ecoflowbenefits_savings10: 'PLUS Exklusives Geschenk',
        ecoflowbenefits_savings11: 'Monatliches Gutscheinpaket',
        ecoflowbenefits_savings21: 'Profitieren Sie von exklusiven Mitgliedspreisen (wenn verfügbar)',
        ecoflowbenefits_savings22: 'Nutzen Sie EcoCredits wie Bargeld für Bestellungen',
        ecoflowbenefits_savings_tips1: 'Sie können Ihre Bestellung innerhalb eines Monats nach dem Kauf kostenlos zurücksenden.',
        ecoflowbenefits_savings_tips2:
            'Sie erhalten einen Sonderrabatt auf die Servicegebühren für Reparaturen außerhalb der Garantiezeit.\nEcoFlow behält sich das Recht vor, den Umfang der Reparaturen auf Basis der tatsächlichen Gegebenheiten festzulegen.',
        ecoflowbenefits_savings_tips3: 'Verlängern Sie Ihre Umtauschfrist für defekte Produkte auf insgesamt 5 Monate.',
        ecoflowbenefits_savings_tips4:
            'Wenn Ihr Produkt irreparabel beschädigt ist, haben Sie Anspruch auf diesen exklusiven Vorteil. Bitte legen Sie einfach einen Versandnachweis für den beschädigten Artikel zusammen mit einem Screenshot Ihres PLUS-Mitgliedsstatus vor. Nach Überprüfung senden wir Ihnen umgehend einen Ersatz zu – Sie müssen nicht warten, bis wir den defekten Artikel erhalten haben. Hinweis: Dieser Service kann nicht kombiniert mit der erweiterten Austauschgarantie von 4 Monaten in Anspruch genommen werden.',
        ecoflowbenefits_support1: 'Kostenloser Versand für die meisten Produkte',
        ecoflowbenefits_support2: 'Erweiterte Garantie für ausgewählte Produkte',
        ecoflowbenefits_support3: 'Kostenlose, bedingungslose Rücksendung (1 Bestellung)',
        ecoflowbenefits_support4: '12 % Rabatt auf Servicegebühren außerhalb der Garantiezeit',
        ecoflowbenefits_support5: 'Erweiterte Austauschgarantie von 4 Monaten',
        ecoflowbenefits_support6: 'Express Austauschservice',
        ecoflowbenefits_experiences1: 'Vorteile von unseren Partnern',
        ecoflowbenefits_experiences2: 'Exklusive Mitgliederevents',
        ecoflowbenefits_experiences3: 'Testevents für neue Produkte (in Kürze)',
        ecoflowbenefits_experiences4: 'Exclusive Early Bird Access (Coming Soon)',
        ecoflowbenefits_savings_message: 'So <line>beantragen</line> Sie Gutscheine für PLUS MITGLIEDER.',
        ecoflowbenefits_savings_message_pop1: '1. Vergessen Sie nicht, sich auf der EcoCredits Seite in Ihr EcoFlow Konto einzuloggen.',
        ecoflowbenefits_savings_message_pop2: '2. Wenn Sie einen neuen Gutschein einlösen möchten, öffnet sich ein Popup-Fenster.',
        ecoflowbenefits_savings_message_pop3:
            '3. Sie haben etwas übersehen, kein Problem! Klicken Sie auf das Symbol „Geschenk“ und überprüfen Sie den Gutschein unter „Meine Vorteile“. Vergessen Sie nicht, den Gutschein innerhalb des Gültigkeitszeitraums einzulösen.',
        ecoflowbenefits_support_message: 'Bei <email>support.eu@ecoflow.com</email> erhalten Sie Hilfe zur Nutzung Ihrer Vorteile.',
        ecoflowbenefits_experiences_message: 'Bleiben Sie auf dem Laufenden!',
        eu_activity_nav_title1: 'Gewinnspiel',
        eu_activity_nav_title2: 'Angebote für generalüberholte Produkte',
        eu_activity_nav_title3: 'Top Angebote',
        eu_activity_nav_title4: 'So funktioniert es',
        eu_activity_nav_title5: 'Exklusive Vorteile',
        eu_activity_nav_title6: 'So sammeln Sie EcoCredits',
        eu_activity_nav_title7: 'Prämien erhalten',
        eu_activity_nav_title8: 'Häufig gestellte Fragen',
        date_of_event: 'Datum des Events',
        expiration_date: 'Ablaufdatum',
        only_plus_member: 'PLUS  Mitglied  EcoCredits Prämie',
        only_member: ' Mitglied  EcoCredits Prämie',
        not_eligible: 'Sie sind nicht berechtigt, an diesem Event teilzunehmen.',
        // 25年会员活动
        first_login_2025: 'Erste Anmeldung',
        know_brand_2025: 'Mehr über EcoFlow erfahren',
        know_member_2025: 'Mehr über die Mitgliedschaft erfahren',
        share_story_2025: 'Meine Story teilen',
        first_order_2025: 'Einen Kauf abschließen',
        repeat_order_2025: 'Einen weiteren Kauf tätigen',
    },
    es: {
        shop1: 'Consigue 1 EcoCredit por cada euro que gastes.',
        warranty1: 'Registra un producto y obtén 1000 EcoCredits.',
        profile1: 'Completa tu perfil y obtén 1000 EcoCredits.',
        referral1: 'Obtén EcoCredits cada vez que un amigo se registre correctamente.',
        ins: 'Síguenos en Instagram y obtén 100 EcoCredits.',
        x: 'Síguenos en X y obtén 100 EcoCredits.',
        youtube: 'Síguenos en YouTube y obtén 100 EcoCredits.',
        facebook: 'Síguenos en Facebook y obtén 100 EcoCredits.',
        line: 'Has ganado 100 EcoCredits al registrarte como amigo en LINE.',
        joininfacebook: 'Únete a EcoFlow en Facebook y obtén 100 EcoCredits.',
        subscribe1: 'Suscríbete y obtén 500 EcoCredits.',
        clock_in: 'Visitar',
        seo_title: 'Únase al programa de lealtad EcoCredits',
        seo_desc:
            '¡Únase al programa de lealtad de EcoCredits de EcoFlow hoy y gane recompensas ahora mismo! Obtenga una recompensa de 500 EcoCredits solo por registrarse.',
        copy_desc: 'Has copiado el código; ve a la tienda para usarlo.',
        welcome_text: 'Gana más EcoCredits y actualiza a la Membresía PLUS para disfrutar de más recompensas exclusivas.',
        welcome_text_plus: '¡Los beneficios exclusivos actualizados te permiten ahorrar y disfrutar de incluso una mejor experiencia con nosotros!',
        how_it_works: 'Cómo funciona',
        sign_up: 'Registrarse',
        sign_up_desc: 'Crea una cuenta gratis y comienza tu recorrido como miembro.',
        earn_points: 'Ganar y usar',
        earn_points_desc: 'Completa tareas para obtener EcoCredits y úsalos como efectivo o canjea recompensas.',
        redeem_points: 'Disfrutar más',
        redeem_points_desc: 'Obtén 6000 EcoCredits y actualiza a la Membresía PLUS para disfrutar de más beneficios.',
        more_benefits: 'MÁS BENEFICIOS',
        more_benefits_desc: 'Actualiza a Miembro PLUS para ahorrar más.',
        more_benefits_question: 'Una vez que tengas 6000 EcoCredits en tu cuenta, podrás actualizar a la Membresía PLUS.',
        sign_up_desc_1: 'Crea una cuenta y consigue 800 EcoCredits.',
        sign_up1: 'Regístrate y obtén 500 EcoCredits.',
        sign_up1_1: 'Regístrate y obtén 800 EcoCredits.',
        see_t_c: 'Lee los Términos y condiciones',
        join_subTitle: 'Conviértete en miembro ahora y consigue EcoCredits para obtener deducciones en efectivo y recompensas exclusivas.',
        send_your_friend: 'Envía tu tarjeta regalo de {amont} a un amigo.',
        purchase: 'Compra',
        coupon: 'Código de descuento',
        login_capital_letters: 'Iniciar sesión',
        login_capital_letters1: 'Iniciar sesión',
        received: 'Recibido',
        subscribe_capital_letters: 'Suscribirse',
        birthday_placeholder: 'DD / MM / AA',
        shop_capital_letters: 'Comprar',
        shop: 'Comprar',
        ecoflow_benefits: 'Ventajas de los EcoCredits',
        complete_profile: 'Completar perfil',
        referral: 'Invita a tus amigos',
        referral_desc: 'Obtén EcoCredits cada vez que un amigo se registre correctamente.',
        referral_btn: 'Unirse ahora',
        warranty: 'Garantía',
        points_activity_a: 'Mi actividad',
        check_more: 'Ver más',
        points_tab_name: 'Actividad de EcoCredits',
        rewards_tab_name: 'Actividad de premios',
        coupon_used_desc: 'Usa este código en el momento de realizar el pago para canjear tu tarjeta regalo de {amont}.',
        email_address: 'Dirección de correo electrónico',
        give_away: 'Regalar',
        add_my_birthday: 'Añadir fecha de mi cumpleaños',
        ins_title: 'Síguenos en Instagram',
        ins_desc1: 'Gana {points} EcoCredits al seguirnos por primera vez.',
        ins_desc2: 'Gana {points} EcoCredits al seguirnos por primera vez.',
        follow_button: 'Síguenos ahora',
        follow_button_ins: '',
        follow_button_x: '',
        follow_button_youtube: '',
        follow_button_facebook: '',
        facebook_title: 'Síguenos en Facebook',
        facebook_desc1: 'Gana {points} EcoCredits al seguirnos por primera vez.',
        facebook_desc2: 'Gana {points} EcoCredits al seguirnos por primera vez.',
        joininfacebook_title: 'Únete a nosotros en Facebook',
        joininfacebook_desc1: 'Gana {points} EcoCredits al seguirnos por primera vez.',
        joininfacebook_desc2: 'Gana {points} EcoCredits al seguirnos por primera vez.',
        subscribe: 'Suscribirse',
        welcome_top_bar: 'Semana EcoCredits de Agradecimiento x Xmas.\n Adquirir Ahora >>',
        welcome_title: 'Hola {username}',
        welcome_sub_title: 'Te damos la bienvenida al programa de recompensas de EcoCredits.',
        profile: 'Completar perfil',
        status: 'Estado',
        refund: 'Reembolso',
        points_balance: 'Saldo de EcoCredits',
        points_progress_tips: 'EcoCredits necesarios para llegar a {plus}: {points} EcoCredits',
        available: 'Disponible',
        sign_up_text: '500 EcoCredits por unirte al programa',
        redeemed_succ: '¡Canjeados correctamente!',
        current_tier: 'Nivel actual',
        subscribe_now: 'Suscribirse ahora',
        date: 'Fecha',
        used: 'Usado',
        edeemed_rewards_note: 'Tus recompensas canjeadas aparecerán aquí.',
        warranty_capital_letters: 'Registro de garantía',
        days_rules2: 'Válido desde {data}.',
        redeem_now: 'CANJEAR AHORA',
        product_rules: 'Solo para {product}',
        membership_includes: 'ESTAS SON LAS VENTAJAS DE AFILIARSE AL PROGRAMA',
        browse_ecocredits_rewards: 'Explorar recompensas de EcoCredits',
        discount: 'Descuento',
        view_more: 'Ver más',
        profile_desc1: 'Completa tu perfil y obtén hasta 1000 EcoCredits.',
        profile_desc2: 'Consigue hasta 1000 EcoCredits por añadir tus datos.',
        points_capital_letters: 'EcoCredits',
        history_note: 'Tu actividad aparecerá aquí. ¿Aún no ves tu actividad? La actividad se actualizará en 24 horas.',
        lucky_flop_start: 'Únete ahora',
        lucky_flop_congrat: '¡Enhorabuena!',
        lucky_flop_get: 'Reclamar',
        lucky_flop_open: 'ABRIR',
        rules: 'Reglas',
        completed_text: 'Ya has conseguido esta recompensa.',
        redeemed: 'Canjeadas',
        birthday: 'CUMPLEAÑOS',
        summary_text: 'Resumen de tus EcoCredits',
        deducted: 'Deducido',
        site_rules: 'Solo para tienda de España.',
        subscribe_hover: 'Suscríbete y gana 500 EcoCredits.',
        subscribe_text: 'Suscríbete para recibir las últimas noticias de EcoFlow.',
        store: 'Comprar Ahora',
        membership: 'Miembro',
        join_now: 'UNIRSE AHORA',
        gift_card: 'Tarjeta regalo',
        rewards_redeemed: 'Mis premios',
        redeedmed_tab_name: 'Canjeado',
        issued_tab_name: 'Emitido',
        expired: 'Caducado',
        login: 'INICIAR SESIÓN',
        earn_points_title: 'Formas de ganar EcoCredits',
        have_points: 'Tienes <code>{points} EcoCredits</code>',
        view_all: 'Ver todo',
        add_your_birthday: 'Añade el día de tu cumpleaños',
        earn_point_rule_shop: 'Consigue 1 EcoCredit por cada euro que gastes.',
        off: 'DESCUENTO',
        earn_point_by_order: 'Gana EcoCredits cada vez que compres. (1 € = 1 EcoCredit)',
        registered: 'Registrado',
        birthday_desc2: 'Gana {points} EcoCredits añadiendo tu fecha de nacimiento.',
        sign_up_desc_h: 'Regístrate como miembro y consigue 500 EcoCredits.',
        sign_up_desc_h_1: 'Crea una cuenta y consigue 800 EcoCredits.',
        birthday_desc1: 'Añade el día de tu cumpleaños para obtener EcoCredits.',
        or_text: 'O',
        profile_a: 'Perfil',
        days_rules: ' Válido durante {days} días desde el canje.',
        join_title: 'Únete al programa de recompensas de EcoCredits',
        pending: 'Pendiente',
        coming_soon: 'Próximamente',
        expires_in_one_month: 'Caduca en un mes',
        shop_to_earn_points: 'Compra para ganar EcoCredits',
        action: 'Acción',
        rewards_title: 'Premios',
        question_title: '¡Responde a las preguntas',
        type_title: 'Tipo',
        discount_type: 'Descuento',
        already_member: '¿Ya eres miembro?  ',
        already_member1: '¿Ya eres miembro?&nbsp;&nbsp;',
        points_activity: 'ACTIVIDAD DE EcoCredits',
        use_this_code_note: 'Usa este código en el momento de realizar el pago para canjear tu tarjeta regalo de <PI1/>.',
        warranty_desc2: '1000 EcoCredits cuando registres un producto.',
        warranty_desc1: 'Registra un producto recién recibido para obtener 1000 EcoCredits.',
        redeem_ecocredits_title: 'Canjear recompensas',
        redeem_ecocredits_title_next: 'Puedes canjear las recompensas y descuentos de los nuevos productos. ¡No te lo pierdas!',
        member_exclusive: 'Precios exclusivos para socios',
        redeem_ecocredits_subtitle_next: 'Iscriviti ora e afferra gli accessori per un fotovoltaico da balcone al 50% in meno degli EcoCredits!',
        redeem_ecocredits_rules_title1: 'Introducción al evento:',
        redeem_ecocredits_rules_title2: 'Mecanismo del evento:',
        redeem_ecocredits_rules_desc1:
            'Únete a los eventos de descuentos de ventanas emergentes de “Canjea recompensas de EcoCredits” del 20 al 23 de octubre de 2023. ¡Las ventanas emergentes aparecerán aleatoriamente durante estas fechas!',
        redeem_ecocredits_rules_desc2:
            '1. Desbloquea sorpresas con antelación: Suscríbete y sé el primero en conocer los horarios de inicio sorpresa de los eventos “Canjea recompensas de EcoCredits”.',
        redeem_ecocredits_rules_desc3:
            '2. Maximiza tus EcoCredits: Durante el evento de ventanas emergentes, aprovecha de un descuento en el canje de puntos de hasta el 50%. ¡Deberás ser rápido! Las cantidades de productos participantes son limitadas. Cada día se destacarán en la promoción cuatro productos únicos, cada uno con un máximo de 100 unidades disponibles.',
        points: 'EcoCredits',
        benefits_item1: 'Obtén EcoCredits con cada compra',
        benefits_item2: 'Canjea EcoCredits por un cupón',
        benefits_item3: 'Envío gratuito para la mayoría de los productos',
        benefits_item4: 'Canjea EcoCredits por regalos especiales',
        benefits_item5: 'Garantía ampliada en productos seleccionados',
        benefits_item6: 'Evento exclusivo para miembros',
        benefits_item7: 'Obtén EcoCredits cuando tus amigos se registren',
        benefits_item8: 'Ventajas de nuestros socios',
        benefits_item9: '¡Refiere y gana una recompensa de hasta 500 € en efectivo!',
        benefits_link_btn: 'Recomendar ahora',
        network_error: 'Error de red',
        manually_added: 'Añadidos manualmente',
        confirm_text: '¿Seguro que quieres canjear tus EcoCredits? Esta acción no se puede anular.',
        manually_deducted: 'Restados manualmente',
        earning_points: 'CÓMO OBTENER EcoCredits',
        confirm_btn: 'Confirmar',
        faq_title: 'Preguntas frecuentes',
        no_enough_points: 'Error al canjear los EcoCredits. No tienes suficientes EcoCredits',
        no_history_note: '¿Todavía no ves tus EcoCredits? Tu actividad se actualizará en 24 horas.',
        no_coupon_note: 'Todavía no se ha canjeado ninguna recompensa.',
        minimum_price: 'Monto mínimo de compra ({price}).',
        minimum_num: 'Cantidad mínima de artículos ({num} piezas).',
        stay_too_long: 'Tu sesión ha expirado. Por favor, actualiza la página e inténtalo otra vez.',
        order_rule: 'Solo un código promocional por pedido.',
        purchas_rule: 'Al comprar un artículo por un precio inferior al del cupón, se perderá la diferencia.',
        profile_birthday: 'Perfil - cumpleaños',
        profile_address: 'Perfil - dirección',
        profile_username: 'Perfil - nombre de usuario',
        profile_picture: 'Perfil - foto',
        profile_contact: 'Perfil - información de contacto',
        View_1_Explore_Article: 'Ver 1 artículo de Explore',
        View_2_Explore_Article: 'Ver 2 artículos de Explore',
        View_3_Explore_Article: 'Ver 3 artículos de Explore',
        Enable_push_notifications: 'Activar las notificaciones push',
        Try_the_energy_calculator_once: 'Prueba una vez la calculadora de energía',
        learn_more: 'Más información',
        profile_detail:
            'Completa tu perfil para obtener hasta 1000 EcoCredits, incluyendo la foto de perfil (200), el nombre de usuario (100), la información de contacto (300), la dirección (200) y el cumpleaños (200).',
        exceeded_counts: 'No se puede canjear. Has superado el límite de canje.',
        grab_title: 'Consigue un bonus EcoCredits',
        grab_sub_title: 'Ofertas exclusivas por tiempo limitado para miembros de EcoCredit. ¡Haga clic para reclamar ahora!',
        grab_btn_text: 'Conseguir mi bonus',
        grab_success_title: 'Felicitaciones',
        grab_success_text1: '¡Bonus reclamado con éxito!\n Pega el código en la caja para obtener tu descuento.',
        grab_success_text2: 'Consulta tus bonus en <code>Mis Recompensas</code>.',
        'no-grab-content-note': '¡Próximamente más ofertas!',
        copy_desc_2: 'Has copiado el código.',
        city_validatino_error: 'Ciudad no válida',
        product_text: 'Producto',
        shipping_address_text: 'Dirección de envío',
        saved_address_text: 'Direcciones registradas',
        use_new_address: 'Utiliza una nueva dirección',
        spend_now: 'Gastar Ahora',
        stock_left: '{stock} Restantes',
        no_stock_tip: 'Próximamente... ¡Esté atento!',
        order_text: 'Pedido',
        campaign_time_limit_text: 'Periodo de canje válido: {startTime} - {endTime}.',
        event_action_text: 'Actividad',
        warranty_minus_action_text: 'Garantía eliminada',
        question_correctly: 'Responde la pregunta correctamente',
        follow_instagram_text: 'Síguenos en Instagram',
        follow_facebook_text: 'Síguenos en Facebook',
        join_facebook_text: 'Únete al grupo de FB',
        referral_correctly: 'Programa de recomendación',
        confirm_btn_text: 'Cerrar',
        lucky_turntable_title: 'Lucky Spin',
        lucky_turntable_title2: 'Sorteo de premios',
        join_lucky_with_points: 'Necesitas {points} EcoCredits para girar una vez Lucky Spin.',
        join_lucky_with_points2: 'Jugar una ronda te cuesta {points} EcoCredits.',
        join_lucky_desc: '¡Gira la ruleta y consigue un gran premio!',
        remaining_number: '<code></code> gira a la izquierda',
        remaining_number2: 'Te quedan <code></code> intentos',
        learn_lucky_rule: 'Obtén más información sobre las reglas',
        prize_coupon_title: '¡Enhorabuena!',
        prize_coupon_sub_title: '¡Premio reclamado correctamente! Usa el código cuando pagues para ahorrar.',
        prize_coupon_action: 'Consulta tus premios en <code>Mis recompensas</code>.',
        prize_coupon_button: 'Comprar ahora',
        prize_points_title: '¡Enhorabuena!',
        prize_points_desc: 'Consulta los EcoCredits recién añadidos en <code>Mi actividad</code>.',
        limit_times_in_day: 'Puedes girar las ruletas <count></count> veces en <day></day> días',
        limit_times_in_day2: 'Puedes dar la vuelta a las tarjetas <count></count> veces en <day></day> días',
        limit_times_in_active: 'Durante el evento, puedes girar las ruletas hasta <count></count> veces.',
        limit_times_in_active2: 'Durante el evento, puedes dar la vuelta a las cartas hasta <count></count> veces.',
        without_limit_times: 'Puedes girar las ruletas <count></count> veces en cualquier momento.',
        without_limit_times2: 'Puedes dar la vuelta a las cartas <count></count> veces en cualquier momento.',
        active_is_unstart: 'El evento empezará pronto.',
        active_is_ended: 'Este evento ha finalizado.',
        over_max_count: 'Has superado el número de veces que puedes girar la ruleta.',
        notice_title: 'Aviso',

        members_nav: 'Precios para miembros',
        referral_nav: 'Invita a un amigo',

        points_cash: 'Canje de Puntos',
        Pending1: 'Pendiente',
        rollback: 'Devuelto',
        product_hot_title: 'Lo más destacado',
        product_hot_desc: '¡No te lo pierdas! ¡Compra ahora y obtén regalos exclusivos y descuentos imbatibles!',
        product_refurbished_title: 'Productos reacondicionados: ¡mejores ofertas durante un tiempo limitado!',
        product_refurbished_desc: '17/10/2024 09:00 (CEST) - 28/10/2024 08:59 (CEST)',
        level_change_log: 'Actividad de nivel',
        deadline: 'Válido hasta',
        history_refresh_member: 'Nivel actual: Miembro',
        history_refresh_plus_member: 'Nivel actual: Miembro PLUS',
        register: 'Registrarse como miembro',
        upgrade: 'Actualizar a miembro PLUS',
        demotion: 'Volver al nivel Miembro',
        relegation: 'Seguir siendo miembro PLUS',
        ecoflowbenefits_title: 'Beneficios exclusivos de los EcoCredits',
        ecoflowbenefits_savings: 'Un mayor ahorro',
        ecoflowbenefits_support: 'Más soporte',
        ecoflowbenefits_experiences: 'Más experiencias',
        ecoflowbenefits_tab_benefits: 'Beneficios',
        ecoflowbenefits_tab_tier: 'Nivel',
        ecoflowbenefits_tab_plus: 'MIEMBRO PLUS',
        ecoflowbenefits_tab_normal: 'MIEMBRO',
        ecoflowbenefits_savings1: 'Obtén EcoCredits con cada compra',
        ecoflowbenefits_savings2: 'Obtén EcoCredits cuando tus amigos se registren',
        ecoflowbenefits_savings3: 'Canjea EcoCredits por un cupón',
        ecoflowbenefits_savings4: 'Canjea EcoCredits por regalos especiales',
        ecoflowbenefits_savings5: 'Save 25% OFF at Harvest Hosts',
        ecoflowbenefits_savings5_link: 'Get the Code',
        ecoflowbenefits_savings6: 'Save 10% OFF at Winnebago gears',
        ecoflowbenefits_savings6_link: 'Get the Code',
        ecoflowbenefits_savings7: '¡Refiere y gana una recompensa de hasta 500 € en efectivo!',
        ecoflowbenefits_savings7_link: 'Recomendar ahora',
        ecoflowbenefits_savings8: 'Cupón de cumpleaños exclusivo',
        ecoflowbenefits_savings9: 'Cupón para actualizar a PLUS',
        ecoflowbenefits_savings10: 'Regalos exclusivos de PLUS',
        ecoflowbenefits_savings11: 'Pack de cupones mensual',
        ecoflowbenefits_savings21: 'Disfruta de precios especiales solo para miembros (cuando estén disponibles)',
        ecoflowbenefits_savings22: 'Usa EcoCredits como efectivo en tus pedidos.',
        ecoflowbenefits_savings_tips1: 'Disfruta de una devolución gratuita antes de que transcurra un mes desde la compra.',
        ecoflowbenefits_savings_tips2:
            'Obtén un descuento especial en las tarifas de las reparaciones realizadas fuera del periodo de garantía.\nEcoFlow se reserva el derecho de determinar el alcance de las reparaciones según cuál sea la situación real.',
        ecoflowbenefits_savings_tips3:
            'Amplía tu periodo de sustitución hasta un total de 5 meses para poder reemplazar productos defectuosos por otros nuevos.',
        ecoflowbenefits_savings_tips4:
            'Si tu producto está dañado de forma irreparable, puedes beneficiarte de esta ventaja exclusiva. Solo tienes que enviar el comprobante de envío del artículo dañado junto con una captura de pantalla que confirme tu membresía PLUS. Una vez verificado, te enviaremos un reemplazo de inmediato, sin necesidad de esperar a que recibamos el producto averiado. \nNota: Este servicio no puede usarse combinado con el beneficio de la sustitución ampliada 4 meses.',
        ecoflowbenefits_support1: 'Envío gratuito para la mayoría de los productos',
        ecoflowbenefits_support2: 'Garantía ampliada en productos seleccionados',
        ecoflowbenefits_support3: 'Devolución incondicional gratuita (1 pedido)',
        ecoflowbenefits_support4: 'Descuento del 12 % en tarifas de reparación de productos fuera de garantía',
        ecoflowbenefits_support5: 'Sustitución bajo garantía ampliada 4 meses',
        ecoflowbenefits_support6: 'Servicio de sustitución exprés',

        ecoflowbenefits_experiences1: 'Ventajas de nuestros socios',
        ecoflowbenefits_experiences2: 'Evento exclusivo para miembros',
        ecoflowbenefits_experiences3: 'Nuevo evento de prueba de producto (próximamente)',
        ecoflowbenefits_experiences4: 'Exclusive Early Bird Access (Coming Soon)',
        ecoflowbenefits_savings_message: 'Consulta aquí para solicitar <line>tus</line> vales de MIEMBRO PLUS.',
        ecoflowbenefits_savings_message_pop1: '1. No olvides iniciar sesión en tu cuenta de EcoFlow en la página de EcoCredits.',
        ecoflowbenefits_savings_message_pop2: '2. Verás el mensaje emergente de inmediato si tienes un vale nuevo que necesitas que solicitar.',
        ecoflowbenefits_savings_message_pop3:
            "3. No te preocupes si te lo has perdido. Ve al icono de 'regalo' y comprueba si existe el vale en «Mis recompensas». No olvides usarlo durante el periodo de validez.",
        ecoflowbenefits_support_message: 'Ponte en contacto con <email>support.eu@ecoflow.com</email> para obtener más ayuda sobre cómo usar tus beneficios.',
        ecoflowbenefits_experiences_message: '¡Mantente al tanto de nuestras noticias!',
        eu_activity_nav_title1: 'Sorteo de premios',
        eu_activity_nav_title2: 'Ofertas en productos reacondicionados',
        eu_activity_nav_title3: 'Lo más destacado',
        eu_activity_nav_title4: '¿Cómo funciona?',
        eu_activity_nav_title5: 'Beneficios exclusivos de los EcoCredits',
        eu_activity_nav_title6: 'Formas de ganar EcoCredits',
        eu_activity_nav_title7: 'Canjear recompensas',
        eu_activity_nav_title8: 'Preguntas frecuentes',
        date_of_event: 'Fecha del evento',
        expiration_date: 'Fecha de caducidad',
        only_plus_member: 'Solo los Miembros PLUS pueden canjear la recompensa.',
        only_member: 'Solo los Miembros pueden canjear la recompensa.',
        not_eligible: 'No eres elegible para participar en este evento.',
        // 25年会员活动
        first_login_2025: 'Regístrate o inicia sesión',
        know_brand_2025: 'Aprende más sobre EcoFlow',
        know_member_2025: 'Descubre más sobre los beneficios de ser miembro',
        share_story_2025: 'Compartir mi historia',
        first_order_2025: 'Realiza una compra',
        repeat_order_2025: 'Realiza una compra adicional',
    },
    eu: {
        shop1: 'Earn every time you order.',
        warranty1: 'You got 1000 EcoCredits by registering a product.',
        profile1: 'You got 1000 EcoCredits by completing your profile.',
        referral1: "Get EcoCredits for each friend's successful registration.",
        ins: 'You got 100 EcoCredits by following us on Instagram.',
        x: 'You got 100 EcoCredits by following us on X.',
        youtube: 'You got 100 EcoCredits by following us on YouTube.',
        facebook: 'You got 100 EcoCredits by following us on Facebook.',
        line: 'You earned 100 EcoCredits by registering as a friend on LINE.',
        joininfacebook: 'You got 100 EcoCredits by joining us on Facebook.',
        subscribe1: 'You got 500 EcoCredits by subscribing.',
        clock_in: 'Check-in',
        seo_title: 'Join The EcoCredits Loyalty Program',
        seo_desc: 'Join the EcoCredits Loyalty Program at EcoFlow today and start earning rewards now! Get a 500-EcoCredits reward just for signing up.',
        join_title: 'Join the EcoCredits reward program',
        join_subTitle: 'Become a member now and get EcoCredits for cash deductions and exclusive rewards.',
        join_now: 'JOIN NOW',
        login: 'LOG IN',
        login_capital_letters: 'Log in',
        login_capital_letters1: 'Log in',
        welcome_top_bar: 'EcoCredits Appreciation Week x Xmas.\n Shop Now >>',
        welcome_title: 'Hi {username}',
        welcome_sub_title: 'Welcome to the EcoCredits reward programme.',
        welcome_text: 'Earn more EcoCredits and upgrade to PLUS Membership to enjoy more exclusive rewards.',
        welcome_text_plus: 'The upgraded exclusive benefits allow you to save and experience even more with us!',
        summary_text: 'Your EcoCredits Summary',
        membership: 'MEMBER',
        current_tier: 'Current Tier',
        points: 'EcoCredits',
        points_balance: 'EcoCredits Balance',
        points_progress_tips: 'EcoCredits Needed to Reach {plus}: {points} EcoCredits',
        coming_soon: 'Coming Soon',
        expires_in_one_month: 'Expires in One Month',
        redeem_now: 'REDEEM NOW',
        points_activity: 'POINTS ACTIVITY',
        how_it_works: 'How It Works',
        sign_up: 'Sign Up',
        sign_up_desc: 'Create an account for free and start your membership journey.',
        earn_points: 'Earn & Use',
        earn_points_desc: 'Complete tasks for EcoCredits to use as cash or redeem rewards.',
        redeem_points: 'Enjoy More',
        redeem_points_desc: 'Get 6000 EcoCredits and upgrade to a PLUS Membership for more.',
        more_benefits: 'More BENEFITS',
        more_benefits_desc: 'Upgrade to PLUS Membership to save more. ',
        more_benefits_question: 'Once you have 6,000 EcoCredits in your account, you can upgrade to PLUS Membership.',
        sign_up_desc_1: 'Create an account and get 800 EcoCredits reward.',
        already_member: 'Already a member?',
        already_member1: 'Already a member?',
        sign_up1: 'You got 500 EcoCredits by signing up.',
        sign_up1_1: 'You got 800 EcoCredits by signing up.',
        sign_up_desc_h: 'Sign up for Membership for 500 EcoCredits.',
        sign_up_desc_h_1: '800 EcoCredits when you join.',
        earn_points_title: 'Ways to Earn EcoCredits',
        sign_up_text: '500 EcoCredits upon joining',
        completed_text: 'You have already achieved this reward.',
        subscribe: 'Subscribe',
        subscribe_capital_letters: 'Subscribe',
        subscribe_text: 'Subscribe to get the latest EcoFlow news.',
        subscribe_hover: 'Earn 500 EcoCredits when you join.',
        subscribe_now: 'Subscribe Now',
        email_address: 'Email Address',
        shop: 'Shop',
        shop_capital_letters: 'Shop',
        earn_point_by_order: 'Earn EcoCredits every time you shop. （€1=1EcoCredits）',
        earn_point_rule_shop: 'Get 1 EcoCredits for every €1 you spend.',
        shop_to_earn_points: 'Shop To Earn EcoCredits',
        warranty: 'Warranty',
        warranty_capital_letters: 'Warranty Registration',
        warranty_desc1: 'Register a newly received product for 1000 EcoCredits.',
        warranty_desc2: 'Register a newly received product for 1000 EcoCredits.',
        profile: 'Complete Profile',
        profile_desc1: 'Completing your profile for up to 1000 EcoCredits.',
        profile_desc2: 'Get up to 1000 EcoCredits for adding your details.',
        complete_profile: 'Complete Profile',
        referral: 'Invited A Friend',
        referral_desc: "Get EcoCredits for each friend's successful registration.",
        referral_btn: 'Join Now',
        birthday: 'BIRTHDAY',
        birthday_desc1: 'Add your birthday for EcoCredits.',
        birthday_desc2: 'Earn {points} EcoCredits when you add your date of birth.',
        add_your_birthday: 'Add Your Birthday',
        birthday_placeholder: 'MM / DD / YY',
        add_my_birthday: 'Add My Birthday',
        ins_title: 'Follow Us On Instagram',
        ins_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        ins_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        follow_button: 'Follow Now',
        follow_button_ins: '',
        follow_button_x: '',
        follow_button_youtube: '',
        follow_button_facebook: '',
        x_title: 'Follow Us On X',
        x_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        x_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        youtube_title: 'Follow Us On YouTube',
        youtube_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        youtube_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        facebook_title: 'Follow Us On Facebook',
        facebook_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        facebook_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        joininfacebook_title: 'Join Us On Facebook',
        joininfacebook_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        joininfacebook_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        redeem_ecocredits_title: 'Redeem Rewards',
        redeem_ecocredits_title_next: 'New product rewards and discounts are available for redeeming.',
        member_exclusive: 'Member-Exclusive Prices',
        redeem_ecocredits_subtitle_next: 'Sign up now and grab Balcony Solar System accessories at 50% less EcoCredits!',
        redeem_ecocredits_rules_title1: 'Event Introduction:',
        redeem_ecocredits_rules_title2: 'Event Mechanism:',
        redeem_ecocredits_rules_desc1:
            'Join our pop-up Redeem EcoCredits Rewards discount events between October 20 and October 23, 2023. Pop-ups will appear randomly during these dates!',
        redeem_ecocredits_rules_desc2:
            '1. Unlock Surprises Early: Subscribe and be the first to know the surprise start times of the Redeem EcoCredits Rewards events.',
        redeem_ecocredits_rules_desc3:
            '2. Maximise Your EcoCredits: During each pop-up event, benefit from a points exchange discount of up to 50%. But act fast! Participating product quantities are limited. Every day, four unique products will be spotlighted in the promotion, each with a maximum of 20 units available.',
        have_points: 'You have <code>{points} EcoCredits</code>',
        view_all: 'View all',
        coupon: 'Discount code',
        discount: 'Discount',
        gift_card: 'Gift Card',
        redeemed_succ: 'Redeemed successfully!',
        copy_desc: 'You have copied the code, please go to the store to use it.',
        store: 'Shop Now',
        coupon_used_desc: 'Use this code at checkout to redeem your {amont} gift card.',
        rules: 'Rules',
        off: 'OFF',
        site_rules: 'For EU store only.',
        days_rules: 'Valid for {days} days from redemption.',
        product_rules: 'For {product} only.',
        days_rules2: 'Valid from {data}.',
        rewards_redeemed: 'My Rewards',
        redeedmed_tab_name: 'Redeemed',
        issued_tab_name: 'Issued',
        available: 'Available',
        redeemed: 'Redeemed',
        expired: 'Expired',
        edeemed_rewards_note: 'Your redeemed rewards will appear here.',
        browse_ecocredits_rewards: 'Browse EcoCredits Rewards',
        used: 'Used',
        give_away: 'Give away',
        or_text: 'OR',
        send_your_friend: 'Send your {amont} gift card to a friend.',
        points_activity_a: 'My Activity',
        check_more: 'Check More',
        points_tab_name: 'EcoCredits Activity',
        rewards_tab_name: 'Rewards Activity',
        date: 'Date',
        action: 'Action',
        rewards_title: 'Rewards',
        question_title: 'Play Quiz',
        type_title: 'Type',
        discount_type: 'Discount',
        purchase: 'Purchase',
        profile_a: 'Profile',
        refund: 'Refund',
        registered: 'Registered',
        points_capital_letters: 'EcoCredits',
        status: 'Status',
        pending: 'Pending',
        received: 'Received',
        deducted: 'Deducted',
        view_more: 'View More',
        history_note: 'Your activity will appear here. Don’t see your activity yet? Your activity will update within 24 hours.',
        lucky_flop_start: 'Join Now',
        lucky_flop_congrat: 'Congratulations',
        lucky_flop_get: 'Claim',
        lucky_flop_open: 'OPEN',
        ecoflow_benefits: 'EcoCredits Benefits',
        membership_includes: 'MEMBERSHIP INCLUDES',
        benefits_item1: 'Earn EcoCredits for Every Purchase',
        benefits_item2: 'Redeem EcoCredits for Coupons',
        benefits_item3: 'Free Shipping on Most Products',
        benefits_item4: 'Redeem EcoCredits for Special Gifts',
        benefits_item5: 'Extended Warranty for Selected Products',
        benefits_item6: 'Member-Only Events',
        benefits_item7: 'Earn EcoCredits From Successful Friend Sign-ups',
        benefits_item8: 'Benefits From Our Partners',
        benefits_item9: 'Refer & Earn Up To €500 Cash Reward!',
        benefits_link_btn: 'Refer Now',
        see_t_c: 'See Terms and Conditions',
        manually_added: 'Manually Added',
        manually_deducted: 'Manually Deducted',
        faq_title: 'Frequently Asked Questions',
        earning_points: 'EARNING EcoCredits',
        network_error: 'Network Error',
        confirm_text: 'Are you sure you want to redeem? Cannot be undone.',
        confirm_btn: 'Confirm',
        no_enough_points: 'Redemption failed, your EcoCredits are not enough',
        no_history_note: 'Don’t see your EcoCredits yet? Your activity will update with in 24 hours.',
        no_coupon_note: 'No rewards redeemed yet.',
        minimum_price: 'Minimum purchase amount ({price}).',
        minimum_num: 'Minimum quantity of items({num} pcs).',
        stay_too_long: 'Your session has expired. Please refresh the page and try again.',
        order_rule: 'Only one discount code per order.',
        purchas_rule: 'Purchasing an item for less than the coupon(s), will forfeit the difference.',
        profile_birthday: 'Profile - birthday',
        profile_address: 'Profile - address',
        profile_username: 'Profile - username',
        profile_picture: 'Profile - picture',
        profile_contact: 'Profile - contact info',
        View_1_Explore_Article: 'View 1 Explore article',
        View_2_Explore_Article: 'View 2 Explore articles',
        View_3_Explore_Article: 'View 3 Explore articles',
        Enable_push_notifications: 'Enable push notifications',
        Try_the_energy_calculator_once: 'Try the energy calculator once',
        learn_more: 'Learn more',
        profile_detail:
            'Complete your profile for up to 1000 EcoCredits, including profile pic (200), user name (100), contact info (300), address (200), and birthday (200).',
        exceeded_counts: 'Failed to redeem. You have exceeded the redemption limit.',
        grab_title: 'Grab an EcoCredits Bonus',
        grab_sub_title: 'Exclusive limited-time offers for EcoCredit members. Click to claim now!',
        grab_btn_text: 'Grab My Bonus',
        grab_success_title: 'Congratulations',
        grab_success_text1: 'Bonus claimed successfully!\n Paste the code at checkout to get your discount.',
        grab_success_text2: 'Check your bonuses in <code>My Rewards</code>.',
        'no-grab-content-note': 'More offers coming soon!',
        copy_desc_2: 'You have copied the code.',
        city_validatino_error: 'Invalid city',
        product_text: 'Product',
        shipping_address_text: 'Shipping address',
        saved_address_text: 'Saved addresses',
        use_new_address: 'use a new address',
        spend_now: 'Spend Now',
        stock_left: '{stock} Left',
        no_stock_tip: 'Coming soon... Stay tuned!',
        order_text: 'Order',
        campaign_time_limit_text: 'Valid redemption period: {startTime} - {endTime}.',
        event_action_text: 'Event',
        warranty_minus_action_text: 'Warranty Deleted',
        question_correctly: 'Answer the question correctly',
        follow_instagram_text: 'Follow Instagram',
        follow_x_text: 'Follow X',
        follow_youtube_text: 'Follow YouTube',
        follow_facebook_text: 'Follow Facebook',
        join_facebook_text: 'Join Us On Facebook',
        referral_correctly: 'Referral program',
        confirm_btn_text: 'Close',
        lucky_turntable_title: 'Lucky Draw',
        lucky_turntable_title2: 'Lucky Draw',
        join_lucky_with_points: 'It costs you {points} EcoCredits to do one round of Lucky Spin.',
        join_lucky_with_points2: 'It costs you {points} EcoCredits to play a round.',
        join_lucky_desc: 'Spin the wheel and get a great prize!',
        remaining_number: '<code></code> spins left',
        remaining_number2: '<code></code> flips left',
        learn_lucky_rule: 'Learn more about the rules',
        prize_coupon_title: 'Congratulations',
        prize_coupon_sub_title: 'The prize was claimed successfully! Use the code at checkout to save.',
        prize_coupon_action: 'Check your prizes in <code>My Rewards</code>.',
        prize_coupon_button: 'Shop Now',
        prize_points_title: 'Congratulations',
        prize_points_desc: 'Check the just-added EcoCredits in <code>My Activity</code>.',
        limit_times_in_day: 'You can spin the wheels <count></count> times in <day></day> days',
        limit_times_in_day2: 'You can flip the cards <count></count> times in <day></day> days',
        limit_times_in_active: 'During the event, you can spin the wheels up to <count></count> times.',
        limit_times_in_active2: 'During the event, you can flip the cards up to <count></count> times.',
        without_limit_times: 'You can spin the wheels <count></count> times at any time.',
        without_limit_times2: 'You can flip the cards <count></count> times at any time.',
        active_is_unstart: 'This event is coming soon.',
        active_is_ended: 'This event has ended.',
        over_max_count: 'You have exceeded the number of spins available.',
        notice_title: 'Notice',
        members_nav: 'Member-Price',
        referral_nav: 'Refer A Friend',

        points_cash: 'Points Redemption',
        Pending1: 'Pending',
        rollback: 'Returned',
        product_hot_title: 'Hot Picks',
        product_hot_desc: 'Don’t miss out—shop now for exclusive gifts and unbeatable savings!',
        product_refurbished_title: 'Refurbished Products - Get better deals for a limited time!',
        product_refurbished_desc: '17 Oct 2024 09:00 (CEST) - 28 Oct 2024 08:59 (CEST)',
        level_change_log: 'Tier Activity',
        deadline: 'Valid Until',
        history_refresh_member: 'Current Tier: Member',
        history_refresh_plus_member: 'Current Tier: PLUS Member',
        register: 'Register as a Member',
        upgrade: 'Upgrade to PLUS Member',
        demotion: 'Downgrade to Member',
        relegation: 'Maintain as PLUS Member',
        ecoflowbenefits_title: 'EcoCredits Exclusive Benefits',
        ecoflowbenefits_savings: 'More Savings',
        ecoflowbenefits_support: 'More Support',
        ecoflowbenefits_experiences: 'More Experiences',
        ecoflowbenefits_tab_benefits: 'Benefits',
        ecoflowbenefits_tab_tier: 'Tier',
        ecoflowbenefits_tab_plus: 'PLUS MEMBER',
        ecoflowbenefits_tab_normal: 'MEMBER',
        ecoflowbenefits_savings1: 'Earn EcoCredits for Every Purchase',
        ecoflowbenefits_savings2: 'Earn EcoCredits From Successful Friend Sign-ups',
        ecoflowbenefits_savings3: 'Redeem EcoCredits for Discounts',
        ecoflowbenefits_savings4: 'Redeem EcoCredits for Special Gifts',
        ecoflowbenefits_savings5: 'Save 25% OFF at Harvest Hosts',
        ecoflowbenefits_savings5_link: 'Get the Code',
        ecoflowbenefits_savings6: 'Save 10% OFF at Winnebago gears',
        ecoflowbenefits_savings6_link: 'Get the Code',
        ecoflowbenefits_savings7: 'Refer & Earn Up To €500 Cash Reward!',
        ecoflowbenefits_savings7_link: 'Refer Now',
        ecoflowbenefits_savings8: 'Exclusive Birthday Coupon',
        ecoflowbenefits_savings9: 'PLUS Level-up Coupon',
        ecoflowbenefits_savings10: 'PLUS Exclusive Gifts ',
        ecoflowbenefits_savings11: 'Monthly Coupon Pack',
        ecoflowbenefits_savings21: 'Enjoy special Member-only prices (when available)',
        ecoflowbenefits_savings22: 'Use EcoCredits as cash for orders.',
        ecoflowbenefits_savings_tips1: 'Enjoy one free return within one month of purchase.',
        ecoflowbenefits_savings_tips2:
            'Receive a special discount on service charges for out-of-warranty repairs.\nEcoFlow reserves the right to determine the scope of repairs based on the actual situation.',
        ecoflowbenefits_savings_tips3: 'Extend your replacement period to a total of 5 months, allowing you to replace faulty products with new ones.',
        ecoflowbenefits_savings_tips4:
            'If your product is irreparably damaged, you’re eligible for this exclusive benefit. Simply provide proof of shipment for the damaged item along with a screenshot of your PLUS Membership status. Once verified, we’ll send you a replacement right away—no need to wait for us to receive the broken item.\nNote: This service cannot be used together with the extra 4-month replacement benefit.',
        ecoflowbenefits_support1: 'Free Shipping on Most Products',
        ecoflowbenefits_support2: 'Extended Warranty for Selected Products',

        ecoflowbenefits_support3: 'Free Unconditional Return (1 Order)',
        ecoflowbenefits_support4: '12% Discount on Out-of-Warranty Service Charges',
        ecoflowbenefits_support5: 'Extended 4-Month Warranty Replacement',
        ecoflowbenefits_support6: 'Express Replacement Service',

        ecoflowbenefits_experiences1: 'Benefits From Our Partners',
        ecoflowbenefits_experiences2: 'Member-Only Event',
        ecoflowbenefits_experiences3: 'New Product Trial Event (Coming Soon)',
        ecoflowbenefits_experiences4: 'Exclusive Early Bird Access (Coming Soon)',
        ecoflowbenefits_savings_message: 'Please check <line>here</line> to see how to claim vouchers for PLUS MEMBER.',
        ecoflowbenefits_savings_message_pop1: "1. Don't forget to log into your EcoFlow Account on the EcoCredits page.",
        ecoflowbenefits_savings_message_pop2: '2. You will see the pop-up right away if you have a new voucher to claim.',
        ecoflowbenefits_savings_message_pop3:
            "3. Don't worry if you missed it. Go to the 'gift' icon and check the voucher in \"My Rewards\". Don't forget to use it within the valid time.",
        ecoflowbenefits_support_message: 'Please contact <email>support.eu@ecoflow.com</email> for assistance in using your benefits.',
        ecoflowbenefits_experiences_message: 'Stay tuned with us!',
        eu_activity_nav_title1: 'Lucky Draw',
        eu_activity_nav_title2: 'Refurbished Deals',
        eu_activity_nav_title3: 'Hot Picks',
        eu_activity_nav_title4: 'How It Works',
        eu_activity_nav_title5: 'EcoCredits Exclusive Benefits',
        eu_activity_nav_title6: 'Ways to Earn EcoCredits',
        eu_activity_nav_title7: 'Enjoy More',
        eu_activity_nav_title8: 'Frequently Asked Questions',
        date_of_event: 'Date of Event',
        expiration_date: 'Expiration Date',
        only_plus_member: 'Only PLUS Members can redeem the reward.',
        only_member: 'Only Members can redeem the reward.',

        not_eligible: 'You are not eligible to participate in this event.',
        // 25年会员活动
        first_login_2025: 'First time logging in',
        know_brand_2025: 'Learn more about EcoFlow',
        know_member_2025: 'Learn more about Membership',
        share_story_2025: 'Share my story',
        first_order_2025: 'Complete a purchase',
        repeat_order_2025: 'Make an additional purchase',
    },
    fr: {
        shop1: 'Obtenez 1 EcoCredits pour chaque euro dépensé.',
        warranty1: 'Vous avez obtenu 1 000 EcoCredits en enregistrant votre produit EcoFlow.',
        profile1: 'Vous avez obtenu 1 000 EcoCredits en complétant votre profil.',
        referral1: "Obtenez des EcoCredits pour l'inscription réussie de chaque ami.",
        ins: 'Vous avez obtenu 100 EcoCredits en nous suivant sur Instagram.',
        x: 'Vous avez obtenu 100 EcoCredits en nous suivant sur X.',
        youtube: 'Vous avez obtenu 100 EcoCredits en nous suivant sur YouTube.',
        facebook: 'Vous avez obtenu 100 EcoCredits en nous suivant sur Facebook.',
        line: 'Vous avez gagné 100 EcoCredits en vous inscrivant comme ami sur LINE.',
        joininfacebook: 'Vous avez obtenu 100 EcoCredits en nous rejoignant sur Facebook.',
        subscribe1: 'Vous avez obtenu 500 EcoCredits en vous abonnant.',
        clock_in: 'Confirmation de présence',
        sign_up1: 'Vous avez obtenu 500 EcoCredits en vous inscrivant.',
        sign_up1_1: 'Vous avez obtenu 800 EcoCredits en vous inscrivant.',
        seo_title: 'EcoCredits - Programme de fidélisation',
        seo_desc: "Adhérez au programme de fidélisation EcoCredits d'EcoFlow et commencez à gagner des récompenses ... dès maintenant !",
        how_it_works: 'Fonctionnement',
        sign_up: "S'inscrire",
        sign_up_desc: "Créez un compte gratuitement et commencez votre parcours d'adhésion.",
        earn_points: 'Gagner et utiliser',
        earn_points_desc:
            "Accomplissez des tâches pour obtenir des EcoCredits que vous pouvez utiliser comme de l'argent liquide ou échanger contre des récompenses.",
        redeem_points: 'Profiter plus',
        redeem_points_desc: "Obtenez 6 000 EcoCredits et passez à l'abonnement PLUS pour en profiter davantage.",
        more_benefits: "Profitez d'encore plus d'avantages",
        more_benefits_desc: 'Devenez membre PLUS pour économiser davantage.',
        more_benefits_question: "Une fois que vous avez accumulé 6 000 EcoCredits sur votre compte, vous pouvez passer à l'abonnement PLUS.",
        sign_up_desc_1: 'Créez un compte et obtenez 800 EcoCredits.',
        copy_desc: "Vous avez copié le code, veuillez vous rendre en boutique pour l'utiliser.",
        welcome_text: "Gagnez des points et passez à l'adhésion PLUS pour profiter d'avantages encore plus intéressants.",
        welcome_text_plus: "Profitez d'avantages encore plus intéressants et de réductions plus importantes grâce à votre adhésion PLUS.",
        see_t_c: 'Voir les conditions générales',
        join_subTitle: 'Inscrivez-vous maintenant et cumulez des points pour profiter de réductions et de cadeaux exclusifs.',
        send_your_friend: 'Envoyez {amont} de votre carte-cadeau à un ami.',
        purchase: 'Achat',
        coupon: 'Code de réduction',
        login_capital_letters: 'Se connecter',
        login_capital_letters1: 'Connectez-vous',
        received: 'Reçu',
        subscribe_capital_letters: "S'inscrire",
        birthday_placeholder: 'JJ/MM/AA',
        shop_capital_letters: 'Achetez',
        shop: 'Gagnez des points à chaque achat',
        ecoflow_benefits: 'Avantages des EcoCredits',
        complete_profile: 'Complétez le profil',
        referral: 'Invitez vos proches',
        referral_desc: "Obtenez des EcoCredits pour l'inscription réussie de chaque ami.",
        referral_btn: 'Rejoignez-nous maintenant',
        warranty: 'Enregistrez votre produit EcoFlow',
        points_activity_a: 'Mon activité',
        check_more: 'En savoir plus',
        points_tab_name: 'Historique des activités',
        rewards_tab_name: 'Historique des récompenses',
        coupon_used_desc: 'Servez-vous de ce code à la caisse pour échanger {amont} votre carte-cadeau.',
        email_address: 'Adresse e-mail',
        give_away: 'Jeu-concours',
        add_my_birthday: 'Ajouter mon anniversaire',
        ins_title: 'Suivez-nous sur Instagram',
        ins_desc1: 'Gagnez {points} EcoCredits pour votre premier abonnement à notre compte Instagram.',
        ins_desc2: 'Gagnez {points} EcoCredits pour votre premier abonnement à notre compte Instagram.',
        follow_button: 'Cliquez ici pour vous abonner',
        follow_button_ins: '',
        follow_button_x: '',
        follow_button_youtube: '',
        follow_button_facebook: '',
        facebook_title: 'Suivez-nous sur Facebook',
        facebook_desc1: 'Gagnez {points} EcoCredits pour votre premier abonnement à notre compte Facebook.',
        facebook_desc2: 'Gagnez {points} EcoCredits pour votre premier abonnement à notre compte Facebook.',
        joininfacebook_title: 'Rejoignez-nous sur Facebook',
        joininfacebook_desc1: 'Gagnez {points} EcoCredits si vous rejoignez notre groupe pour la première fois.',
        joininfacebook_desc2: 'Gagnez {points} EcoCredits si vous rejoignez notre groupe pour la première fois.',
        subscribe: 'Abonnez-vous à notre newsletter',
        welcome_top_bar: 'Semaine des EcoCredits x Xmas.\n Acheter dès maintenant >>',
        welcome_title: 'Bonjour {username},',
        welcome_sub_title: 'Bienvenue dans notre programme de fidélité !',
        profile: 'Complétez votre profil',
        status: 'Statut',
        refund: 'Remboursement',
        points_balance: 'Solde des EcoCredits',
        points_progress_tips: 'Nombre de points requis pour devenir {plus} : {points} EcoCredits',
        available: 'Disponible',
        sign_up_text: "500 EcoCredits à l'inscription",
        redeemed_succ: 'Échangées avec succès !',
        current_tier: 'Statut',
        subscribe_now: 'Abonnez-vous dès maintenant',
        date: 'Date',
        used: 'Utilisé',
        edeemed_rewards_note: 'Vos récompenses échangées apparaîtront ici.',
        warranty_capital_letters: "Enregistrement d'un nouveau produit",
        days_rules2: 'Valable à partir de {data}.',
        redeem_now: 'ÉCHANGER MAINTENANT',
        product_rules: 'Pour {product} seulement',
        membership_includes: 'ABONNEMENT INCLUT',
        browse_ecocredits_rewards: 'Consultez les récompenses EcoCredits',
        discount: 'Réduction',
        view_more: 'Afficher plus',
        profile_desc1: "Complétez votre profil et obtenez jusqu'à 1 000 EcoCredits.",
        profile_desc2: "Obtenez jusqu'à 1000 EcoCredits en ajoutant vos coordonnées.",
        points_capital_letters: 'EcoCredits',
        history_note: 'Votre activité apparaîtra ici. Vous ne voyez pas encore votre activité ? Votre activité sera mise à jour dans les 24 heures.',
        lucky_flop_start: 'S’inscrire',
        lucky_flop_congrat: 'Félicitations',
        lucky_flop_get: 'Obtenir mes récompenses',
        lucky_flop_open: 'Retourner',
        rules: 'Règles',
        completed_text: 'Vous avez déjà obtenu cette récompense.',
        redeemed: 'Échangées',
        birthday: 'ANNIVERSAIRE',
        summary_text: 'Le résumé de vos EcoCredits',
        deducted: 'Déduit',
        site_rules: 'Réservé aux clients de la boutique française.',
        subscribe_hover: 'Gagnez 500 EcoCredits lors de votre inscription.',
        subscribe_text: "Abonnez-vous pour recevoir les dernières actualités d'EcoFlow.",
        store: 'Acheter maintenant',
        membership: 'MEMBRE',
        join_now: 'REJOINDRE',
        gift_card: 'Carte-cadeau',
        rewards_redeemed: 'Mes récompenses',
        redeedmed_tab_name: 'Échangé',
        issued_tab_name: 'Émis',
        expired: 'Arrivé à expiration',
        login: 'SE CONNECTER',
        earn_points_title: 'Comment gagner des points\u00A0?',
        have_points: 'Vous avez <code>{points} EcoCredits</code>',
        view_all: 'Voir tout',
        add_your_birthday: 'Ajoutez votre anniversaire',
        earn_point_rule_shop: 'Obtenez 1 EcoCredits pour chaque euro dépensé.',
        off: 'DE RÉDUCTION',
        earn_point_by_order: 'Gagnez des EcoCredits à chaque achat. (1 € = 1 EcoCredit)',
        registered: 'Inscrit',
        birthday_desc2: 'Gagnez {points} EcoCredits lorsque vous ajoutez votre date de naissance.',
        sign_up_desc_h: 'Inscrivez-vous pour devenir membre et obtenir 500 EcoCredits.',
        sign_up_desc_h_1: 'Créez un compte et obtenez 800 EcoCredits.',
        birthday_desc1: 'Ajoutez votre date de naissance pour obtenir des EcoCredits.',
        or_text: 'OU',
        profile_a: 'Profil',
        days_rules: "Valable pendant {days} jours à partir de la date d'échange",
        join_title: 'Rejoignez le programme de fidélité EcoFlow !',
        pending: 'En attente',
        coming_soon: 'À venir',
        expires_in_one_month: 'Expire dans un mois',
        shop_to_earn_points: 'Achetez pour gagner des EcoCredits',
        action: 'Action',
        rewards_title: 'Récompenses',
        question_title: 'Participez au quiz',
        type_title: 'Type',
        discount_type: 'Réduction',
        already_member: 'Êtes-vous déjà membre ?',
        already_member1: 'Vous possédez déjà un compte ?',
        points_activity: 'ACTIVITÉ DES ECOCREDITS',
        use_this_code_note: 'Servez-vous de ce code à la caisse pour échanger <PI1/> votre carte-cadeau.',
        warranty_desc2: '1000 EcoCredits lorsque vous enregistrez un produit.',
        warranty_desc1: 'Enregistrez un produit nouvellement reçu pour obtenir 1 000 EcoCredits.',
        redeem_ecocredits_title: 'Échanger mes points',
        redeem_ecocredits_title_next: 'Transformez vos points en cadeaux et réductions exclusifs disponibles dès maintenant !',
        member_exclusive: '',
        redeem_ecocredits_subtitle_next: "Inscrivez-vous et économisez 50 % d'EcoCredits sur vos accessoires pour système solaire de balcon !",
        redeem_ecocredits_rules_title1: 'Présentation de l’événement:',
        redeem_ecocredits_rules_title2: 'Mécanisme d’événement:',
        redeem_ecocredits_rules_desc1:
            'Ne manquez pas nos offres éphémères d’échange d’EcoCredits contre des cadeaux du 20 au 23 octobre 2023. Des offres spéciales apparaîtront aléatoirement à ces dates !',
        redeem_ecocredits_rules_desc2:
            '1. Découvrez des surprises plus tôt. Abonnez-vous et soyez le premier à connaître les heures de début de ventes flash pour échanger vos récompenses EcoCredits.',
        redeem_ecocredits_rules_desc3:
            '2. Tirez le meilleur parti de vos EcoCredits. Pendant chaque vente flash, bénéficiez d’une réduction allant jusqu’à 50 % en échangeant vos points de récompense. Mais agissez vite ! Le stock de produits participants à la promotion est limitée. Chaque jour, quatre produits uniques seront mis en avant dans la promotion, chacun avec un maximum de 100 unités disponibles.',
        points: 'EcoCredits',
        benefits_item1: 'Gagnez des EcoCredits à chaque achat',
        benefits_item2: 'Échangez des EcoCredits contre des coupons',
        benefits_item3: 'Livraison gratuite sur la plupart des produits',
        benefits_item4: 'Échangez vos EcoCredits contre des cadeaux',
        benefits_item5: 'Garantie prolongée sur certains produits',
        benefits_item6: 'Événements réservés aux membres',
        benefits_item7: "Obtenez des EcoCredits lorsque vos amis s'inscrivent",
        benefits_item8: 'Avantages de nos partenaires',
        benefits_item9: "Rejoignez le programme de parrainage et gagnez jusqu'à 500 € de récompense !",
        benefits_link_btn: 'Parrainer',
        network_error: 'Erreur réseau',
        manually_added: 'Ajout manuel',
        confirm_text: "Voulez-vous vraiment procéder à l'échange ? Vous ne pouvez pas annuler cette action.",
        manually_deducted: 'Déduction manuelle',
        earning_points: "OBTENTION D'ECOCREDITS",
        confirm_btn: 'Confirmer',
        faq_title: 'Foire aux questions',
        no_enough_points: "Échec de l'échange, vos EcoCredits ne sont pas suffisants",
        no_history_note: 'Vous ne voyez pas encore vos EcoCredits ? Votre activité sera mise à jour dans les 24 heures.',
        no_coupon_note: 'Aucune récompense échangée pour le moment.',
        minimum_price: "Montant minimum d'achat : {price}.",
        minimum_num: "Quantité minimum d'articles ({num} articles).",
        stay_too_long: 'Votre session a expiré. Veuillez actualiser la page et réessayer.',
        order_rule: 'Un seul code promo par commande.',
        purchas_rule: "Si le prix de l'article est inférieur à la valeur du/des code(s) promo, la différence sera perdue.",
        profile_birthday: 'Profil - Date de naissance',
        profile_address: 'Profil - Adresse',
        profile_username: 'Profil - Nom',
        profile_picture: 'Profil - Photo',
        profile_contact: 'Profil - Informations de contact',
        View_1_Explore_Article: 'Consultez 1 article Explore',
        View_2_Explore_Article: 'Consultez 2 articles Explore',
        View_3_Explore_Article: 'Consultez 3 articles Explore',
        Enable_push_notifications: 'Activer les notifications push',
        Try_the_energy_calculator_once: 'Essayez une fois le calculateur d’énergie',
        learn_more: 'Découvrir',
        profile_detail:
            "Complétez votre profil pour gagner jusqu'à 1000 EcoCredits : photo de profil (200), nom (100), informations de contact (300), adresse (200), et date de naissance (200).",
        exceeded_counts: "Echec de l'échange. Vous avez dépassé la limite d'échanges.",
        grab_title: 'Obtenez un bonus EcoCredits',
        grab_sub_title: 'Offres exclusives à durée limitée pour les membres EcoCredits. Cliquez pour en profiter maintenant !',
        grab_btn_text: 'Récupérer mon bonus',
        grab_success_title: 'Félicitations',
        grab_success_text1: 'Vous avez récupéré votre bonus !\n Utilisez le code lors du paiement pour obtenir votre réduction.',
        grab_success_text2: 'Consultez vos bonus dans l\'espace <code>"Mes récompenses"</code>.',
        'no-grab-content-note': "Plus d'offres à venir",
        copy_desc_2: 'Vous avez copié le code.',
        city_validatino_error: 'Ville non valide',
        product_text: 'Produit',
        shipping_address_text: 'Adresse de livraison',
        saved_address_text: 'Adresses enregistrées',
        use_new_address: 'Utiliser une nouvelle adresse',
        spend_now: 'Utiliser maintenant',
        stock_left: '{stock} restants',
        no_stock_tip: "Bientôt disponible...Restez à l'écoute !",
        order_text: 'Commande',
        campaign_time_limit_text: 'Période de remboursement valide: {startTime} - {endTime}.',
        event_action_text: 'Activité',
        warranty_minus_action_text: 'Garantie supprimée',
        question_correctly: 'Saurez-vous répondre à cette question',
        follow_instagram_text: 'Suivez-nous sur Instagram',
        follow_facebook_text: 'Suivez-nous sur Facebook',
        join_facebook_text: 'Rejoignez-nous sur Facebook',
        referral_correctly: 'Programme de parrainage',
        confirm_btn_text: 'Fermer',
        lucky_turntable_title: 'Tirage au sort',
        lucky_turntable_title2: 'Tirage au sort',
        join_lucky_with_points: 'Lorsque que vous effectuez un tour au Lucky Spin, cela vous coûte {points} EcoCredits.',
        join_lucky_with_points2: 'Il vous faut {points} EcoCredits pour jouer un tour.',
        join_lucky_desc: 'Tournez la roue et obtenez une belle récompense !',
        remaining_number: '<code></code> tours restants',
        remaining_number2: '<code></code> tentatives restantes',
        learn_lucky_rule: 'En savoir plus sur les règles',
        prize_coupon_title: 'Félicitations',
        prize_coupon_sub_title: 'Vous avez gagné un prix ! Utilisez ce code au moment du paiement pour bénéficier de votre réduction.',
        prize_coupon_action: 'Vous pouvez consulter vos prix dans <code>Mes récompenses</code>.',
        prize_coupon_button: 'Acheter maintenant',
        prize_points_title: 'Félicitations',
        prize_points_desc: 'Consultez les EcoCredits ajoutés récemment dans <code>Mon activité</code>.',
        limit_times_in_day: 'Vous pouvez tourner les roues <count></count> fois en <day></day> jours',
        limit_times_in_day2: 'Vous pouvez jouer <count></count> fois en <day></day> jours',
        limit_times_in_day_one: 'Vous pouvez tourner les roues <count></count> fois en <day></day> jour',
        limit_times_in_active: 'Pendant l’événement, vous pouvez tournez les roues jusqu’à <count></count> fois.',
        limit_times_in_active2: "Pendant les ventes flash, vous pouvez jouer jusqu'à <count></count> fois.",
        without_limit_times: 'Vous pouvez tourner les roues <count></count> fois à tout moment.',
        without_limit_times2: 'Vous pouvez jouer <count></count> fois à tout moment.',
        active_is_unstart: 'Cet événement va bientôt commencer.',
        active_is_ended: 'Cet événement est terminé. ',
        over_max_count: 'Vous avez dépassé le nombre de tours disponibles. ',
        notice_title: 'Avis',
        members_nav: 'Prix exclusifs',
        referral_nav: 'Parrainer un ami',

        points_cash: 'Remboursement en Points',
        Pending1: 'En Attente',
        rollback: 'Remboursé',
        product_hot_title: 'Les meilleures offres du moment',
        product_hot_desc: 'Achetez maintenant pour profiter de réductions imbattables et recevoir des cadeaux exclusifs !',
        product_refurbished_title: "Profitez d'offres exceptionnelles sur nos produits reconditionnés",
        product_refurbished_desc: '17/10/2024 09:00 (CEST) - 28/10/2024 08:59 (CEST) ',
        level_change_log: 'Activité',
        deadline: "Date d'expiration",
        history_refresh_member: 'Membre',
        history_refresh_plus_member: 'Membre PLUS',
        register: "S'inscrire",
        upgrade: 'Devenir membre PLUS',
        demotion: 'Annuler mon adhésion PLUS',
        relegation: 'Rester membre PLUS',
        ecoflowbenefits_nav: 'Avantages',
        ecoflowbenefits_title: 'Découvrez tous les avantages de notre programme de fidélité\u00A0!',
        ecoflowbenefits_savings: 'Économisez plus',
        ecoflowbenefits_support: 'Service étendu',
        ecoflowbenefits_experiences: 'Avantages VIP',
        ecoflowbenefits_tab_benefits: 'Avantages',
        ecoflowbenefits_tab_tier: 'Niveau',
        ecoflowbenefits_tab_plus: 'Membre PLUS',
        ecoflowbenefits_tab_normal: 'Membre',
        ecoflowbenefits_savings1: 'Gagnez des points à chaque achat',
        ecoflowbenefits_savings2: 'Obtenez des points pour chaque inscription parrainée',
        ecoflowbenefits_savings3: 'Échangez vos points contre des coupons et des cadeaux',
        ecoflowbenefits_savings4: 'Échangez vos EcoCredits contre des cadeaux exclusifs',
        ecoflowbenefits_savings5: 'Save 25% OFF at Harvest Hosts',
        ecoflowbenefits_savings5_link: 'Get the Code',
        ecoflowbenefits_savings6: 'Save 10% OFF at Winnebago gears',
        ecoflowbenefits_savings6_link: 'Get the Code',
        ecoflowbenefits_savings7: "Invitez vos proches et gagnez jusqu'à 500 € de récompense !",
        ecoflowbenefits_savings7_link: 'Parrainer >',
        ecoflowbenefits_savings8: "Bon d'anniversaire",
        ecoflowbenefits_savings9: 'Coupon spécial PLUS',
        ecoflowbenefits_savings10: 'Cadeaux PLUS',
        ecoflowbenefits_savings11: 'Lot de coupons',
        ecoflowbenefits_savings21: "Profitez de tarifs spéciaux réservés aux membres (lorsqu'ils sont disponibles)",
        ecoflowbenefits_savings22: "Utilisez les EcoCredits comme de l'argent liquide pour vos commandes.",
        ecoflowbenefits_savings_tips1: "Profitez d'un retour gratuit dans le mois suivant l'achat.",
        ecoflowbenefits_savings_tips2:
            "Bénéficiez d'une réduction spéciale sur les frais de service pour les réparations hors garantie.\nEcoFlow se réserve le droit de déterminer l'étendue des réparations en fonction de la situation réelle.",
        ecoflowbenefits_savings_tips3: "Bénéficiez d'une extension de votre période de remplacement gratuit de 4 mois pour un total de 5 mois.",
        ecoflowbenefits_savings_tips4:
            "Si votre produit est irrémédiablement endommagé, vous êtes éligible à cet avantage exclusif. Il suffit de fournir une preuve d'expédition pour l'article endommagé ainsi qu'une capture d'écran de votre statut d'abonnement PLUS. Après vérification, nous vous enverrons un remplacement immédiatement ; pas besoin d’attendre que nous recevions l’article cassé.\nRemarque : Ce service ne peut pas être utilisé en même temps que la garantie de remplacement gratuit de 5 mois.",
        ecoflowbenefits_support1: 'Livraison gratuite sur la plupart des produits',
        ecoflowbenefits_support2: 'Garantie prolongée sur certains produits',
        ecoflowbenefits_support3: 'Retour gratuit sans conditions (1 commande)',
        ecoflowbenefits_support4: '12 % de réduction sur les frais de service hors garantie',
        ecoflowbenefits_support5: '5 mois de remplacement gratuit en cas de problème de qualité',
        ecoflowbenefits_support6: 'Service de remplacement express',
        ecoflowbenefits_experiences1: 'Avantages de nos partenaires',
        ecoflowbenefits_experiences2: 'Événements réservés aux membres',
        ecoflowbenefits_experiences3: 'Essai de nouveaux produits (bientôt disponible)',
        ecoflowbenefits_experiences4: 'Exclusive Early Bird Access (Coming Soon)',
        ecoflowbenefits_savings_message: 'Vous pouvez réclamer vos bons de réduction PLUS <line>ici</line>.',
        ecoflowbenefits_savings_message_pop1: "1. N'oubliez pas de vous connecter à votre compte EcoFlow sur la page du programme de fidélité.",
        ecoflowbenefits_savings_message_pop2: '2. Vous verrez immédiatement la fenêtre contextuelle si vous avez un nouveau bon à réclamer.',
        ecoflowbenefits_savings_message_pop3:
            "3. Ne vous inquiétez pas si vous l'avez manqué. Cliquez simplement sur l'icône du cadeau pour consulter votre bon dans la section « Mes récompenses ». N'oubliez pas de l'utiliser avant sa date d'expiration.",
        ecoflowbenefits_support_message: "Veuillez contacter <email>support.eu@ecoflow.com</email> pour obtenir de l'aide sur l'utilisation de vos avantages.",
        ecoflowbenefits_experiences_message: "Restez à l'écoute !",
        eu_activity_nav_title1: 'Tirage au sort',
        eu_activity_nav_title2: 'Offres sur les produits reconditionnés',
        eu_activity_nav_title3: 'Les meilleures offres du moment',
        eu_activity_nav_title4: 'Comment ça marche ?',
        eu_activity_nav_title5: 'Avantages',
        eu_activity_nav_title6: 'Comment gagner des EcoCredits ?',
        eu_activity_nav_title7: 'Échanger mes points',
        eu_activity_nav_title8: 'Foire aux questions',
        date_of_event: "Date de l'événement",
        expiration_date: "Date d'expiration",
        only_plus_member: 'Seuls les membres PLUS peuvent accéder à cette récompense.',
        only_member: 'Seuls les membres peuvent accéder à cette récompense.',
        not_eligible: "Vous n'êtes pas éligible pour participer à cet événement.",
        // 25年会员活动
        first_login_2025: 'Créer un compte',
        know_brand_2025: "À propos d'EcoFlow",
        know_member_2025: 'Programme de fidélité',
        share_story_2025: 'Partager mon expérience',
        first_order_2025: 'Effectuer un achat',
        repeat_order_2025: 'Effectuer un achat supplémentaire',
    },
    it: {
        shop1: 'Ottieni 1 EcoCredits per ogni euro speso.',
        warranty1: 'Hai guadagnato 1.000 EcoCredits registrando un prodotto.',
        profile1: 'Hai guadagnato 1.000 EcoCredits completando il tuo profilo.',
        referral1: 'Ottieni EcoCredit per ogni registrazione andata a buon fine da parte di un amico.',
        ins: 'Hai guadagnato 100 EcoCredits seguendoci su Instagram.',
        x: 'Hai guadagnato 100 EcoCredits seguendoci su X.',
        youtube: 'Hai guadagnato 100 EcoCredits seguendoci su YouTube.',
        facebook: 'Hai guadagnato 100 EcoCredits seguendoci su Facebook.',
        line: 'Hai guadagnato 100 EcoCredits registrandoti come amico su LINE.',
        joininfacebook: 'Hai guadagnato 100 EcoCredits unendoti alla nostra community su Facebook.',
        subscribe1: 'Hai guadagnato 500 EcoCredits iscrivendoti.',
        clock_in: 'Check-in',
        seo_title: 'EcoCredits - Programma fedeltà',
        seo_desc: 'Diventa subito membro del programma fedeltà EcoCredits di EcoFlow e ricevi EcoCredits e premi esclusivi con ogni acquisto.',
        how_it_works: 'Come funziona',
        sign_up: 'Iscriviti',
        sign_up_desc: 'Crea un account gratuitamente e inizia il tuo programma fedeltà.',
        earn_points: 'Guadagna e utilizza',
        earn_points_desc: 'Completa le attività per ottenere EcoCredit da utilizzare come denaro o per riscattare premi.',
        redeem_points: 'Goditi più vantaggi',
        redeem_points_desc: 'Ottieni 6000 EcoCredit e passa a un abbonamento PLUS per ottenere di più.',
        more_benefits: 'PIÙ VANTAGGI',
        more_benefits_desc: 'Diventa un CLIENTE PLUS per risparmiare ancora di più.',
        more_benefits_question: 'Una volta che hai 6000 EcoCredit nel tuo account, puoi passare a un abbonamento PLUS.',
        sign_up_desc_1: 'Crea un account e ricevi 800 EcoCredits.',
        sign_up1: 'Hai guadagnato 500 EcoCredits registrandoti.',
        sign_up1_1: 'Hai guadagnato 800 EcoCredits registrandoti.',
        copy_desc: 'Hai copiato il codice, vai nel negozio per utilizzarlo.',
        welcome_text: 'Ottieni più EcoCredits e passa al livello PLUS per ricevere premi ancora più esclusivi.',
        welcome_text_plus: 'Approfitta dei nuovi vantaggi scelti appositamente per te per risparmiare e goderti un’esperienza ancora più unica!',
        see_t_c: 'Consulta i Termini e le condizioni',
        join_subTitle: 'Diventa un membro subito e ricevi degli EcoCredits per le detrazioni in denaro e premi in esclusiva.',
        send_your_friend: 'Invia il tuo buono regalo di {amont} a un amico.',
        purchase: 'Acquisto',
        coupon: 'Codice di sconto',
        login_capital_letters: 'Accedi',
        login_capital_letters1: 'Accedi',
        received: 'Ricevuti',
        subscribe_capital_letters: 'Iscriviti',
        birthday_placeholder: 'GG / MM / AA',
        shop_capital_letters: 'Acquista',
        shop: 'Fare La Spesa',
        ecoflow_benefits: 'Benefici di EcoCredits',
        complete_profile: 'Completa il profilo',
        referral: 'Invita I Tuoi Amici',
        referral_desc: 'Ottieni EcoCredit per ogni registrazione andata a buon fine da parte di un amico.',
        referral_btn: 'Unisciti ora',
        warranty: 'Garanzia',
        points_activity_a: 'La Mia Attività',
        check_more: 'Verifica altro',
        points_tab_name: "EcoCredits d'Attività",
        rewards_tab_name: "Pemi d'Attività",
        coupon_used_desc: 'Usa questo codice alla cassa per riscattare il tuo buono regalo di {amont}.',
        email_address: 'Indirizzo e-mail',
        give_away: 'Omaggio',
        add_my_birthday: 'Aggiungi il mio compleanno',
        ins_title: 'Seguici su Instagram',
        ins_desc1: 'Guadagna {points} EcoCredits quando inizi a seguirci.',
        ins_desc2: 'Guadagna {points} EcoCredits quando inizi a seguirci.',
        follow_button: 'Seguici ora',
        follow_button_ins: '',
        follow_button_x: '',
        follow_button_youtube: '',
        follow_button_facebook: '',
        facebook_title: 'Seguici su Facebook',
        facebook_desc1: 'Guadagna {points} EcoCredits quando inizi a seguirci.',
        facebook_desc2: 'Guadagna {points} EcoCredits quando inizi a seguirci.',
        joininfacebook_title: 'Unisciti a noi su Facebook',
        joininfacebook_desc1: 'Guadagna {points} EcoCredits quando inizi a seguirci.',
        joininfacebook_desc2: 'Guadagna {points} EcoCredits quando inizi a seguirci.',
        subscribe: 'Iscriviti',
        welcome_top_bar: 'Settimana degli EcoCredits x Xmas.\n Compra Ora >>',
        welcome_title: 'Ciao {username}',
        welcome_sub_title: 'Benvenuti nel programma di ricompensa EcoCredits.',
        profile: 'Completa il profilo',
        status: 'Stato',
        refund: 'Rimborso',
        points_balance: 'Saldo dei EcoCredits',
        points_progress_tips: 'EcoCredits necessari per raggiungere il livello di {plus}: {points} EcoCredits',
        available: 'Disponibili',
        sign_up_text: "500 EcoCredits all'iscrizione",
        redeemed_succ: 'Riscattato correttamente!',
        current_tier: 'Livello attuale',
        subscribe_now: 'Iscriviti ora',
        date: 'Data',
        used: 'Utilizzati',
        edeemed_rewards_note: 'Le tue ricompense riscattate saranno visualizzate qui.',
        warranty_capital_letters: 'Registrazione della garanzia',
        days_rules2: 'Valido dal {data}.',
        redeem_now: 'RISCATTA ORA',
        product_rules: 'Solo per {product}',
        membership_includes: "L'ISCRIZIONE INCLUDE",
        browse_ecocredits_rewards: 'Sfoglia le ricompense EcoCredits',
        discount: 'Sconto',
        view_more: 'Vedi di più',
        profile_desc1: 'Completa il tuo profilo per ottenere fino a 1000 EcoCredit.',
        profile_desc2: 'Ottieni fino a 1000 EcoCredits per aggiungere i tuoi dati.',
        points_capital_letters: 'EcoCredits',
        history_note:
            "I tuoi EcoCredits d'attività apparanno qui. Non vedi ancora i tuoi EcoCredits d'attività? I tuoi EcoCredits d'attività veranno aggiornata entro 24 ore.",
        lucky_flop_start: 'Unisciti ora',
        lucky_flop_congrat: 'Congratulazioni',
        lucky_flop_get: 'Richiedi',
        lucky_flop_open: 'SCOPRI',
        rules: 'Regole',
        completed_text: 'Hai già ottenuto questa ricompensa.',
        redeemed: 'Riscattate',
        birthday: 'COMPLEANNO',
        summary_text: 'Panoramica del tuo account EcoCredits',
        deducted: 'Detratto',
        site_rules: 'Solo per il negozio italiana.',
        subscribe_hover: "Guadagna 500 EcoCredits all'iscrizione.",
        subscribe_text: 'Iscriviti per ricevere le ultime notizie da EcoFlow.',
        store: 'Acquista ora',
        membership: 'MEMBERO',
        join_now: 'ISCRIVITI ORA',
        gift_card: 'Buono regalo',
        rewards_redeemed: 'Premi',
        redeedmed_tab_name: 'Riscattato',
        issued_tab_name: 'Emessi',
        expired: 'Scaduti',
        login: 'ACCEDI',
        earn_points_title: 'Come guadagnare EcoCredits',
        have_points: 'Hai <code>{points} EcoCredits</code>',
        view_all: 'Visualizza tutti',
        add_your_birthday: 'Aggiungi il compleanno',
        earn_point_rule_shop: 'Ottieni 1 EcoCredits per ogni euro speso.',
        off: 'OFF',
        earn_point_by_order: 'Guadagna EcoCredit ogni volta che fai acquisti. (1 € = 1 EcoCredit)',
        registered: 'Registrati',
        birthday_desc2: 'Guadagna {points} EcoCredits aggiungendo la data del tuo compleanno.',
        sign_up_desc_h: 'Iscriviti al programma fedeltà per 500 EcoCredit.',
        sign_up_desc_h_1: 'Crea un account e ricevi 800 EcoCredits.',
        birthday_desc1: 'Aggiungi la data del tuo compleanno per ricevere EcoCredits.',
        or_text: 'OPPURE',
        profile_a: 'Profilo',
        days_rules: 'Valido per {days} giorni dal riscatto',
        join_title: 'Partecipa al programma di ricompense EcoCredits',
        pending: 'In sospeso',
        coming_soon: 'In arrivo',
        expires_in_one_month: 'In scadenza tra un mese',
        shop_to_earn_points: 'Acquista per guadagnare EcoCredits.',
        action: 'Azione',
        rewards_title: 'Premi',
        question_title: 'Fai il quiz',
        type_title: 'Tipo',
        discount_type: 'Sconto',
        already_member: 'Sei già iscritto/a?',
        already_member1: 'Sei già iscritto/a?',
        points_activity: 'ATTIVITÀ EcoCredits',
        use_this_code_note: 'Usa questo codice alla cassa per riscattare il tuo buono regalo di <PI1/>.',
        warranty_desc2: 'Ottieni1000 EcoCredits quando registri un prodotto.',
        warranty_desc1: 'Registra un prodotto appena ricevuto per 1000 EcoCredit.',
        redeem_ecocredits_title: 'Riscatta i premi',
        redeem_ecocredits_title_next: "Sono disponibili premi e sconti sui nuoi prodotti da riscattare. Non perderti l'occasione!",
        member_exclusive: 'Prezzi esclusivi per i soci',
        redeem_ecocredits_subtitle_next: '¡Regístrate ahora y obtén accesorios para el Kit solar para balcones canjeando un 50 % menos de EcoCredits!',
        redeem_ecocredits_rules_title1: 'Introduzione dell’evento:',
        redeem_ecocredits_rules_title2: 'Meccanismo dell’evento:',
        redeem_ecocredits_rules_desc1:
            'Partecipa ai nostri eventi pop-up di sconto Riscatta le ricompense EcoCredits, tra il 20 e il 23 Ottobre 2023. I pop-up appariranno in modo casuale in quei giorni!',
        redeem_ecocredits_rules_desc2:
            '1. Scarta la sorpresa per primo: Iscriviti e scoprirai prima di chiunque altro l’ora d’inizio degli eventi Riscatta le ricompense EcoCredits.',
        redeem_ecocredits_rules_desc3:
            '2. Aumenta i tuoi EcoCredits: Durante ogni evento pop-up, potrai usufruire di uno sconto scambio punti fino al 50%. Ma sbrigati! Le quantità dei prodotti sono limitate. Ogni giorno, quattro prodotti unici verranno presentati nella promozione, ognuno dei quali sarà disponibili in un massimo di 100 unità.',
        points: 'EcoCredits',
        benefits_item1: 'Guadagna EcoCredits con ogni acquisto',
        benefits_item2: 'Riscatta gli EcoCredits per ricevere un buono sconto',
        benefits_item3: 'Spedizione gratuita per la maggior parte dei prodotti',
        benefits_item4: 'Riscatta gli EcoCredits per ricevere regali speciali',
        benefits_item5: 'Garanzia estesa per prodotti selezionati',
        benefits_item6: 'Evento per i soli membri',
        benefits_item7: 'Guadagna EcoCredits dalle iscrizioni di amici',
        benefits_item8: 'Vantaggi offerti dai nostri partner',
        benefits_item9: 'Invia referral e ricevi un premio di fino a 500 € in denaro!',
        benefits_link_btn: 'Invita ora',
        network_error: 'Errore di rete',
        manually_added: 'Aggiunti manualmente',
        confirm_text: 'Riscattare i EcoCredits? Questa azione non può essere annullata.',
        manually_deducted: 'Detratti manualmente',
        earning_points: 'GUADAGNARE EcoCredits',
        confirm_btn: 'Conferma',
        faq_title: 'Domande frequenti',
        no_enough_points: 'Riscossione non riuscita, non hai abbastanza EcoCredits',
        no_history_note: 'Non vedi ancora i tuoi EcoCredits? La tua attività verrà aggiornata entro le 24 ore.',
        no_coupon_note: 'Nessun premio riscattato ancora.',
        minimum_price: 'Importo minimo di acquisto ({price}).',
        minimum_num: 'Quantità minima di articoli ({num} pezzi).',
        stay_too_long: 'La tua sessione è scaduta. Si prega di ricaricare la pagina e riprovare.',
        order_rule: "Un solo codice sconto per un'ordine.",
        purchas_rule: "Se il costo dell'articolo è inferiore dei coupon, la differenza andrà persa.",
        profile_birthday: 'Profilo - Data di nascita',
        profile_address: 'Profilo - Indirizzo',
        profile_username: 'Profilo - Nome',
        profile_picture: 'Profilo - Foto',
        profile_contact: 'Profilo - Informazioni di contatto',
        View_1_Explore_Article: 'Visualizza 1 articolo Explore',
        View_2_Explore_Article: 'Visualizza 2 articoli Explore',
        View_3_Explore_Article: 'Visualizza 3 articoli Explore',
        Enable_push_notifications: 'Attiva le notifiche push',
        Try_the_energy_calculator_once: 'Prova una volta il calcolatore energetico',
        learn_more: 'Ulteriori informazioni',
        profile_detail:
            "Completa il tuo profilo per guadagnare un massimo di 1000 EcoCredits, inclusa la foto del profilo (200), il nome utente (100), le informazioni di contatto (300), l'indirizzo (200) e il compleanno (200).",
        exceeded_counts: 'Non è stato possibile riscattare. È stato superato il limite di riscatto.',
        grab_title: 'Ottieni il bonus EcoCredits',
        grab_sub_title: 'Offerte esclusive a tempo limitato per i membri di EcoCredit. Clicca per reclamare il bonus ora',
        grab_btn_text: 'Prendi il mio bonus',
        grab_success_title: 'Congratulazioni',
        grab_success_text1: 'Bonus richiesto con successo!\n Incolla il codice alla cassa per ottenere lo sconto.',
        grab_success_text2: 'Controlla i tuoi bonus in <code>I miei premi</code>.',
        'no-grab-content-note': 'Ulteriori offerte in arrivo!',
        copy_desc_2: 'Hai copiato il codice.',
        city_validatino_error: 'Città non valido',
        product_text: 'Prodotto',
        shipping_address_text: "L'indirizzo di spedizione",
        saved_address_text: 'Indirizzi salvati',
        use_new_address: 'Utilizza un nuovo indirizzo',
        spend_now: 'Spendi ora',
        stock_left: '{stock} Rimasti',
        no_stock_tip: 'Prossimamente... Rimani sintonizzato',
        order_text: 'Ordine',
        campaign_time_limit_text: 'Periodo di riscatto valido: {startTime} - {endTime}.',
        event_action_text: 'Attività',
        warranty_minus_action_text: 'Garanzia eliminata',
        question_correctly: 'Rispondi correttamente alla domanda',
        follow_instagram_text: 'Seguici su Instagram',
        follow_facebook_text: 'Seguici su Facebook',
        join_facebook_text: 'Unisciti a noi su Facebook',
        referral_correctly: 'rogramma di referral',
        confirm_btn_text: 'Chiudi',
        lucky_turntable_title: 'Giro fortunato',
        lucky_turntable_title2: 'Estrazione fortunata',
        join_lucky_with_points: 'Un giro fortunato costa {points} EcoCredit.',
        join_lucky_with_points2: 'Giocare una mano costa {points} EcoCredits.',
        join_lucky_desc: 'Gira la ruota e vinci un premio! ',
        remaining_number: 'Ancora <code></code> tentativi',
        remaining_number2: '<code></code> tentativi rimasti',
        learn_lucky_rule: 'Ulteriori informazioni sulle regole',
        prize_coupon_title: 'Congratulazioni',
        prize_coupon_sub_title: 'Il premio è stato richiesto correttamente! Utilizza questo codice al momento del pagamento per risparmiare.',
        prize_coupon_action: 'Controlla i tuoi premi in <code>I miei premi</code>.',
        prize_coupon_button: 'Acquista ora',
        prize_points_title: 'Congratulazioni',
        prize_points_desc: 'Controlla gli EcoCredits appena aggiunti in <code>Le mie attività</code>.',
        limit_times_in_day: 'Puoi girare la ruota per <count></count> volte in <day></day> giorni',
        limit_times_in_day2: 'Puoi girare le carte <count></count> volte in <day></day> giorni',
        limit_times_in_active: 'Durante l’evento, puoi girare la ruota fino a <count></count> volte.',
        limit_times_in_active2: 'Durante l’evento, puoi girare le carte fino a <count></count> volte.',
        without_limit_times: 'Puoi girare la ruota <count></count> volte in qualsiasi momento.',
        without_limit_times2: 'Puoi girare le carte <count></count> volte in qualsiasi momento.',
        active_is_unstart: 'Questo evento inizierà a breve.',
        active_is_ended: 'Questo evento è terminato.',
        over_max_count: 'Hai superato il numero di giri a disposizione.',
        notice_title: 'Avviso',

        members_nav: 'Prezzi per membri',
        referral_nav: 'Invita un amico',

        points_cash: 'Riscatto Punti',
        Pending1: 'In Sospeso',
        rollback: 'Restituito',
        product_hot_title: 'Imperdibili del momento',
        product_hot_desc: 'Non perdere l’occasione: acquista ora per beneficiare di regali esclusivi e sconti imbattibili!',
        product_refurbished_title: 'Prodotti ricondizionati – Approfitta di offerte ancora più vantaggiose per un periodo di tempo limitato!',
        product_refurbished_desc: 'Dalle 09:00 (CEST) del 17/10/2024 alle 08:59 (CEST) del 28/10/2024',
        level_change_log: 'Attività livelli',
        deadline: 'Valido fino a',
        history_refresh_member: 'Livello attuale: cliente',
        history_refresh_plus_member: 'Livello attuale: cliente PLUS',
        register: 'Iscriviti come membro',
        upgrade: 'Passa al livello PLUS',
        demotion: 'Effettua il downgrade al livello Cliente',
        relegation: 'Resta cliente PLUS',
        ecoflowbenefits_title: 'Vantaggi esclusivi con gli EcoCredits',
        ecoflowbenefits_savings: 'Ancora più risparmi',
        ecoflowbenefits_support: 'Necessiti di assistenza?',
        ecoflowbenefits_experiences: 'Più esperienze',
        ecoflowbenefits_tab_benefits: 'Vantaggi',
        ecoflowbenefits_tab_tier: 'Livello',
        ecoflowbenefits_tab_plus: 'CLIENTE PLUS',
        ecoflowbenefits_tab_normal: 'CLIENTE',
        ecoflowbenefits_savings1: 'Guadagna EcoCredits con ogni acquisto',
        ecoflowbenefits_savings2: 'Guadagna EcoCredits dalle iscrizioni di amici',
        ecoflowbenefits_savings3: 'Riscatta gli EcoCredits per ricevere un buono sconto',
        ecoflowbenefits_savings4: 'Riscatta gli EcoCredits per ricevere regali speciali',
        ecoflowbenefits_savings5: 'Save 25% OFF at Harvest Hosts',
        ecoflowbenefits_savings5_link: 'Get the Code',
        ecoflowbenefits_savings6: 'Save 10% OFF at Winnebago gears',
        ecoflowbenefits_savings6_link: 'Get the Code',
        ecoflowbenefits_savings7: 'Invia referral e ricevi un premio di fino a 500 € in denaro!',
        ecoflowbenefits_savings7_link: 'Invita ora',
        ecoflowbenefits_savings8: 'Buono sconto per il tuo compleanno',
        ecoflowbenefits_savings9: 'Buono sconto per il passaggio al livello PLUS',
        ecoflowbenefits_savings10: 'Regali esclusivi per i clienti PLUS',
        ecoflowbenefits_savings11: 'Una vasta selezione di buoni sconto ogni mese',
        ecoflowbenefits_savings21: 'Approfitta di prezzi speciali riservati ai membri (quando disponibili)',
        ecoflowbenefits_savings22: 'Utilizza EcoCredit come contanti per gli ordini.',
        ecoflowbenefits_savings_tips1:
            'Prolungando il periodo di garanzia fino a 5 mesi potrai sostituire i prodotti difettosi con equivalenti privi di difetti.',
        ecoflowbenefits_savings_tips2:
            "Ottieni uno sconto speciale sulle riparazioni fuori garanzia.\nEcoFlow si riserva il diritto di stabilire l'entità delle riparazioni in base al singolo caso.",
        ecoflowbenefits_savings_tips3:
            'Prolungando il periodo di garanzia fino a 5 mesi potrai sostituire i prodotti difettosi con equivalenti privi di difetti.',
        ecoflowbenefits_savings_tips4:
            'Se il tuo prodotto è irreparabilmente danneggiato, hai diritto a questo vantaggio esclusivo. Tutto ciò che devi fare è fornire una prova dell’avvenuta spedizione dell’articolo danneggiato, insieme a uno screenshot del tuo stato di adesione al livello PLUS del programma fedeltà. Una volta eseguita la verifica, ti invieremo immediatamente un prodotto sostitutivo, senza il bisogno di attendere la ricezione dell’articolo rotto.\nNota: questo servizio non è compatibile con la garanzia estesa a 4 mesi per la sostituzione.',
        ecoflowbenefits_support1: 'Spedizione gratuita per la maggior parte dei prodotti',
        ecoflowbenefits_support2: 'Garanzia estesa per prodotti selezionati',
        ecoflowbenefits_support3: 'Reso gratuito e incondizionato (1 ordine)',
        ecoflowbenefits_support4: 'Sconti del 12% sui servizi non coperti da garanzia',
        ecoflowbenefits_support5: 'Garanzia estesa a 4 mesi per la sostituzione',
        ecoflowbenefits_support6: 'Sostituzione espressa',
        ecoflowbenefits_experiences1: 'Vantaggi offerti dai nostri partner',
        ecoflowbenefits_experiences2: 'Evento per i soli membri',
        ecoflowbenefits_experiences3: 'Test di nuovi prodotti (in arrivo)',
        ecoflowbenefits_experiences4: 'Exclusive Early Bird Access (Coming Soon)',
        ecoflowbenefits_savings_message: 'Scopri come <line>ottenere</line> i buoni per i CLIENTI PLUS.',
        ecoflowbenefits_savings_message_pop1: '1. Non dimenticare di accedere al tuo account EcoFlow nella pagina EcoCredits.',
        ecoflowbenefits_savings_message_pop2: '2. Un pop-up ti avviserà se hai nuovi buoni da riscattare.',
        ecoflowbenefits_savings_message_pop3:
            '3. Non lo trovi? Non preoccuparti. Clicca sull’icona a forma di pacco regalo e verifica il buono disponibile nella sezione “I miei premi”. Non scordarti di utilizzare il buono entro la data di scadenza.',
        ecoflowbenefits_support_message:
            'Per ulteriore assistenza su come sfruttare al meglio i tuoi vantaggi, contatta <email>support.eu@ecoflow.com</email>.',
        ecoflowbenefits_experiences_message: 'Segui tutti gli aggiornamenti!',
        eu_activity_nav_title1: '',
        eu_activity_nav_title2: 'Offerte per i prodotti ricondizionati',
        eu_activity_nav_title3: 'Imperdibili del momento',
        eu_activity_nav_title4: 'Come funziona',
        eu_activity_nav_title5: 'Vantaggi esclusivi con gli EcoCredits',
        eu_activity_nav_title6: 'Come guadagnare EcoCredits',
        eu_activity_nav_title7: 'Riscatta i premi',
        eu_activity_nav_title8: 'Domande frequenti',
        date_of_event: 'Data dell’evento',
        expiration_date: 'Data di scadenza',

        only_plus_member: 'Il premio può essere riscattato solo dai clienti PLUS.',
        only_member: 'Il premio può essere riscattato solo dai clienti.',
        not_eligible: 'Non hai l’idoneità per partecipare a questo evento.',
        // 25年会员活动
        first_login_2025: 'Primo accesso',
        know_brand_2025: 'Scopri di più su EcoFlow',
        know_member_2025: 'Scopri di più sul programma fedeltà',
        share_story_2025: 'Raccontaci la tua esperienza',
        first_order_2025: 'Completa un acquisto',
        repeat_order_2025: 'Effettua un altro acquisto',
    },
    jp: {
        shop1: '購入金額に応じてポイント獲得',
        warranty1: '製品の保証登録で1000ポイント獲得',
        profile1: 'プロフィールを入力すると1000ポイント獲得',
        referral1: '友だちを招待して、エコポイントをゲット',
        ins: 'EcoFlowのInstagramをフォローで100ポイント獲得',
        x: 'EcoFlowのXをフォローで100ポイント獲得',
        youtube: 'EcoFlowのYouTubeアカウントをチャンネル登録で100ポイント獲得',
        facebook: 'EcoFlowのFacebookアカウントをフォローで100ポイント獲得',
        line: 'EcoFlowのLINEアカウントをフォローで100ポイント獲得',
        joininfacebook: 'Facebook で参加すると 100 EcoCredits がもらえます。',
        subscribe1: 'EcoFlowのメルマガに登録で500ポイント獲得',
        seo_title: 'サポート | エコポイントご利用ガイド',
        seo_desc: 'エコポイントプログラム特典プログラムとエコポイントのご利用方法についてご紹介しています。',
        how_it_works: '会員の仕組み',
        sign_up: '登録する',
        sign_up_desc: '今すぐ無料でアカウント登録して、会員体験をスタート。',
        earn_points: 'エコポイントを獲得＆利用',
        earn_points_desc: 'タスクを達成するとエコポイントを獲得できます。現金同様に利用、または特典と交換できます。',
        redeem_points: 'さらに楽しむ',
        redeem_points_desc: '6,000エコポイントを獲得するとPLUS会員にアップグレード',
        more_benefits: '優待サービス',
        more_benefits_desc: 'PLUS会員は、PLUS会員優待サービスを獲得できる',
        more_benefits_question: 'PLUS会員なら、さらに多くの特典をお楽しみいただけます。',
        sign_up_desc_1: '初めてアカウント登録すると800ポイントをプレゼント',
        sign_up1: 'EcoFlow会員に登録（無料）で500ポイント獲得',
        sign_up1_1: '新規登録をすると 800 エコポイントがもらえます。',
        copy_desc: 'コードをコピーしました。ストアにアクセスして使用してください。',
        welcome_text: 'PLUS会員にアップグレードして、豊富なPLUS会員優待サービスを獲得しましょう。',
        welcome_text_plus: 'PLUS会員優待サービスを楽しみましょう！',
        see_t_c: 'エコポイント会員規約はこちら',
        join_subTitle: '会員になって、買い物するたびにポイントと限定特典を獲得しましょう。',
        send_your_friend: '{amont}分のギフトカードをお友達に送ることができます。',
        purchase: 'ご購入により獲得',
        coupon: 'ディスカウントコード',
        login_capital_letters: 'ログイン',
        login_capital_letters1: 'ログイン',
        received: '獲得',
        subscribe_capital_letters: 'メルマガ登録',
        birthday_placeholder: 'MM / DD / YY',
        shop_capital_letters: 'お買い物',
        shop: '公式サイトで買い物',
        ecoflow_benefits: 'エコポイント会員になるメリット',
        complete_profile: 'プロフィールを作成',
        referral: 'お友達を紹介',
        referral_desc: '友だちを招待して、エコポイントをゲット',
        referral_btn: 'お友達を紹介',
        warranty: '保証',
        points_activity_a: '私の実績',
        check_more: 'チェックする',
        points_tab_name: 'ポイント実績',
        rewards_tab_name: '特典実績',
        coupon_used_desc: 'チェックアウト時にこのコードを入力して、{amont}分のギフトカードを適用します。',
        email_address: 'メールアドレス',
        give_away: '贈る',
        add_my_birthday: '生年月日を追加',
        ins_title: 'Instagramをフォロー',
        ins_desc1: 'EcoFlowのInstagramをフォローで{points}ポイント獲得',
        ins_desc2: 'EcoFlowのInstagramをフォローで{points}ポイント獲得',
        x_title: 'Xをフォロー',
        x_desc1: 'EcoFlowのXをフォローで{points}ポイント獲得',
        x_desc2: 'EcoFlowのXをフォローで{points}ポイント獲得',
        follow_button: 'フォロー',
        follow_button2: 'LINEアカウントをフォロー',
        follow_button_ins: 'Instagramをフォロー',
        follow_button_x: 'Xをフォロー',
        follow_button_youtube: 'YouTubeチャンネル登録',
        follow_button_facebook: 'Facebookをフォロー',
        youtube_title: 'YouTubeチャンネル登録',
        youtube_desc1: 'EcoFlowのYouTubeアカウントをチャンネル登録で{points}ポイント獲得',
        youtube_desc2: 'EcoFlowのYouTubeアカウントをチャンネル登録で{points}ポイント獲得',
        facebook_title: 'Facebookをフォロー',
        facebook_desc1: 'EcoFlowのFacebookアカウントをフォローで{points}ポイント獲得',
        facebook_desc2: 'EcoFlowのFacebookアカウントをフォローで{points}ポイント獲得',
        line_title: 'LINEアカウントをフォロー',
        line_desc1: 'EcoFlowのLINEアカウントをフォローで{points}ポイント獲得',
        line_desc2: 'EcoFlowのLINEアカウントをフォローで{points}ポイント獲得',
        subscribe: 'メルマガ登録',
        welcome_title: 'こんにちは、{username}さん',
        welcome_sub_title: 'エコポイント特典プログラムにようこそ。',
        profile: 'プロフィールを完成',
        status: 'ステータス',
        refund: '返金',
        points_balance: 'ポイント残高',
        points_progress_tips: '{plus}になるために必要なエコポイント {points} ポイント',
        available: '使用可能',
        sign_up_text: '参加時に500ポイント',
        redeemed_succ: '交換が成功しました！',
        current_tier: '現在のレベル',
        subscribe_now: '今すぐ登録',
        date: '日付',
        used: '使用済み',
        edeemed_rewards_note: '交換した特典はここに表示されます。',
        warranty_capital_letters: '保証登録',
        days_rules2: '*交換後の有効期間は{data}です。',
        redeem_now: '今すぐ交換',
        product_rules: '*{product}のみ対象です。',
        membership_includes: 'メンバーシップに含まれるもの',
        benefits_item1: '購入するたびにポイントを獲得',
        benefits_item2: 'ポイントを特典に交換可能',
        benefits_item3: 'ほとんどの製品が送料無料',
        benefits_item4: 'ポイントを特典に交換可能',
        benefits_item5: '会員登録は無料',
        benefits_item6: '会員登録は無料',
        benefits_item7: '友達に紹介してポイントを獲得',
        benefits_item8: 'パートナー企業からの特典',
        benefits_item9: 'お友達紹介でキャッシュバック 上限なし！',
        benefits_link_btn: 'ログイン',
        browse_ecocredits_rewards: 'エコポイント特典を閲覧',
        discount: 'ディスカウント',
        view_more: '詳細',
        profile_desc1: 'プロフィールをすべて入力すると、最大1,000 ポイントを獲得',
        profile_desc2: '詳細を追加することで最大1000ポイントを獲得できます。',
        points_capital_letters: 'ポイント',
        history_note:
            'あなたのポイントアクティビティーはここに表示されます。まだ受け取ったポイントが表示されていない場合もありますが、受け取り後24時間以内に更新されます。',
        lucky_flop_start: '今すぐ参加する',
        lucky_flop_congrat: 'おめでとうございます',
        lucky_flop_get: '特典をゲット',
        lucky_flop_open: 'めくる',
        rules: '条件',
        completed_text: 'この特典はすでに達成しています。',
        completed_text2: 'この特典はすでに獲得しています。',
        redeemed: '使用済み',
        birthday: 'お誕生日の登録',
        summary_text: 'エコポイントの概要',
        deducted: '利用',
        site_rules: '*EcoFlow Japan公式サイトのストアでのみ適用します。',
        subscribe_hover: '参加時に500ポイントを獲得できます。',
        subscribe_text: 'ニュースレター購読すると、EcoFlowの最新情報をいち早くお届け',
        store: '今すぐ購入',
        membership: '会員',
        join_now: '今すぐ登録する',
        gift_card: 'ギフトカード',
        rewards_redeemed: '獲得した特典',
        redeedmed_tab_name: '交換済',
        issued_tab_name: '発行済',
        expired: '期限切れ',
        login: 'ログイン',
        earn_points_title: 'エコポイントの貯め方',
        have_points: '<code>{points}ポイント</code>があります',
        view_all: 'すべて表示',
        add_your_birthday: '生年月日を追加',
        earn_point_rule_shop: '購入金額に応じてポイント獲得',
        off: 'OFF',
        earn_point_by_order: 'EcoFlowでのお買い物ごとにエコポイントを獲得（150元=1EcoCredits）',
        registered: '登録済み',
        birthday_desc2: '生年月日を追加したときに{points}ポイントを獲得できます。',
        sign_up_desc_h: '会員登録すると、500ポイントを獲得',
        sign_up_desc_h_1: 'EcoFlow会員に登録（無料）で800ポイント獲得',
        birthday_desc1: '生年月日を追加するとポイント獲得',
        or_text: 'または、',
        profile_a: 'プロフィール',
        days_rules: '*交換後、有効期限は{days}日間です。',
        join_title: 'エコポイント特典プログラムに参加',
        pending: '保留中',
        coming_soon: '近日公開予定',
        expires_in_one_month: '1か月後の失効ポイント',
        shop_to_earn_points: '買い物をしてポイントを獲得',
        action: '内容',
        rewards_title: '特典',
        question_title: 'クイズに回答',
        type_title: '種類',
        discount_type: '割引',
        already_member: '会員登録済ですか？',
        already_member1: '会員登録済ですか？',
        points_activity: 'ポイントアクティビティ',
        use_this_code_note: '精算時にこのコードを使用して<PI1/>のギフトカードと交換できます。',
        warranty_desc2: '製品を保証登録いただくと1,000ポイント獲得できます。',
        warranty_desc1: '新しく購入した製品を登録すると、1,000ポイントを獲得',
        redeem_ecocredits_title: 'エコポイントを特典と交換する',
        points: 'ポイント',

        network_error: 'ネットワークエラー',
        manually_added: '手動で追加',
        confirm_text: '本当に交換をしますか？一度交換した特典を取り消すことはできません。',
        manually_deducted: '手動で差し引き',
        earning_points: 'ポイントを獲得する',
        confirm_btn: '確認',
        faq_title: 'よくあるご質問',
        no_enough_points: 'ポイントが不足しているため、交換に失敗しました',
        no_history_note: 'ま⁠だ⁠ポ⁠イ⁠ン⁠ト⁠が⁠表⁠示⁠さ⁠れ⁠な⁠い⁠場⁠合⁠も⁠あ⁠り⁠ま⁠す⁠が、ア⁠ク⁠テ⁠ィ⁠ビ⁠テ⁠ィ⁠は24時⁠間⁠以⁠内⁠に⁠更⁠新⁠さ⁠れ⁠ま⁠す。',
        no_coupon_note: 'まだ交換済みの特典はありません。',
        minimum_price: '*最低購入金額 ({price})。',
        minimum_num: '*最低購入個数以上 ({num} 個) の購入時に使用可能です。',
        stay_too_long: 'ページに止まる時間が長くて切れました。ページを更新してから確認してください。',
        order_rule: '*割引コードは、1回の注文につき1つしか利用することができません。',
        purchas_rule: '*クーポンの値引き額が商品金額を上回っていた場合、差額分は返金されません。',
        profile_birthday: 'プロファイルーお誕生日',
        profile_address: 'プロファイルー住所',
        profile_username: 'プロファイルーユーザー名',
        profile_picture: 'プロファイルー写真',
        profile_contact: 'プロファイルー連絡先情報',
        View_1_Explore_Article: 'Explore記事を1本閲覧する',
        View_2_Explore_Article: 'Explore記事を2本閲覧する',
        View_3_Explore_Article: 'Explore記事を3本閲覧する',
        Enable_push_notifications: 'プッシュ通知を有効にする',
        Try_the_energy_calculator_once: 'エネルギー計算ツールを1回体験する',
        learn_more: '詳細はこちら',
        profile_detail:
            'プロフィール写真 (200)、ユーザー名 (100)、連絡先情報 (300)、住所 (200)、生年月日 (200) を入力していただくと、1000ポイントを獲得できます。',
        exceeded_counts: '利用限度額を超えているため、交換できません。',
        grab_title: '特典のエコポイントを受け取る',
        grab_sub_title: 'エコポイント会員の期間限定特典があります。ここをクリックして今すぐ受け取りましょう！',
        grab_btn_text: '特典を受け取る',
        grab_success_title: 'おめでとうございます',
        grab_success_text1: '特典を受け取りました！\nチェックアウト時にこのディスカウントコードを入力することで、対象商品の価格が割引されます。',
        grab_success_text2: 'あなたが獲得した特典は<code>「交換済みの特典」</code>で確認できます。',
        'no-grab-content-note': '今後も続々更新予定ですので、ぜひお楽しみに！',
        copy_desc_2: 'コードをコピーしました.',
        city_validatino_error: '市区町村無効です',
        product_text: 'アイテム',
        shipping_address_text: 'お届け先',
        saved_address_text: '登録したお届け先',
        use_new_address: '新しい住所を使用',
        spend_now: 'ポイントを使用',
        stock_left: '残り{stock}個/台',
        no_stock_tip: '在庫切れ',
        order_text: '注文',
        campaign_time_limit_text: '交換有効期間：{startTime} - {endTime}.',
        lucky_turntable_title: 'ラッキールーレットに挑戦',
        join_lucky_with_points: 'エコポイント{points}ptにつきラッキールーレットに1回挑戦できます',
        join_lucky_with_points2: '1回 {points}エコポイントで挑戦できます。',
        join_lucky_desc: 'ルーレットを回してお得なクーポンをゲット！',
        remaining_number: '残り<code></code>回のチャンスがあります',
        remaining_number2: '残りのめくれる回数：<code></code>',
        learn_lucky_rule: '詳しくはこちら',
        prize_coupon_title: 'おめでとうございます',
        prize_coupon_sub_title: '賞品の請求が完了しました！チェックアウト時にコードを使用して保存します。',
        prize_coupon_action: '<code>マイリワード</code>で賞品を確認します。',
        prize_coupon_button: '今すぐ購入',
        prize_points_title: 'おめでとうございます',
        prize_points_desc: '<code>マイアクティビティ</code>で、追加したエコポイントを確認します。',
        limit_times_in_day: '<day></day>日に<count></count>回参加できます',
        limit_times_in_day2: 'カードは <day></day> 日間で <count></count> 回めくれます。',
        limit_times_in_active: 'キャンペーン期間内に<count></count>回参加できます',
        limit_times_in_active2: 'イベント中は、カードを最大 <count></count> 回めくれます。',
        without_limit_times: '有効期限なしでお好きな時に<count></count>回参加できます',
        without_limit_times2: 'カードはいつでも <count></count> 回めくれます。',
        active_is_unstart: 'このイベントはまもなく始まります。',
        active_is_ended: '本キャンペーンは終了しました。',
        over_max_count: '挑戦回数の上限に達しました。',
        event_action_text: 'ゲームに参加',
        warranty_minus_action_text: '保証記録が削除されました',
        question_correctly: '質問に正確に答えてください',
        follow_instagram_text: 'Instagramでフォロー',
        follow_x_text: 'Xでフォロー',
        follow_youtube_text: 'YouTubeでフォロー',
        follow_facebook_text: 'Facebookでフォロー',
        follow_line_text: 'LINEで友だち登録',
        join_facebook_text: 'Facebookでフォロー',
        clock_in: 'チェックイン',
        referral_correctly: '紹介プログラム',
        confirm_btn_text: 'ウィンドウを閉じる',
        notice_title: '※注意事項',

        points_cash: 'ポイント利用',
        Pending1: '保留中',
        rollback: '返却済み',
        level_change_log: 'レベル変動履歴',
        deadline: 'まで有効',
        history_refresh_member: '現在のレベル：会員',
        history_refresh_plus_member: '現在のレベル：PLUS会員',
        register: '会員登録',
        upgrade: 'PLUS会員にアップグレード',
        demotion: '会員にダウングレード',
        relegation: 'PLUS会員資格を保留',
        ecocredits_notice1:
            '2024 年 10 月 17 日にエコポイントのルールを更新しました。エコポイントを使用する前に、更新後の［<line1>エコポイントのルール</line1>］をよくお読みください。',
        ecoflowbenefits_title: 'PLUS会員優待サービス',
        ecoflowbenefits_savings: 'ポイントの優待',
        ecoflowbenefits_support: 'サポートの優待',
        ecoflowbenefits_experiences: '製品体験の優待',
        ecoflowbenefits_tab_benefits: '特典',
        ecoflowbenefits_tab_tier: 'レベル',
        ecoflowbenefits_tab_plus: 'PLUS会員',
        ecoflowbenefits_tab_normal: '会員',
        ecoflowbenefits_savings1: '購入するたびにポイントを獲得',
        ecoflowbenefits_savings2: '友達に紹介してポイントを獲得',
        ecoflowbenefits_savings3: 'ポイントを特典に交換可能',
        ecoflowbenefits_savings4: 'Redeem EcoCredits for Special Gifts',
        ecoflowbenefits_savings5: 'Save 25% OFF at Harvest Hosts',
        ecoflowbenefits_savings5_link: 'Get the Code',
        ecoflowbenefits_savings6: 'Save 10% OFF at Winnebago gears',
        ecoflowbenefits_savings6_link: 'Get the Code',
        ecoflowbenefits_savings7: 'お友達紹介でキャッシュバック 上限なし！',
        ecoflowbenefits_savings7_link: 'ログイン',
        ecoflowbenefits_savings8: 'バースデーポイント2倍',
        ecoflowbenefits_savings9: '決済時より多くのポイントを利用可能',
        ecoflowbenefits_savings10: 'PLUS Exclusive Gifts ',
        ecoflowbenefits_savings11: 'Monthly Coupon Pack',
        ecoflowbenefits_savings12: 'PLUS会員限定特典',
        ecoflowbenefits_savings21: '会員限定価格を楽しむ',
        ecoflowbenefits_savings22: 'エコポイントはご注文時に現金同様にご利用いただけます。',
        ecoflowbenefits_savings_tips1: 'PLUS会員のお問い合わせは、専用のメールアドレスにて対応し、優先的に返信します。',
        ecoflowbenefits_savings_tips2: '不良品を新製品に交換できる期間は1カ月から6カ月に延長され、6カ月以内の故障製品はすべて新品に交換できます。',
        ecoflowbenefits_savings_tips3:
            'If your product is irreparably broken, you can use this service. After sending in your broken product and providing the proof of shipment, we will immediately send you a new product without waiting for the broken one to be received.\nNote: This service cannot be used together with the extra 4-month replacement benefit.',
        ecoflowbenefits_savings_tips4: '*累計60万円以上（税込み）のお買い物をされたPLUS会員限定、会員資格につき一度のみ入手可能です。',
        ecoflowbenefits_support1: 'ほとんどの製品が送料無料',
        ecoflowbenefits_support2: 'Extended Warranty for Selected Products',

        ecoflowbenefits_support3: 'PLUS会員専属カスタマーサービス',
        ecoflowbenefits_support4: '購入6 か月間以内の不良品を新品に交換',
        ecoflowbenefits_support5: 'Express Replacement Service',
        ecoflowbenefits_support6: 'Tier',

        ecoflowbenefits_experiences1: 'Benefits From Our Partners',
        ecoflowbenefits_experiences2: 'Member-Only Event',
        ecoflowbenefits_experiences3: '新製品体験イベント (近日公開)',
        ecoflowbenefits_experiences4: '新製品の早期購入 (近日公開)',
        ecoflowbenefits_savings_message: 'Please check <line>here</line> to see how to claim vouchers for PLUS MEMBER.',
        ecoflowbenefits_savings_message_pop1: "1. Don't forget to log into your EcoFlow Account on the EcoCredits page.",
        ecoflowbenefits_savings_message_pop2: '2. You will see the pop-up right away if you have a new voucher to claim.',
        ecoflowbenefits_savings_message_pop3:
            "3. Don't worry if you missed it. Go to the 'gift' icon and check the voucher in \"My Rewards\". Don't forget to use it within the valid time.",
        ecoflowbenefits_support_message: 'Please contact <email>support@ecoflow.com</email> for assistance in using your benefits.',
        ecoflowbenefits_experiences_message: 'Stay tuned with us!',
        date_of_event: '時刻',
        expiration_date: '失効時刻',

        only_plus_member: 'こちらの特典は、Plus会員の方のみご利用いただけます。',
        only_member: 'こちらの特典は、会員の方のみご利用いただけます。',
        not_eligible: 'まだミッションをクリアしていません',
        // 25年会员活动
        first_login_2025: 'ログイン',
        know_brand_2025: 'Power For Allプログラムを知る',
        know_member_2025: 'EcoFlow会員制度を知る',
        share_story_2025: 'ストーリーをシェア',
        first_order_2025: 'お買い物をする',
        repeat_order_2025: 'さらにお買い物をする',
    },
    kr: {
        shop1: '구매에 지불한 1500원당 1에코 포인트를 적립합니다.',
        warranty1: '제품을 등록하여 1000 EcoCredits를 받았습니다',
        profile1: '프로필을 완성하여 1000 EcoCredits를 받았습니다',
        referral1: '친구의 가입이 완료될 때마다 EcoCredits를적립하세요.',
        ins: 'Instagram에서 팔로우하여 100 EcoCredits를 받았습니다',
        x: 'X에서 팔로우하여 100 EcoCredits를 받았습니다',
        youtube: 'YouTube에서 팔로우하여 100 EcoCredits를 받았습니다',
        facebook: 'Facebook에서 팔로우하여 100 EcoCredits를 받았습니다',
        line: 'LINE에서 친구로 등록하여 100 EcoCredits를 받았습니다.',
        joininfacebook: 'Facebook에 가입하여 100 EcoCredits를 받았습니다',
        subscribe1: '구독하여 500 EcoCredits를 받았습니다',
        clock_in: '체크인',
        seo_title: '에코플로우의 특별한 적립 프로그램 - 에코 포인트',
        seo_desc: '지금 에코플로우 공식 홈페이지 회원가입하고 에코 포인트 적립해 보세요. 회원가입 즉시 500 에코 포인트 적립!',
        sign_up1: '가입하여 500 EcoCredits를 받았습니다',
        sign_up1_1: '가입하여 800 EcoCredits를 받았습니다',
        copy_desc: '코드를 복사​했습니다. 코드를 사용하려면 스토어로 이동​하세요.',
        welcome_text: '더 많은 독점 혜택을 위해 더 많은 에코 크레딧을 획득하고 PLUS 멤버십으로 업그레이드하세요.',
        welcome_text_plus: '업그레이드된 독점 혜택을 통해 에코플로우와 함께 더 많은 것을 절약하고 경험할 수 있습니다!',
        how_it_works: '진행 방식',
        sign_up: '가입하기',
        sign_up_desc: '무료로 계정을 만들고 멤버십 여정을 시작하세요.',
        earn_points: '적립 및 사용',
        earn_points_desc: '작업을 완료하여 EcoCredits을 적립하고 현금처럼 사용하거나 보상 사용하세요.',
        redeem_points: '혜택 더 보기',
        redeem_points_desc: 'EcoCredits 6,000점을 모아 플러스 멤버십으로 업그레이드하고 더 많은 혜택을 누리세요.',
        more_benefits: '단독 혜택',
        more_benefits_desc: 'PLUS 멤버로 업그레이드하여 더 많이 절약해보세요.',
        more_benefits_question: '계정에 EcoCredits 6,000점이 적립되면 플러스 멤버십으로 업그레이드할 수 있습니다.',
        sign_up_desc_1: '회원가입 시 800포인트 즉시 적립',
        see_t_c: '사용약관 보기',
        join_subTitle: 'EcoCredits 리워드 프로그램에 가입하세요 \n지금 가입하고 500 EcoCredits를 받아보세요.',
        send_your_friend: '{amont} 기프트 카드를 친구에게 보냅니다.',
        purchase: '구매',
        coupon: '할인 쿠폰',
        login_capital_letters: '로그인',
        login_capital_letters1: '로그인',
        received: '받음',
        subscribe_capital_letters: '구독하기',
        birthday_placeholder: 'MM/DD/YY',
        shop_capital_letters: '스토어',
        shop: '구매 적립',
        ecoflow_benefits: '에코 포인트 혜택',
        complete_profile: '프로필 작성',
        referral: '친구 초대하기',
        referral_desc: '친구의 가입이 완료될 때마다 EcoCredits를적립하세요.',
        referral_btn: '친구 초대하기',
        warranty: '제품 등록',
        points_activity_a: '나의 활동',
        check_more: '더 확인하기',
        points_tab_name: '에코포인트 내역',
        rewards_tab_name: '에코포인트 적립 내역',
        coupon_used_desc: '결제 시 이 코드로 {amont} ​기프트 카드를 사용하세요.',
        email_address: '이메일 주소',
        give_away: '경품',
        add_my_birthday: '생일 추가',
        ins_title: '인스타그램 팔로우하기',
        ins_desc1: '첫 팔로우 시 {points} EcoCredit을 획득하세요.',
        ins_desc2: '첫 팔로우 시 {points} 에코 크레딧 획득,',
        follow_button: '지금 팔로우하기',
        follow_button_ins: '',
        follow_button_x: '',
        follow_button_youtube: '',
        follow_button_facebook: '',
        kakoo_title: '카카오에서 팔로우하기',
        kakoo_desc1: '첫 팔로우 시 {points} EcoCredit을 획득하세요.',
        kakoo_desc2: '첫 팔로우 시 {points} 에코 크레딧 획득, ',
        subscribe: '구독하기',
        welcome_title: '안녕하세요 {username}님,',
        welcome_sub_title: '에코 포인트 프로그램에 오신 것을\n 환영합니다.',
        profile: '프로필 작성',
        status: '상태',
        refund: '환불',
        points_balance: '보유 포인트',
        points_progress_tips: '{plus} 되기 위해 필요한 Eco Credit: {points}에코크레딧',
        available: '사용 가능',
        sign_up_text: '회원 가입 시 500포인트',
        redeemed_succ: '성공적으로 사용했습니다!',
        current_tier: '현재 등급',
        subscribe_now: '구독하기',
        date: '날짜',
        used: '사용함',
        edeemed_rewards_note: '사용한 리워드는 여기에 표시됩니다.',
        warranty_capital_letters: '보증 등록',
        days_rules2: '{data}부터 유효.',
        redeem_now: '바로 사용하기',
        product_rules: '{product} 상품에만 해당',
        membership_includes: '멤버십에는 다음이 포함됩니다.',
        browse_ecocredits_rewards: 'EcoCredits 리워드 찾아보기',
        discount: '할인',
        view_more: '더 보기',
        profile_desc1: '프로필 작성을 완료하시면 최대 1000 EcoCredits를 받으실 수 있습니다.',
        profile_desc2: '세부 정보를 입력하면 최대 1000포인트를 받을 수 있습니다.',
        points_capital_letters: '포인트',
        history_note: '에코포인트 적립 및 사용 내역은 24시간 이내로 업데이트됩니다.',
        lucky_flop_start: '참여하기',
        lucky_flop_congrat: '축하합니다',
        lucky_flop_get: '축하합니다',
        lucky_flop_open: 'OPEN',
        rules: '포인트 사용 규칙 ',
        completed_text: '포인트가 적립되었습니다.',
        redeemed: '사용됨',
        birthday: '생일 포인트',
        summary_text: '귀하의 EcoCredits 요약',
        deducted: '차감됨',
        site_rules: '에코플로우 코리아 공식 홈페이지에서만 적용 가능.',
        subscribe_hover: '회원 가입 시 500포인트가 적립됩니다.',
        subscribe_text: 'EcoFlow 최신 소식을 받아보려면 구독하세요.',
        store: '바로 구매',
        membership: '멤버',
        join_now: '지금 가입하기',
        gift_card: '기프트 카드',
        rewards_redeemed: '에코포인트 내역',
        redeedmed_tab_name: '전환 완료',
        issued_tab_name: '발급 완료',
        expired: '만료됨',
        login: '로그인',
        earn_points_title: '포인트 적립 방법',
        have_points: '에코 포인트: <code> {points} P</code>',
        view_all: '더 알아보기',
        add_your_birthday: '생년월일 입력',
        earn_point_rule_shop: '구매에 지불한 1500원당 1에코 포인트를 적립합니다.',
        off: '할인',
        earn_point_by_order: '쇼핑할 때마다 EcoCredits를 적립하세요. (1500달러 = 1EcoCredits)',
        registered: '등록됨',
        birthday_desc2: '생년월일을 추가하면 {points}포인트가 적립됩니다.',
        sign_up_desc_h: '멤버십 가입 시 EcoCredits 500점을 드립니다.',
        sign_up_desc_h_1: '회원가입 시 800포인트 즉시 적립',
        birthday_desc1: '전 회원 생일 축하 포인트 증정',
        or_text: '또는',
        profile_a: '프로필',
        days_rules: '리워드 사용일로부터 {days}일 동안 유효.',
        join_title: '에코포인트 쌓고,\n플러스 할인 받자!',
        pending: '보류 중',
        coming_soon: '곧 적립될 포인트',
        expires_in_one_month: '1개월 이내 만료',
        shop_to_earn_points: '쇼핑하여 포인트 적립하기',
        action: '유형',
        rewards_title: '적립 내역',
        type_title: '구분',
        discount_type: '할인 내역',
        already_member: '이미 회원이신가요?',
        already_member1: '이미 회원이신가요?',
        points_activity: '포인트 적립 내역',
        use_this_code_note: '결제 시 이 코드로 <PI1/> ​기프트 카드를 사용하세요.',
        warranty_desc2: '상품 등록 시 1000포인트가 제공됩니다.',
        warranty_desc1: '새로 받은 제품을 등록하면 EcoCredits 1,000점을 드립니다.',
        redeem_ecocredits_title: '에코 포인트 전환하기',
        points: '포인트',

        benefits_item1: '모든 구매건에 대해 에코포인트 지급',
        benefits_item2: '에코포인트로 할인쿠폰 교환',
        benefits_item3: '무료 배송 혜택',
        benefits_item4: '에코포인트로 특별 선물 교환',
        benefits_item5: '특정 상품에 대한 보증기간 연장 혜택',
        benefits_item6: '회원 단독 이벤트',
        benefits_item7: '친구 추천할 때 마다 에코포인트 추가 지급',
        benefits_item8: '',
        benefits_item9: '지인들을 추천하고 최대 100만원의 캐시백을 받아보세요!',
        benefits_link_btn: '친구추천하기 ',

        network_error: '네트워크 오류',
        manually_added: '수동으로 추가됨',
        confirm_text: '포인트를 사용하시겠습니까?\n사용하면 취소할 수 없습니다.',
        manually_deducted: '수동으로 차감됨',
        earning_points: '포인트 적립',
        confirm_btn: '확인',
        faq_title: '자주 묻는 질문',
        no_enough_points: '사용하지 못했습니다. 포인트가 충분하지 않습니다.',
        no_history_note: '아직 포인트를 확인하지 못하셨나요? 활동이 24시간 이내에 업데이트됩니다.',
        no_coupon_note: '포인트 사용 내역이 없습니다.',
        minimum_price: '최소 구매 금액 ({price}).',
        minimum_num: '최소 품목 수량({num} 개).',
        stay_too_long: '오랜 기간 사용하지 않아 기간이 만료되었습니다. 페이지를 새로 고친 후 다시 시도하십시오.',
        order_rule: '할인코드의 중복적용은 불가능합니다.',
        purchas_rule: '쿠폰 금액보다 적은 금액으로 상품을 구매하는 경우,\n 차액이 회수됩니다.',
        profile_birthday: '프로필 - 생년월일',
        profile_address: '프로필 - 주소',
        profile_username: '프로필 - 성함',
        profile_picture: '프로필 - 사진',
        profile_contact: '프로필 - 연락처 정보',
        learn_more: '더 알아보기',
        profile_detail:
            '프로필을 작성해 보세요. 프로필 사진(200 포인트), 성함(100 포인트), 연락처 정보(300 포인트), 주소 정보(200 포인트), 생년월일(200 포인트) 등의 정보 등록 시 마다 최대 1000포인트를 받을 수 있습니다.',
        exceeded_counts: '포인트 전환할 수 없습니다. 전환 한도를 초과했습니다.',
        grab_title: '에코포인트? 보너스로 그냥 드려요!',
        grab_sub_title: '에코포인트 멤버를 위한 기간 한정 혜택, 지금 바로 확인해 보세요!',
        grab_btn_text: '기간 한정 혜택 받기',
        grab_success_title: '보너스 에코포인트 지급 완료',
        grab_success_text1: '보너스 에코포인트가 지급되었습니다. 자동 복사된 코드를 결제 전 입력하세요.',
        grab_success_text2: '<code>보너스 에코포인트</code> 확인하기',
        'no-grab-content-note': '더 많은 혜택을 제공해 드릴 예정입니다!',
        copy_desc_2: '할인 코드를 복사하였습니다.',
        city_validatino_error: '유효하지 않은 도시',
        product_text: '제품',
        shipping_address_text: '배송 주소',
        saved_address_text: '배송 정보를 저장하였습니다',
        use_new_address: '새 주소를 사용하기',
        spend_now: '바로 사용하기',
        stock_left: '{stock}개가 남았습니다.',
        no_stock_tip: '곧 재입고될 예정입니다.',
        order_text: '주문 번호',
        campaign_time_limit_text: '포인트 전환의 유효 기간: {startTime} - {endTime}.',
        event_action_text: '이벤트',
        warranty_minus_action_text: '보증 기록 삭제되었습니다',
        question_correctly: 'Answer the question correctly',
        follow_instagram_text: '인스타그램 팔로우',
        follow_kakoo_text: '카카오톡 팔로우',
        referral_correctly: '추천 프로그램',
        confirm_btn_text: '닫기',
        lucky_turntable_title: '행운의 룰렛',
        join_lucky_with_points: '{points} 에코 포인트로 행운의 당첨자가 되어보세요',
        join_lucky_with_points2: '{points} 에코 포인트로 행운의 당첨자가 되어보세요',
        join_lucky_desc: '룰렛을 돌리면 최대 777 포인트 (5만 4천원 상당)가 적립됩니다.',
        remaining_number: '잔여 횟수 <code></code>회',
        remaining_number2: '잔여 횟수 <code></code>회',
        learn_lucky_rule: '규칙에 대해 더 알아보기',
        prize_coupon_title: '축하합니다',
        prize_coupon_sub_title: '상품 수령에 성공했습니다! 결제 시 코드를 사용하여 할인을 받으세요.',
        prize_coupon_action: '<code>에코포인트 내역</code>에서 상품을 확인하세요.',
        prize_coupon_button: '바로 구매',
        prize_points_title: '축하합니다',
        prize_points_desc: '<code>나의 활동</code>에서 지금 추가된 EcoCredit을 확인하세요.',
        limit_times_in_day: '<day></day>일 동안 <count></count>회 참여 가능합니다',
        limit_times_in_day2: '휠을 <day></day>일 동안 <count></count>회 돌릴 수 있습니다',
        limit_times_in_day_one: '매일 <count></count>번씩 주어지는 기회!',
        limit_times_in_active: '이벤트 기간 동안 최대 <count></count>회까지 참여 가능합니다.',
        limit_times_in_active2: '이벤트 기간 동안 휠을 최대 <count></count>회까지 돌릴 수 있습니다.',
        without_limit_times: '언제든지 게임을 <count></count>회 참여할 수 있습니다.',
        without_limit_times2: '언제든지 휠을 <count></count>회 돌릴 수 있습니다.',
        active_is_unstart: '이벤트가 곧 시작됩니다.',
        active_is_ended: '이벤트가 종료되었습니다.',
        over_max_count: '사용 가능한 횟수를 초과했습니다.',
        notice_title: '알림',

        kr_subscribe_poptitle: '에코플로우 뉴스레터 등록하고 \n가장 먼저 에코플로우의 최신 소식을 받아보세요!',
        kr_subscribe_popsuccess: '구독해 주셔서 감사합니다!',
        points_cash: '포인트 사용',
        Pending1: '보류 중',
        rollback: '반환됨',
        level_change_log: '등급 변경',
        deadline: '유효 기간',
        history_refresh_member: '현재 등급: 멤버',
        history_refresh_plus_member: '현재 등급: 플러스 멤버',
        register: '멤버로 가입하기',
        upgrade: '플러스 멤버로 업그레이드',
        demotion: '멤버로 강등하기',
        relegation: '플러스 멤버 유지하기',
        ecocredits_notice1:
            '2024년 10월 17일에 EcoCredits 규칙을 업데이트했습니다. EcoCredits를 사용하기 전에 업데이트된 [<line1>EcoCredits 규칙</line1>]을 주의 깊게 읽어보시기 바랍니다.',
        ecoflowbenefits_title: '에코크레딧 독점 혜택',
        ecoflowbenefits_savings: '더 많은 절약',
        ecoflowbenefits_support: '더 많은 지원',
        ecoflowbenefits_experiences: '더 많은 경험',

        ecoflowbenefits_tab_benefits: '누적 수입',
        ecoflowbenefits_tab_tier: '등급',
        ecoflowbenefits_tab_plus: 'PLUS 멤버',
        ecoflowbenefits_tab_normal: '멤버',
        ecoflowbenefits_savings1: '모든 구매건에 대해 에코포인트 지급',
        ecoflowbenefits_savings2: '친구 추천할 때 마다 에코포인트 추가 지급',
        ecoflowbenefits_savings3: '에코포인트로 할인쿠폰 교환',
        ecoflowbenefits_savings4: '에코포인트로 특별 선물 교환',
        ecoflowbenefits_savings5: 'Save 25% OFF at Harvest Hosts',
        ecoflowbenefits_savings5_link: 'Get the Code',
        ecoflowbenefits_savings6: 'Save 10% OFF at Winnebago gears',
        ecoflowbenefits_savings6_link: 'Get the Code',
        ecoflowbenefits_savings7: '지인들을 추천하고 최대 100만원의 캐시백을 받아보세요!',
        ecoflowbenefits_savings7_link: '친구추천하기',
        ecoflowbenefits_savings8: '추가 생일 쿠폰',
        ecoflowbenefits_savings9: '추가 레벨업 쿠폰',
        ecoflowbenefits_savings10: '추가 한정 선물',
        ecoflowbenefits_savings11: '월간 쿠폰팩',
        ecoflowbenefits_savings21: '멤버 전용 특별 가격(가능한 경우)을 이용하세요',
        ecoflowbenefits_savings22: 'EcoCredits를 현금처럼 사용하여 주문하세요.',
        ecoflowbenefits_savings_tips1: '구매 후 1개월 이내에 1회의 무료 반품 혜택을 누리십시오.',
        ecoflowbenefits_savings_tips2:
            '보증기간 외 수리 시 서비스 요금을 특별 할인받으세요.\n에코플로우는 실제 상황에 따라 수리 범위를 결정할 수 있는 권리를 보유하고 있습니다.',
        ecoflowbenefits_savings_tips3: '총 5개월로 교환 기간을 연장하여 불량품을 새 제품으로 교환할 수 있습니다.',
        ecoflowbenefits_savings_tips4:
            '제품이 복구 불가능할 정도로 손상된 경우, 이 특별 서비스를 이용하실 수 있습니다. 손상된 제품의 발송 증빙과 플러스 멤버십 상태를 확인할 수 있는 스크린샷을 제공해 주시면 자격을 확인한 후 바로 교체 제품을 발송해 드립니다. 손상된 제품이 저희에게 도착하기 전에 교체 제품을 받으실 수 있습니다. \n주의: 본 서비스는 추가 4개월 교체 혜택과 함께 이용하실 수 없습니다.',
        ecoflowbenefits_support1: '무료 배송 혜택',
        ecoflowbenefits_support2: '특정 상품에 대한 보증기간 연장 혜택',
        ecoflowbenefits_support3: '무조건 무료 반품 (1 회)',
        ecoflowbenefits_support4: '보증 범위 외 서비스 요금 12% 할인',
        ecoflowbenefits_support5: '교환 보증기간 4개월 연장',
        ecoflowbenefits_support6: '익스프레스 교체 서비스',
        ecoflowbenefits_experiences1: 'Benefits From Our Partners',
        ecoflowbenefits_experiences2: '회원 단독 이벤트',
        ecoflowbenefits_experiences3: '신제품 체험 이벤트(곧 출시)',
        ecoflowbenefits_experiences4: '단독 얼리버드 혜택(곧 출시)',
        ecoflowbenefits_savings_message: 'PLUS 멤버 바우처 수령 방법을 확인하려면 <line>여기를</line> 클릭하세요.',
        ecoflowbenefits_savings_message_pop1: '1. EcoCredits 페이지에서 EcoFlow 계정에 로그인하는 것을 잊지 마십시오.',
        ecoflowbenefits_savings_message_pop2: '2. 사용가능한 새 바우처가 있으면 바로 팝업창이 나타납니다.',
        ecoflowbenefits_savings_message_pop3:
            '3. 놓쳤어도 걱정하지 마세요. \'선물\' 아이콘으로 이동하여 "나의 리워드"에서 바우처를 확인하십시오. 유효 기간 내에 사용하는 것을 잊지 마십시오.',
        ecoflowbenefits_support_message: '혜택 사용에 관해 도움이 필요하시면 <email>support.kr@ecoflow.com</email>  로 문의하십시오.',
        ecoflowbenefits_experiences_message: '계속 주목하세요!',
        date_of_event: '이벤트 날짜',
        expiration_date: '만료일',
        only_plus_member: 'PLUS 회원만 리워드를 사용할 수 있습니다.',
        only_member: '회원만 리워드를 사용할 수 있습니다.',
        not_eligible: '이 이벤트에 참여할 자격이 없습니다',
        // 25年会员活动
        first_login_2025: '첫 방문 로그인',
        know_brand_2025: '에코플로우에 대해 더 알아보기',
        know_member_2025: '멤버십에 대해 더 알아보기',
        share_story_2025: '내 이야기 공유하기',
        first_order_2025: '구매 완료하기',
        repeat_order_2025: '추가 구매하기',
    },
    sa: {
        shop1: 'Earn every time you order.',
        warranty1: 'You got 1000 EcoCredits by registering a product.',
        profile1: 'You got 1000 EcoCredits by completing your profile.',
        referral1: "Get EcoCredits for each friend's successful registration.",
        ins: 'You got 100 EcoCredits by following us on Instagram.',
        x: 'You got 100 EcoCredits by following us on X.',
        youtube: 'You got 100 EcoCredits by following us on YouTube.',
        facebook: 'You got 100 EcoCredits by following us on Facebook.',
        line: 'You earned 100 EcoCredits by registering as a friend on LINE.',
        joininfacebook: 'You got 100 EcoCredits by joining us on Facebook.',
        subscribe1: 'You got 500 EcoCredits by subscribing.',
        clock_in: '',
        seo_title: '',
        seo_desc: '',
        redeem_now: 'استبدل الآن',
        browse_ecocredits_rewards: 'تصفَّح مكافآت EcoCredits',
        sign_up1: 'You got 500 EcoCredits by signing up.',
        profile_detail:
            'أكمِل ملفك الشخصي لتحصل على ما يصل إلى 1000 نقطة، بما في ذلك صورة الملف الشخصي (200 نقطة)، واسم المستخدم (100 نقطة)، وبيانات الاتصال (300 نقطة)، والعنوان (200 نقطة)، وتاريخ الميلاد (200 نقطة).',
        confirm_text: 'هل أنت واثق بأنك تريد الاستبدال؟ هذه الخطوة لا يمكن الرجوع فيها.',
        welcome_title: 'مرحبًا {username}',
        login: 'تسجيل الدخول',
        refund: 'رد المبلغ المدفوع',
        history_note: 'ستظهر النقاط التي تحصل عليها هنا. ألا ترى نقاطك؟ سيتم تحديث نشاطك في خلال 24 ساعة.',
        already_member: 'هل أنت عضو بالفعل؟',
        already_member1: 'هل أنت عضو بالفعل؟',
        points: 'النقاط',
        warranty_capital_letters: 'الضمان',
        action: 'الإجراء',
        available: 'متاح',
        faq_title: 'الأسئلة الشائعة',
        product_rules: 'لمنتج {product} فقط.',
        view_more: 'عرض المزيد',
        points_capital_letters: 'النقاط',
        welcome_text: 'Earn more EcoCredits and upgrade to PLUS Membership to enjoy more exclusive rewards.',
        welcome_text_plus: 'The upgraded exclusive benefits allow you to save and experience even more with us!',
        complete_profile: 'الملف الشخصي مكتمل',
        referral: 'INVITE A FRIEND',
        referral_desc: "Get EcoCredits for each friend's successful registration.",
        referral_btn: 'Join Now',
        minimum_price: 'الحد الأدنى لمبلغ الشراء ({price}).',
        off: 'إيقاف التشغيل',
        days_rules: 'يمكن استخدامها خلال {days} من الأيام عند الاستبدال.',
        join_subTitle: 'سجِّل نفسك عضوًا في مجتمعنا لكسب النقاط والمكافآت الحصرية كلما تسوَّقت على موقعنا.',
        current_tier: 'المستوى الحالي',
        purchas_rule: 'شراء منتج بثمن أقل من قيمة الكوبون (الكوبونات) سيجعلك تفقد باقي قيمة الكوبون.',
        site_rules: 'لمتاجر المملكة المتحدة فقط.',
        subscribe_hover: 'اكسب 500 نقطة عند انضمامك.',
        profile_address: 'الملف الشخصي - العنوان',
        benefits_item7: 'استبدال النقاط بهدايا مميزة',
        benefits_item6: 'الفوائد التي يمكن الحصول عليها من شركائنا',
        earn_point_rule_shop: 'احصل على نقطة مقابل كل جنيه إسترليني تنفقه.',
        benefits_item3: 'تركيب مجاني لمنتجات معينة',
        benefits_item2: 'استبدال النقاط مقابل مكافآت',
        benefits_item5: 'الانضمام مجاني تمامًا',
        benefits_item4: 'شحن مجاني لمعظم المنتجات',
        benefits_item1: 'الفوز بنقاط عند إجراء كل عملية شراء',
        received: 'تم الاستلام',
        profile_birthday: 'الملف الشخصي - تاريخ الولادة',
        shop: 'التسوُّق',
        earn_point_by_order: 'اكسب في كل مرة تطلب فيها.',
        shop_capital_letters: 'التسوُّق',
        redeem_ecocredits_title: 'استبدال مكافآت EcoCredits',
        rules: 'القواعد',
        subscribe_text: 'اشترك للحصول على رسائل EcoFlow الإخبارية.',
        pending: 'قيد الانتظار',
        welcome_sub_title: 'مرحبًا بك في برنامج المكافآت EcoCredits.',
        how_it_works: 'آلية العمل',
        sign_up: 'الاشتراك',
        sign_up_desc: 'أنشئ حسابًا واحصل على مكافأة بمقدار 500 نقطة.',
        earn_points: 'كسب النقاط',
        earn_points_desc: 'اكسب نقاطًا في كل مرة تتسوق فيها.',
        redeem_points: 'استبدال النقاط',
        redeem_points_desc: 'اجمع النقاط للحصول على خصومات حصرية.',
        more_benefits: 'MORE BENEFITS',
        more_benefits_desc: 'Upgrade to PLUS Member to save more. ',
        more_benefits_question: 'Once you have 6,000 EcoCredits in your account, you can upgrade to PLUS Membership.',
        sign_up_desc_1: 'أنشئ حسابًا واحصل على مكافأة بمقدار 500 نقطة.',
        no_history_note: 'ألم ترَ النقاط التي كسبتها بعد؟ سيتم تحديث نشاطك خلال 24 ساعة.',
        no_enough_points: 'لم ينجح الاستبدال، فنقاطك غير كافية',
        see_t_c: 'اطلع على الشروط والأحكام',
        email_address: 'عنوان البريد الإلكتروني',
        redeemed: 'تم الحصول عليها',
        manually_added: 'تمت الإضافة يدويًا',
        have_points: 'لديك <code>{points} من النقاط</code>',
        learn_more: 'اعرف المزيد',
        add_your_birthday: 'أضف تاريخ ميلادك',
        earning_points: 'كسب النقاط',
        or_text: 'أو',
        join_title: 'انضم إلى برنامج المكافآت EcoCredits',
        copy_desc: 'لقد نسخت الرمز. يُرجى الانتقال إلى المتجر لاستخدامه.',
        manually_deducted: 'تم الخصم يدويًا',
        join_now: 'انضم الآن',
        warranty: 'الضمان',
        status: 'الحالة',
        birthday: 'يوم الميلاد',
        points_balance: 'توازن النقاط',
        points_progress_tips: 'EcoCredits Needed to Reach {plus}: {points} EcoCredits',
        shop_to_earn_points: 'تسوق لتكسب نقاطًا',
        stay_too_long: 'انتهت صلاحية جلستك. يُرجى تحديث الصفحة والمحاولة مرة أخرى.',
        subscribe_now: 'اشترك الآن',
        exceeded_counts: 'فشل في استخدام النقاط. لقد تجاوزت حد استخدام النقاط.',
        coming_soon: 'قريبًا',
        expires_in_one_month: 'Expires in One Month',
        points_activity: 'نشاط النقاط',
        login_capital_letters: 'تسجيل الدخول',
        login_capital_letters1: 'تسجيل الدخول',
        profile_username: 'الملف الشخصي - اسم المستخدم',
        rewards_redeemed: 'تم الحصول على الجوائز',
        expired: 'منتهي الصلاحية',
        minimum_num: 'الحد الأدنى لعدد العناصر ({num} من القطع).',
        coupon: 'رمز الخصم',
        subscribe: 'اشتراك',
        gift_card: 'بطاقة هدية',
        profile: 'الملف الشخصي',
        deducted: 'تم الخصم',
        registered: 'مسجل',
        birthday_placeholder: 'اليوم/الشهر/السنة',
        give_away: 'منح',
        discount: 'خصم',
        edeemed_rewards_note: 'ستظهر الجوائز التي حصلت عليها هنا.',
        completed_text: 'لقد حققت هذه المكافأة بالفعل.',
        points_activity_a: 'نشاط النقاط',
        check_more: 'Check More',
        earn_points_title: 'طرق لتكسب نقاطًا',
        profile_picture: 'الملف الشخصي - الصورة',
        days_rules2: 'صالح من {data}.',
        purchase: 'الشراء',
        used: 'مُستخدَم',
        network_error: 'خطأ في الشبكة',
        confirm_btn: 'تأكيد',
        sign_up_text: '500 نقطة عند الانضمام',
        profile_contact: 'الملف الشخصي - معلومات التواصل',
        membership_includes: 'تتضمن العضوية',
        summary_text: 'ملخص نقاطك من EcoCredits',
        store: 'تسوق الآن',
        sign_up_desc_h: '500 نقطة عند انضمامك.',
        sign_up_desc_h_1: '500 نقطة عند انضمامك.',
        warranty_desc2: '1000 نقطة عندما تسجّل منتجًا.',
        warranty_desc1: '1000 نقطة عندما تسجّل منتجًا.',
        order_rule: 'رمز خصم واحد فقط لكل طلب.',
        ecoflow_benefits: 'مزايا EcoCredits لعام ',
        coupon_used_desc: 'استخدم هذا الرمز عند إتمام الشراء لتحصل على بطاقة هديتك بقيمة {amont}.',
        add_my_birthday: 'إضافة تاريخ ميلادي',
        date: 'التاريخ',
        profile_desc1: 'اكسب ما يصل إلى 1000 نقطة مقابل استكمال ملفك الشخصي.',
        profile_desc2: 'احصل على ما يصل إلى 1000 نقطة مقابل إضافة تفاصيلك.',
        membership: 'العضو',
        view_all: 'عرض الكل',
        send_your_friend: 'أرسل بطاقة هديتك بقيمة {amont} إلى صديق.',
        subscribe_capital_letters: 'اشتراك',
        no_coupon_note: 'لم يتم الحصول على جوائز بعد.',
        redeemed_succ: 'تم الحصول بنجاح!',
        birthday_desc2: 'اكسب {points} من النقاط عندما تضيف تاريخ ميلادك.',
        birthday_desc1: 'أضف تاريخ ميلادك للحصول على نقاط.',
        profile_a: 'الملف الشخصي',
        event_action_text: 'Event',
        warranty_minus_action_text: 'Warranty Deleted',
        question_correctly: 'Answer the question correctly',
        follow_instagram_text: 'Follow Instagram',
        follow_x_text: 'Follow X',
        follow_youtube_text: 'Follow YouTube',
        follow_facebook_text: 'Follow Facebook',
        join_facebook_text: 'Join Us On Facebook',
        confirm_btn_text: 'OK',

        points_cash: 'Points Redemption',
        Pending1: 'Pending',
        rollback: 'Returned',
        level_change_log: 'Tier Activity',
        deadline: 'Valid Until',
        history_refresh_member: 'Current Tier: Member',
        history_refresh_plus_member: 'Current Tier: PLUS Member',
        register: 'Register as a Member',
        upgrade: 'Upgrade to PLUS Member',
        demotion: 'Downgrade to Member',
        relegation: 'Maintain as PLUS Member',
        ecoflowbenefits_title: 'EcoFlow Benefits',
        ecoflowbenefits_savings: 'More Savings',
        ecoflowbenefits_support: 'More Support',
        ecoflowbenefits_experiences: 'More Experiences',
        ecoflowbenefits_tab_benefits: 'Benefits',
        ecoflowbenefits_tab_tier: 'Tier',
        ecoflowbenefits_tab_plus: 'PLUS MEMBER',
        ecoflowbenefits_tab_normal: 'MEMBER',
        ecoflowbenefits_savings1: 'Earn EcoCredits for Every Purchase',
        ecoflowbenefits_savings2: 'Earn EcoCredits From Successful Friend Sign-ups',
        ecoflowbenefits_savings3: 'Redeem EcoCredits for Discounts',
        ecoflowbenefits_savings4: 'Redeem EcoCredits for Special Gifts',
        ecoflowbenefits_savings5: 'Save 25% OFF at Harvest Hosts',
        ecoflowbenefits_savings5_link: 'Get the Code',
        ecoflowbenefits_savings6: 'Save 10% OFF at Winnebago gears',
        ecoflowbenefits_savings6_link: 'Get the Code',
        ecoflowbenefits_savings7: 'Refer & Earn Up To $500 Cash Reward!',
        ecoflowbenefits_savings7_link: 'Refer Now',
        ecoflowbenefits_savings8: 'Exclusive Birthday Coupon',
        ecoflowbenefits_savings9: 'PLUS Level-up Coupon',
        ecoflowbenefits_savings10: 'PLUS Exclusive Gifts ',
        ecoflowbenefits_savings11: 'Monthly Coupon Pack',
        ecoflowbenefits_savings_tips1: 'Enjoy one free return within one month of purchase.',
        ecoflowbenefits_savings_tips2:
            'Receive a special discount on service charges for out-of-warranty repairs.\nEcoFlow reserves the right to determine the scope of repairs based on the actual situation.',
        ecoflowbenefits_savings_tips3:
            'If your product is irreparably broken, you can use this service. After sending in your broken product and providing the proof of shipment, we will immediately send you a new product without waiting for the broken one to be received.\nNote: This service cannot be used together with the extra 4-month replacement benefit.',
        ecoflowbenefits_support1: 'Free Shipping on Most Products',
        ecoflowbenefits_support2: 'Extended Warranty for Selected Products',

        ecoflowbenefits_support3: 'Free Unconditional Return (1 Order)',
        ecoflowbenefits_support4: '12% Discount on Out-of-Warranty Service Charges',
        ecoflowbenefits_support5: 'Express Replacement Service',
        ecoflowbenefits_support6: 'Tier',

        ecoflowbenefits_experiences1: 'Benefits From Our Partners',
        ecoflowbenefits_experiences2: 'Member-Only Event',
        ecoflowbenefits_experiences3: 'New Product Trial Event (Coming Soon)',
        ecoflowbenefits_experiences4: 'Exclusive Early Bird Access (Coming Soon)',
        ecoflowbenefits_savings_message: 'Please check <line>here</line> to see how to claim vouchers for PLUS MEMBER.',
        ecoflowbenefits_savings_message_pop1: "1. Don't forget to log into your EcoFlow Account on the EcoCredits page.",
        ecoflowbenefits_savings_message_pop2: '2. You will see the pop-up right away if you have a new voucher to claim.',
        ecoflowbenefits_savings_message_pop3:
            "3. Don't worry if you missed it. Go to the 'gift' icon and check the voucher in \"My Rewards\". Don't forget to use it within the valid time.",
        ecoflowbenefits_support_message: 'Please contact <email>support@ecoflow.com</email> for assistance in using your benefits.',
        ecoflowbenefits_experiences_message: 'Stay tuned with us!',
        date_of_event: 'Date of Event',
        expiration_date: 'Expiration Date',

        only_plus_member: 'Only PLUS Members can redeem the reward.',
        only_member: 'Only Members can redeem the reward.',
        not_eligible: 'You are not eligible to participate in this event.',
        // 25年会员活动
        first_login_2025: 'First time logging in',
        know_brand_2025: 'Learn more about EcoFlow',
        know_member_2025: 'Learn more about Membership',
        share_story_2025: 'Share my story',
        first_order_2025: 'Complete a purchase',
        repeat_order_2025: 'Make an additional purchase',
    },
    za: {
        shop1: 'Earn every time you order.',
        warranty1: 'You got 1000 EcoCredits by registering a product.',
        profile1: 'You got 1000 EcoCredits by completing your profile.',
        referral1: "Get EcoCredits for each friend's successful registration.˝",
        ins: 'You got 100 EcoCredits by following us on Instagram.',
        x: 'You got 100 EcoCredits by following us on X.',
        youtube: 'You got 100 EcoCredits by following us on YouTube.',
        facebook: 'You got 100 EcoCredits by following us on Facebook.',
        line: 'You earned 100 EcoCredits by registering as a friend on LINE.',
        joininfacebook: 'You got 100 EcoCredits by joining us on Facebook.',
        clock_in: 'Check-in',
        seo_title: 'Join The EcoCredits Loyalty Program',
        seo_desc: 'Join the EcoCredits Loyalty Program at EcoFlow today and start earning rewards now! Get a 500-EcoCredits reward just for signing up.',
        join_title: 'Join the EcoCredits reward program',
        join_subTitle: 'Become a member now and get EcoCredits for cash deductions and exclusive rewards.',
        join_now: 'JOIN NOW',
        login: 'LOG IN',
        login_capital_letters: 'Log in',
        login_capital_letters1: 'Log in',
        subscribe1: 'You got 500 EcoCredits by subscribing.',
        welcome_title: 'Hi {username}',
        welcome_sub_title: 'Welcome to the EcoCredits reward program.',
        welcome_text: 'Earn more EcoCredits and upgrade to PLUS Membership to enjoy more exclusive rewards.',
        welcome_text_plus: 'The upgraded exclusive benefits allow you to save and experience even more with us!',
        summary_text: 'Your EcoCredits Summary',
        membership: 'MEMBER',
        current_tier: 'Current Tier',
        points: 'EcoCredits',
        points_balance: 'EcoCredits Balance',
        points_progress_tips: 'EcoCredits Needed to Reach {plus}: {points} EcoCredits',
        coming_soon: 'Coming Soon',
        expires_in_one_month: 'Expires in One Month',
        redeem_now: 'REDEEM NOW',
        points_activity: 'POINTS ACTIVITY',
        how_it_works: 'How It Works',
        sign_up: 'Sign Up',
        sign_up_desc: 'Create an account for free and start your membership journey.',
        earn_points: 'Earn & Use',
        earn_points_desc: 'Complete tasks for EcoCredits to use as cash or redeem rewards.',
        redeem_points: 'Enjoy More',
        redeem_points_desc: 'Get 6000 EcoCredits and upgrade to a PLUS Membership for more.',
        more_benefits: 'MORE BENEFITS',
        more_benefits_desc: 'Upgrade to PLUS Member to save more.',
        more_benefits_question: 'Once you have 6,000 EcoCredits in your account, you can upgrade to PLUS Membership.',
        sign_up_desc_1: 'Create an account and get 800 EcoCredits reward.',
        already_member: 'Already a member?',
        already_member1: 'Already a member?',
        sign_up1: 'You got 500 EcoCredits by signing up.',
        sign_up1_1: 'You got 800 EcoCredits by signing up.',
        sign_up_desc_h: 'Sign up for Membership for 500 EcoCredits.',
        sign_up_desc_h_1: '800 EcoCredits when you join.',
        earn_points_title: 'Ways to Earn EcoCredits',
        sign_up_text: '500 EcoCredits upon joining',
        completed_text: 'You have already achieved this reward.',
        subscribe: 'Subscribe',
        subscribe_capital_letters: 'Subscribe',
        subscribe_text: 'Subscribe to get the latest EcoFlow news.',
        subscribe_hover: 'Earn 500 EcoCredits when you join.',
        subscribe_now: 'Subscribe Now',
        email_address: 'Email Address',
        shop: 'Shop',
        shop_capital_letters: 'Shop',
        earn_point_by_order: 'Earn EcoCredits every time you shop. （R 20=1EcoCredits）',
        earn_point_rule_shop: 'Get 1 EcoCredits for every $1 you spend.',
        shop_to_earn_points: 'Shop To Earn EcoCredits',
        warranty: 'Warranty',
        warranty_capital_letters: 'Warranty Registration',
        warranty_desc1: 'Register a newly received product for 1000 EcoCredits.',
        warranty_desc2: 'Register a newly received product for 1000 EcoCredits.',
        profile: 'Complete Profile',
        profile_desc1: 'Completing your profile for up to 1000 EcoCredits.',
        profile_desc2: 'Get up to 1000 EcoCredits for adding your details.',
        complete_profile: 'Complete Profile',
        referral: 'Invited A Friend',
        referral_desc: "Get EcoCredits for each friend's successful registration.",
        referral_btn: 'Join Now',
        birthday: 'BIRTHDAY',
        birthday_desc1: 'Add your birthday for EcoCredits.',
        birthday_desc2: 'Earn {points} EcoCredits when you add your date of birth.',
        add_your_birthday: 'Add Your Birthday',
        birthday_placeholder: 'MM / DD / YY',
        add_my_birthday: 'Add My Birthday',
        ins_title: 'Follow Us On Instagram',
        ins_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        ins_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        follow_button: 'Follow Now',
        follow_button_ins: '',
        follow_button_x: '',
        follow_button_youtube: '',
        follow_button_facebook: '',
        x_title: 'Follow Us On X',
        x_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        x_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        youtube_title: 'Follow Us On YouTube',
        youtube_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        youtube_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        facebook_title: 'Follow Us On Facebook',
        facebook_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        facebook_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        joininfacebook_title: 'Join Us On Facebook',
        joininfacebook_desc1: 'Earn {points} EcoCredits when you join for the first time.',
        joininfacebook_desc2: 'Earn {points} EcoCredits when you join for the first time.',
        redeem_ecocredits_title: 'Redeem EcoCredits Rewards',
        have_points: 'You have <code>{points} EcoCredits</code>',
        view_all: 'View all',
        coupon: 'Discount code',
        discount: 'Discount',
        gift_card: 'Gift Card',
        redeemed_succ: 'Redeemed successfully!',
        copy_desc: 'You have copied the code, please go to the store to use it.',
        store: 'Shop Now',
        coupon_used_desc: 'Use this code at checkout to redeem your {amont} gift card.',
        rules: 'Rules',
        off: 'OFF',
        site_rules: 'For ZA store only.',
        days_rules: 'Valid for {days} days from redemption.',
        product_rules: 'For {product} only.',
        days_rules2: 'Valid from {data}.',
        rewards_redeemed: 'My Rewards',
        lucky_rewards_list: 'Rewards List',
        redeedmed_tab_name: 'Redeemed',
        issued_tab_name: 'Issued',
        available: 'Available',
        redeemed: 'Redeemed',
        expired: 'Expired',
        edeemed_rewards_note: 'Your redeemed rewards will appear here.',
        browse_ecocredits_rewards: 'Browse EcoCredits Rewards',
        used: 'Used',
        give_away: 'Give away',
        or_text: 'OR',
        send_your_friend: 'Send your {amont} gift card to a friend.',
        points_activity_a: 'My Activity',
        check_more: 'Check More',
        points_tab_name: 'EcoCredits Activity',
        rewards_tab_name: 'Rewards Activity',
        date: 'Date',
        action: 'Action',
        email: 'Email',
        rewards_title: 'Rewards',
        type_title: 'Type',
        discount_type: 'Discount',
        purchase: 'Purchase',
        profile_a: 'Profile',
        refund: 'Refund',
        registered: 'Registered',
        points_capital_letters: 'EcoCredits',
        status: 'Status',
        pending: 'Pending',
        received: 'Received',
        deducted: 'Deducted',
        view_more: 'View More',
        history_note: 'Your activity will appear here. Don’t see your activity yet? Your activity will update within 24 hours.',
        lucky_flop_start: 'Join Now',
        lucky_flop_congrat: 'Congratulations',
        lucky_flop_get: 'Claim',
        lucky_flop_open: 'OPEN',
        ecoflow_benefits: 'EcoCredits Benefits',
        membership_includes: 'MEMBERSHIP INCLUDES',
        benefits_item1: 'Earn EcoCredits for Every Purchase',
        benefits_item2: 'Redeem EcoCredits for Coupon',
        benefits_item3: 'Free Shipping on Most Products',
        benefits_item4: 'Redeem EcoCredits for Special Gifts',
        benefits_item5: 'Extended Warranty for Selected Products',
        benefits_item6: 'Member-Only Event',
        benefits_item7: 'Earn EcoCredits From Successful Friend Sign-ups',
        benefits_item8: 'Benefits From Our Partners',
        benefits_item9: 'Refer & Earn Up To $500 Cash Reward!',
        benefits_link_btn: 'Refer Now',
        see_t_c: 'See Terms and Conditions',
        manually_added: 'Manually Added',
        manually_deducted: 'Manually Deducted',
        faq_title: 'FAQ',
        earning_points: 'EARNING EcoCredits',
        network_error: 'Network Error',
        confirm_text: 'Are you sure you want to redeem? Cannot be undone.',
        confirm_btn: 'Confirm',
        no_enough_points: 'Redemption failed, your EcoCredits are not enough',
        no_history_note: 'Don’t see your EcoCredits yet? Your activity will update with in 24 hours.',
        no_coupon_note: 'No rewards redeemed yet.',
        minimum_price: 'Minimum purchase amount ({price}).',
        minimum_num: 'Minimum quantity of items({num} pcs).',
        stay_too_long: 'Your session has expired. Please refresh the page and try again.',
        order_rule: 'Only one discount code per order.',
        purchas_rule: 'Purchasing an item for less than the coupon(s), will forfeit the difference.',
        profile_birthday: 'Profile - birthday',
        profile_address: 'Profile - address',
        profile_username: 'Profile - username',
        profile_picture: 'Profile - picture',
        profile_contact: 'Profile - contact info',
        learn_more: 'Learn more',
        profile_detail:
            'Complete your profile for up to 1000 EcoCredits, including profile pic (200), user name (100), contact info (300), address (200), and birthday (200).',
        exceeded_counts: 'Failed to redeem. You have exceeded the redemption limit.',
        grab_title: 'Grab an EcoCredits Bonus',
        grab_sub_title: 'Exclusive limited-time offers for EcoCredit members. Click to claim now!',
        grab_btn_text: 'Grab My Bonus',
        grab_success_title: 'Congratulations',
        grab_success_text1: 'Bonus claimed successfully!\n Paste the code at checkout to get your discount.',
        grab_success_text2: 'Check your bonuses in <code>My Rewards</code>.',
        'no-grab-content-note': 'More offers coming soon!',
        copy_desc_2: 'You have copied the code.',
        city_validatino_error: 'Invalid city',
        product_text: 'Product',
        shipping_address_text: 'Shipping address',
        saved_address_text: 'Saved addresses',
        use_new_address: 'use a new address',
        spend_now: 'Spend Now',
        stock_left: '{stock} Left',
        no_stock_tip: 'Coming soon... Stay tuned!',
        order_text: 'Order',
        campaign_time_limit_text: 'Valid redemption period: {startTime} - {endTime}.',
        event_action_text: 'Event',
        warranty_minus_action_text: 'Warranty Deleted',
        question_correctly: 'Answer the question correctly',
        follow_instagram_text: 'Follow Instagram',
        follow_x_text: 'Follow X',
        follow_youtube_text: 'Follow YouTube',
        follow_facebook_text: 'Follow Facebook',
        join_facebook_text: 'Join Us On Facebook',
        referral_correctly: 'Referral program',
        confirm_btn_text: 'Close',
        lucky_turntable_title: 'Lucky Spin',
        join_lucky_with_points: 'It costs you {points} EcoCredits to do one round of Lucky Spin.',
        join_lucky_with_points2: 'It costs you {points} EcoCredits to play a round.',
        join_lucky_desc: 'Spin the wheel and get a great prize!',
        remaining_number: '<code></code> spins left',
        remaining_number2: '<code></code> flips left',
        learn_lucky_rule: 'Learn more about the rules',
        prize_coupon_title: 'Congratulations',
        prize_coupon_sub_title: 'The prize was claimed successfully! Use the code at checkout to save.',
        prize_coupon_action: 'Check your prizes in <code>My Rewards</code>.',
        prize_coupon_button: 'Shop Now',
        prize_points_title: 'Congratulations',
        prize_points_desc: 'Check the just-added EcoCredits in <code>My Activity</code>.',
        limit_times_in_day: 'You can spin the wheels <count></count> times in <day></day> days',
        limit_times_in_day2: 'You can flip the cards <count></count> times in <day></day> days',
        limit_times_in_active: 'During the event, you can spin the wheels up to <count></count> times.',
        without_limit_times: 'You can spin the wheels <count></count> times at any time.',
        without_limit_times2: 'You can flip the cards <count></count> times at any time.',
        active_is_unstart: 'This event is coming soon.',
        active_is_ended: 'This event has ended.',
        over_max_count: 'You have exceeded the number of spins available.',
        notice_title: 'Notice',
        points_cash: 'Points Redemption',
        Pending1: 'Pending',
        rollback: 'Returned',
        level_change_log: 'Tier Activity',
        deadline: 'Valid Until',
        history_refresh_member: 'Current Tier: Member',
        history_refresh_plus_member: 'Current Tier: PLUS Member',
        register: 'Register as a Member',
        upgrade: 'Upgrade to PLUS Member',
        demotion: 'Downgrade to Member',
        relegation: 'Maintain as PLUS Member',
        ecocredits_notice1:
            'We have updated the EcoCredits rules on Oct 17, 2024. Please carefully read our updated [<line1>EcoCredits rules</line1>] before using your EcoCredits.',

        ecoflowbenefits_title: 'EcoCredits Exclusive Benefits',
        ecoflowbenefits_savings: 'More Savings',
        ecoflowbenefits_support: 'More Support',
        ecoflowbenefits_experiences: 'More Experiences',
        ecoflowbenefits_tab_benefits: 'Benefits',
        ecoflowbenefits_tab_tier: 'Tier',
        ecoflowbenefits_tab_plus: 'PLUS MEMBER',
        ecoflowbenefits_tab_normal: 'MEMBER',
        ecoflowbenefits_savings1: 'Earn EcoCredits for Every Purchase',
        ecoflowbenefits_savings2: 'Earn EcoCredits From Successful Friend Sign-ups',
        ecoflowbenefits_savings3: 'Redeem EcoCredits for Discounts',
        ecoflowbenefits_savings4: 'Redeem EcoCredits for Special Gifts',
        ecoflowbenefits_savings5: 'Save 25% OFF at Harvest Hosts',
        ecoflowbenefits_savings5_link: 'Get the Code',
        ecoflowbenefits_savings6: 'Save 10% OFF at Winnebago gears',
        ecoflowbenefits_savings6_link: 'Get the Code',
        ecoflowbenefits_savings7: 'Refer & Earn Up To $500 Cash Reward!',
        ecoflowbenefits_savings7_link: 'Refer Now',
        ecoflowbenefits_savings8: 'Exclusive Birthday Coupon',
        ecoflowbenefits_savings9: 'PLUS Level-up Coupon',
        ecoflowbenefits_savings10: 'PLUS Exclusive Gifts ',
        ecoflowbenefits_savings11: 'Monthly Coupon Pack',
        ecoflowbenefits_savings21: 'Enjoy special Member-only prices (when available)',
        ecoflowbenefits_savings22: 'Use EcoCredits as cash for orders.',
        ecoflowbenefits_savings_tips1: 'Enjoy one free return within one month of purchase.',
        ecoflowbenefits_savings_tips2:
            'Receive a special discount on service charges for out-of-warranty repairs.\nEcoFlow reserves the right to determine the scope of repairs based on the actual situation.',
        ecoflowbenefits_savings_tips3:
            'If your product is irreparably damaged, you’re eligible for this exclusive benefit. Simply provide proof of shipment for the damaged item along with a screenshot of your PLUS Membership status. Once verified, we’ll send you a replacement right away—no need to wait for us to receive the broken item.\nNote: This service cannot be used together with the extra 4-month replacement benefit.',
        ecoflowbenefits_support1: 'Free Shipping on Most Products',
        ecoflowbenefits_support2: 'Extended Warranty for Selected Products',

        ecoflowbenefits_support3: 'Free Unconditional Return (1 Order)',
        ecoflowbenefits_support4: '12% Discount on Out-of-Warranty Service Charges',
        ecoflowbenefits_support5: 'Express Replacement Service',
        ecoflowbenefits_support6: 'Tier',

        ecoflowbenefits_experiences1: 'Benefits From Our Partners',
        ecoflowbenefits_experiences2: 'Member-Only Event',
        ecoflowbenefits_experiences3: 'New Product Trial Event (Coming Soon)',
        ecoflowbenefits_experiences4: 'Exclusive Early Bird Access (Coming Soon)',
        ecoflowbenefits_savings_message: 'Please check <line>here</line> to see how to claim vouchers for PLUS MEMBER.',
        ecoflowbenefits_savings_message_pop1: "1. Don't forget to log into your EcoFlow Account on the EcoCredits page.",
        ecoflowbenefits_savings_message_pop2: '2. You will see the pop-up right away if you have a new voucher to claim.',
        ecoflowbenefits_savings_message_pop3:
            "3. Don't worry if you missed it. Go to the 'gift' icon and check the voucher in \"My Rewards\". Don't forget to use it within the valid time.",
        ecoflowbenefits_support_message: 'Please contact <email>support@ecoflow.com</email> for assistance in using your benefits.',
        ecoflowbenefits_experiences_message: 'Stay tuned with us!',
        only_plus_member: 'Only PLUS Members can redeem the reward.',
        only_member: 'Only Members can redeem the reward.',

        plusbenefit: {
            ins_title: 'Follow Us On Instagram',
            ins_desc: 'Earn XX EcoCredits when you follow for the first time.',
        },
        date_of_event: 'Date of Event',
        expiration_date: 'Expiration Date',
        not_eligible: 'You are not eligible to participate in this event.',
        // 25年会员活动
        first_login_2025: 'First time logging in',
        know_brand_2025: 'Learn more about EcoFlow',
        know_member_2025: 'Learn more about Membership',
        share_story_2025: 'Share my story',
        first_order_2025: 'Complete a purchase',
        repeat_order_2025: 'Make an additional purchase',
    },
    br: {
        shop1: 'Ganhe a cada vez que você fizer um pedido.',
        warranty1: 'Você recebeu 1.000 EcoCredits ao registrar um produto.',
        profile1: 'Você recebeu 1.000 EcoCredits ao preencher seu perfil.',
        referral1: 'Obtenha EcoCredits para cada registro bem-sucedido de um amigo.',
        ins: 'Você recebeu 100 EcoCredits ao nos seguir no Instagram.',
        x: 'Você recebeu 100 EcoCredits ao nos seguir no X.',
        youtube: 'Você recebeu 100 EcoCredits ao nos seguir no YouTube.',
        facebook: 'Você recebeu 100 EcoCredits ao nos seguir no Facebook.',
        line: 'Você recebeu 100 EcoCredits ao se registrar como um amigo no LINE.',
        joininfacebook: 'Você recebeu 100 EcoCredits ao se juntar a nós no Facebook.',
        clock_in: 'Check-in',
        seo_title: 'Entre para o Programa de Fidelidade EcoCredits',
        seo_desc:
            'Entre para o Programa de Fidelidade EcoCredits da EcoFlow hoje mesmo e já comece a acumular recompensas! Inscreva-se e ganhe um bônus de 500 EcoCredits.',
        join_title: 'Participe do programa de recompensas EcoCredits',
        join_subTitle: 'Torne-se membro agora e receba EcoCredits para descontos em dinheiro e recompensas exclusivas.',
        join_now: 'Inscreva-se agora',
        login: 'FAZER LOGIN',
        login_capital_letters: 'Fazer login',
        login_capital_letters1: 'Fazer login',
        subscribe1: 'Você recebeu 500 EcoCredits ao se inscrever.',
        welcome_title: 'Olá, {username}',
        welcome_sub_title: 'Receba as boas-vindas ao programa de fidelidade EcoCredits.',
        welcome_text: 'Ganhe mais EcoCredits e atualize para Assinatura PLUS para garantir mais recompensas exclusivas.',
        welcome_text_plus: 'Os benefícios exclusivos atualizados permitem que você economize mais e tenha mais experiências conosco!',
        summary_text: 'Seu resumo EcoCredits',
        membership: 'MEMBRO',
        current_tier: 'Nível atual',
        points: 'EcoCredits',
        points_balance: 'Saldo de EcoCredits',
        points_progress_tips: 'EcoCredits necessários para chegar a {plus}: {points} EcoCredits',
        coming_soon: 'Em breve',
        expires_in_one_month: 'Expira em um mês',
        redeem_now: 'RESGATE AGORA',
        points_activity: 'ATIVIDADE POR PONTOS',
        how_it_works: 'Como funciona',
        sign_up: 'Inscreva-se',
        sign_up_desc: 'Crie uma conta gratuita e inicie sua jornada como membro.',
        earn_points: 'Ganhe e utilize',
        earn_points_desc: 'Conclua tarefas para usar EcoCredits como dinheiro ou resgatar recompensas.',
        redeem_points: 'Aproveite mais',
        redeem_points_desc: 'Obtenha 6.000 EcoCredits e faça o upgrade para uma Assinatura PLUS para obter mais benefícios.',
        more_benefits: 'MAIS BENEFÍCIOS',
        more_benefits_desc: 'Faça um upgrade para Membro PLUS e economize mais.',
        more_benefits_question: 'Assim que sua conta atingir 6.000 EcoCredits, você poderá fazer o upgrade para a Assinatura PLUS.',
        sign_up_desc_1: 'Crie uma conta e receba 800 EcoCredits como recompensa.',
        already_member: 'Já é membro?',
        already_member1: 'Já é membro?',
        sign_up1: 'Você ganhou 500 EcoCredits por se cadastrar.',
        sign_up1_1: 'Você ganhou 500 EcoCredits por se cadastrar.',
        sign_up_desc_h: 'Inscreva-se na assinatura por 500 EcoCredits.',
        sign_up_desc_h_1: '800 EcoCredits na inscrição.',
        earn_points_title: 'Maneiras de ganhar EcoCredits',
        sign_up_text: '500 EcoCredits na inscrição',
        completed_text: 'Você já conquistou essa recompensa.',
        subscribe: 'Assine',
        subscribe_capital_letters: 'Assine',
        subscribe_text: 'Inscreva-se para receber as últimas notícias da EcoFlow.',
        subscribe_hover: 'Ganhe 500 EcoCredits na inscrição.',
        subscribe_now: 'Assine agora',
        email_address: 'Endereço de e-mail',
        shop: 'Comprar',
        shop_capital_letters: 'Comprar',
        earn_point_by_order: 'Earn EcoCredits every time you shop. （₱ 60=1EcoCredits）',
        earn_point_rule_shop: 'Receba 1 EcoCredit a cada R$ 1 gasto.',
        shop_to_earn_points: 'Compre para ganhar EcoCredits',
        warranty: 'Garantia',
        warranty_capital_letters: 'Registro de garantia',
        warranty_desc1: 'Registre um produto recém-recebido para 1.000 EcoCredits.',
        warranty_desc2: 'Registre um produto recém-recebido para 1.000 EcoCredits.',
        profile: 'Preencha seu perfil',
        profile_desc1: 'Complete o seu perfil para ganhar até 1.000 EcoCredits.',
        profile_desc2: 'Ganhe até 1.000 EcoCredits para adicionar suas informações.',
        complete_profile: 'Preencha seu perfil',
        referral: 'Convide um amigo',
        referral_desc: 'Obtenha EcoCredits para cada registro bem-sucedido de um amigo.',
        referral_btn: 'Inscreva-se agora',
        birthday: 'Aniversário',
        //
        birthday_desc1: 'Adicione seu aniversário para ganhar EcoCredits.',
        birthday_desc2: 'Ganhe {points} EcoCredits ao adicionar sua data de nascimento.',
        add_your_birthday: 'Adicione seu aniversário',
        birthday_placeholder: 'DD/MM/AA',
        add_my_birthday: 'Adicionar meu aniversário',
        ins_title: 'Siga a gente no Instagram',
        ins_desc1: 'Ganhe {points} EcoCredits ao seguir pela primeira vez.',
        ins_desc2: 'Ganhe {points} EcoCredits ao seguir pela primeira vez.',
        follow_button: 'Siga agora',
        follow_button_ins: '',
        follow_button_x: '',
        follow_button_youtube: '',
        follow_button_facebook: '',
        x_title: 'Siga a gente no X',
        x_desc1: 'Ganhe {points} EcoCredits ao seguir pela primeira vez.',
        x_desc2: 'Ganhe {points} EcoCredits ao seguir pela primeira vez.',
        youtube_title: 'Siga a gente no YouTube',
        youtube_desc1: 'Ganhe {points} EcoCredits ao seguir pela primeira vez.',
        youtube_desc2: 'Ganhe {points} EcoCredits ao seguir pela primeira vez.',
        facebook_title: 'Siga a gente no Facebook',
        facebook_desc1: 'Ganhe {points} EcoCredits ao seguir pela primeira vez.',
        facebook_desc2: 'Ganhe {points} EcoCredits ao seguir pela primeira vez.',
        joininfacebook_title: 'Siga a gente no Facebook',
        joininfacebook_desc1: 'Ganhe {points} EcoCredits ao entrar pela primeira vez.',
        joininfacebook_desc2: 'Ganhe {points} EcoCredits ao entrar pela primeira vez.',
        //

        redeem_ecocredits_title: 'Resgate recompensas com EcoCredits',
        have_points: 'Você tem <code>{points} EcoCredits</code>',
        view_all: 'Ver tudo',
        coupon: 'Código de desconto',
        discount: 'Desconto',
        gift_card: 'Vale-presente',
        redeemed_succ: 'Resgatados com sucesso!',
        copy_desc: 'Você já copiou o código. Vá até a loja para usá-lo.',
        store: 'Comprar agora',
        coupon_used_desc: 'Use este código no fechamento da compra para resgatar seu vale-presente de {amont}.',
        rules: 'Regras',
        off: 'DESCONTO',
        site_rules: 'Apenas para loja na BR.',
        days_rules: 'Válido por {days} dias a partir do resgate.',
        product_rules: 'Apenas para {product}.',
        days_rules2: 'Válido a partir de {data}.',
        rewards_redeemed: 'Minhas recompensas',
        lucky_rewards_list: 'Lista de recompensas',
        redeedmed_tab_name: 'Resgatados',
        issued_tab_name: 'Emitidos',
        available: 'Disponível',
        redeemed: 'Resgatados',
        expired: 'Expirados',
        edeemed_rewards_note: 'Suas recompensas resgatadas aparecerão aqui.',
        browse_ecocredits_rewards: 'Navegue pelas recompensas EcoCredits',
        used: 'Usados',
        give_away: 'Distribuídos',
        or_text: 'OU',
        send_your_friend: 'Envie seu vale-presente de {amont} para um amigo.',
        points_activity_a: 'Minha atividade',
        check_more: 'Check More',
        points_tab_name: 'Atividade de EcoCredits',
        rewards_tab_name: 'Atividade de recompensas',
        date: 'Data',
        action: 'Ação',
        email: 'Email',
        rewards_title: 'Recompensas',
        type_title: 'Tipo',
        discount_type: 'Desconto',
        purchase: 'Compra',
        profile_a: 'Perfil',
        refund: 'Reembolso',
        registered: 'Registrados',
        points_capital_letters: 'EcoCredits',
        status: 'Status',
        pending: 'Pendentes',
        received: 'Recebidos',
        deducted: 'Deduzidos',
        view_more: 'Ver mais',
        history_note: 'Sua atividade de EcoCredits aparecerá aqui. Ainda não está vendo seus EcoCredits? Sua atividade será atualizada em 24 horas.',
        lucky_flop_start: 'Inscreva-se agora',
        lucky_flop_congrat: 'Parabéns',
        lucky_flop_get: 'Reivindicar',
        lucky_flop_open: 'ABRIR',
        ecoflow_benefits: 'Benefícios EcoCredits',
        membership_includes: 'A ASSINATURA INCLUI',
        benefits_item1: 'Earn EcoCredits for Every Purchase',
        benefits_item2: 'Redeem EcoCredits for Coupon',
        benefits_item3: 'Free Shipping on Most Products',
        benefits_item4: 'Redeem EcoCredits for Special Gifts',
        benefits_item5: 'Extended Warranty for Selected Products',
        benefits_item6: 'Member-Only Event',
        benefits_item7: 'Earn EcoCredits From Successful Friend Sign-ups',
        benefits_item8: 'Benefits From Our Partners',
        benefits_item9: 'Refer & Earn Up To $500 Cash Reward!',
        benefits_link_btn: 'Refer Now',
        see_t_c: 'Veja os termos e condições',
        manually_added: 'Adicionado manualmente',
        manually_deducted: 'Deduzido manualmente',
        faq_title: 'Perguntas frequentes',
        earning_points: 'EARNING EcoCredits',
        network_error: 'Erro de reder',
        confirm_text: 'Tem certeza de que deseja resgatar? Não pode ser desfeito.',
        confirm_btn: 'Confirmar',
        no_enough_points: 'Erro no resgate, não há EcoCredits suficientes',
        no_history_note: 'Ainda não está vendo seus EcoCredits? Sua atividade será atualizada em 24 horas.',
        no_coupon_note: 'Nenhuma recompensa resgatada ainda.',
        minimum_price: 'Valor mínimo de compra ({price}).',
        minimum_num: 'Quantidade mínima de itens ({num} pçs).',
        stay_too_long: 'Sua sessão expirou. Atualize a página e tente de novo.',
        order_rule: 'Apenas um código de desconto por pedido.',
        purchas_rule: 'Comprar um item por menos que o(s) cupom(ns) cancelará a diferença.',
        profile_birthday: 'Perfil: aniversário',
        profile_address: 'Perfil: endereço',
        profile_username: 'Perfil: nome de usuário',
        profile_picture: 'Perfil: foto',
        profile_contact: 'Perfil: informações de contato',
        learn_more: 'Saiba mais',
        profile_detail:
            'Preencha seu perfil para ganhar até 1.000 EcoCredits, incluindo foto de perfil (200), nome de usuário (100), informações de contato (300), endereço (200) e aniversário (200).',
        exceeded_counts: 'Não foi possível o resgate. Você excedeu o limite de resgates.',
        grab_title: 'Pegue um Bônus EcoCredits',
        grab_sub_title: 'Ofertas exclusivas por tempo limitado para membros EcoCredit. Clique agora para solicitar!',
        grab_btn_text: 'Pegar meu bônus',
        grab_success_title: 'Parabéns',
        grab_success_text1: 'Bônus solicitado com sucesso!\nCole o código no fechamento da compra para conseguir seu desconto.',
        grab_success_text2: 'Veja seus bônus em <code>Minhas recompensas</code>.',
        'no-grab-content-note': 'Mais ofertas em breve!',
        copy_desc_2: 'Você copiou o código.',
        city_validatino_error: 'Cidade inválida',
        product_text: 'Produto',
        shipping_address_text: 'Endereço de envio',
        saved_address_text: 'Endereço salvo',
        use_new_address: 'use um novo endereço',
        spend_now: 'Gaste agora',
        stock_left: '{stock} restante',
        no_stock_tip: 'Em breve… Fique de olho!',
        order_text: 'Pedido',
        campaign_time_limit_text: 'Período de resgate válido entre {startTime} e {endTime}.',
        event_action_text: 'Evento',
        warranty_minus_action_text: 'Garantia excluída',
        question_correctly: 'Responda à pergunta corretamente',
        follow_instagram_text: 'Siga no Instagram',
        follow_x_text: 'Siga no X',
        follow_youtube_text: 'Siga no YouTube',
        follow_facebook_text: 'Siga no Facebook',
        join_facebook_text: 'Siga a gente no Facebook',
        referral_correctly: 'Programa de indicação',
        confirm_btn_text: 'Fechar',
        lucky_turntable_title: 'Roleta da Sorte',
        join_lucky_with_points: 'Custa {points} EcoCredits para uma rodada da Roleta da Sorte.',
        join_lucky_with_points2: 'Custa {points} EcoCredits para jogar uma rodada.',
        join_lucky_desc: 'Gire a Roleta e receba um grande prêmio!',
        remaining_number: '<code></code> rodadas restantes',
        remaining_number2: '<code></code> giros restantes',
        learn_lucky_rule: 'Saiba mais sobre as regras',
        prize_coupon_title: 'Parabéns',
        prize_coupon_sub_title: 'O prêmio foi solicitado com sucesso! Use o código no fechamento para salvar.',
        prize_coupon_action: 'Veja seus prêmios em <code>Minhas recompensas</code>.',
        prize_coupon_button: 'Comprar agora',
        prize_points_title: 'Parabéns',
        prize_points_desc: 'Verifique os EcoCredits recém-adicionados em <code>Minha atividade</code>.',
        limit_times_in_day: 'Você pode girar a roleta <count></count> vezes em <day></day> dias',
        limit_times_in_day2: 'Você pode virar as cartas <count></count> vezes em <day></day> dias',
        limit_times_in_active: 'Durante o evento, você pode girar a roleta até <count></count> vezes.',
        without_limit_times: 'Você pode girar a roleta <count></count> vezes a qualquer momento.',
        without_limit_times2: 'Você pode virar as cartas <count></count> vezes a qualquer momento.',
        active_is_unstart: 'Este evento acontecerá em breve.',
        active_is_ended: 'Este evento terminou.',
        over_max_count: 'Você excedeu o número de giros disponível.',
        notice_title: 'Aviso',
        points_cash: 'Resgate de pontos',
        Pending1: 'Pendentes',
        rollback: 'Devolvidos',
        level_change_log: 'Nível de atividade',
        deadline: 'Válidos até',
        history_refresh_member: 'Nível atual: Membro',
        history_refresh_plus_member: 'Nível atual: Membro PLUS',
        register: 'Registrar como Membro',
        upgrade: 'Atualizar para Membro PLUS',
        demotion: 'Voltar para Membro',
        relegation: 'Manter-se como Membro PLUS',
        ecocredits_notice1:
            'Atualizamos as regras dos EcoCredits em 17 de outubro de 2024. Leia atentamente nossas [<line1>regras dos EcoCredits</line1>] atualizadas antes de usar seus EcoCredits.',

        //
        ecoflowbenefits_title: 'Benefícios exclusivos EcoCredits',
        ecoflowbenefits_savings: 'Mais economia',
        ecoflowbenefits_support: 'Mais suporte',
        ecoflowbenefits_experiences: 'Mais experiências',
        ecoflowbenefits_tab_benefits: 'Benefícios',
        ecoflowbenefits_tab_tier: 'Nível',
        ecoflowbenefits_tab_plus: 'MEMBRO PLUS',
        ecoflowbenefits_tab_normal: 'MEMBRO',
        ecoflowbenefits_savings1: 'Ganhe EcoCredits em todas as compras',
        ecoflowbenefits_savings2: 'Ganhe EcoCredits quando amigos se cadastrarem com sucesso',
        ecoflowbenefits_savings3: 'Resgate EcoCredits para trocar por descontos',
        ecoflowbenefits_savings4: 'Regate EcoCredits para trocar por presentes especiais',
        ecoflowbenefits_savings5: 'Economize 25 % na Harvest Hosts',
        ecoflowbenefits_savings5_link: 'Pegue o código',
        ecoflowbenefits_savings6: 'Economize 10 % em acessórios Winnebago',
        ecoflowbenefits_savings6_link: 'Pegue o código',
        ecoflowbenefits_savings7: 'Indique e ganhe até R$ 1800 de recompensa em dinheiro!',
        ecoflowbenefits_savings7_link: 'Indique agora',
        ecoflowbenefits_savings8: 'Cupom exclusivo de aniversário',
        ecoflowbenefits_savings9: 'Cupom de atualização PLUS',
        ecoflowbenefits_savings10: 'Presentes exclusivos PLUS ',
        ecoflowbenefits_savings11: 'Pacote de cupom mensal',
        ecoflowbenefits_savings21: 'Aproveite preços especiais exclusivos para membros (quando disponíveis)',
        ecoflowbenefits_savings22: 'Utilize EcoCredits como dinheiro para pedidos.',
        ecoflowbenefits_savings_tips1: 'Aproveite uma devolução grátis dentro de um mês da compra.',
        ecoflowbenefits_savings_tips2:
            'Receba um desconto especial em cobranças por serviços para reparos fora da garantia.\n A EcoFlow reserva-se o direito de determinar o escopo dos reparos com base na situação efetiva.',
        ecoflowbenefits_savings_tips3:
            'Aumente seu período de substituição para um total de 5 meses, permitindo que você substitua produtos com defeito por novos',
        ecoflowbenefits_savings_tips4:
            'Se seu produto estiver quebrado sem possibilidade de reparo, você pode usar esse serviço. Depois de enviar seu produto quebrado e um certificado, imediatamente enviaremos a você um novo produto sem esperar o quebrado ser recebido. \nObservação: Este serviço não pode ser usado junto com o benefício de substituição extra de 4 meses.',
        ecoflowbenefits_support1: 'Frete grátis na maioria dos produtos',
        ecoflowbenefits_support2: 'Garantia estendida para produtos selecionados',

        ecoflowbenefits_support3: 'Devolução incondicional grátis (1 pedido)',
        ecoflowbenefits_support4: '12 % de desconto em serviços fora da garantia',
        ecoflowbenefits_support5: 'Garantia estendida para substituição de 4 meses',
        ecoflowbenefits_support6: 'Serviços de substituição expressa',

        ecoflowbenefits_experiences1: 'Benefícios de nossos parceiros',
        ecoflowbenefits_experiences2: 'Eventos exclusivos para membros',
        ecoflowbenefits_experiences3: 'Evento de teste de novo produto (em breve)',
        ecoflowbenefits_experiences4: 'Acesso antecipado exclusivo (em breve)',
        ecoflowbenefits_savings_message: 'Veja <line>aqui</line> como solicitar vouchers para MEMBRO PLUS.',
        ecoflowbenefits_savings_message_pop1: '1. Lembre-se de entrar em sua conta EcoFlow na página EcoCredits.',
        ecoflowbenefits_savings_message_pop2: '2. Você logo verá a janela pop-up se tiver um novo voucher para solicitar.',
        ecoflowbenefits_savings_message_pop3:
            '3. Não se preocupe se tiver perdido. Vá até o ícone de "presente" e veja o voucher em "Minhas recompensas". Lembre-se de usá-lo dentro do período válido.',
        ecoflowbenefits_support_message: 'Entre em contato pelo e-mail <email>support.br@ecoflow.com</email> para obter assistência no uso de seus benefícios.',
        ecoflowbenefits_experiences_message: 'Acompanhe nossas novidades!',

        //
        only_plus_member: 'Somente Membros PLUS podem resgatar a recompensa.',
        only_member: 'Somente Membros podem resgatar a recompensa.',

        plusbenefit: {
            ins_title: 'Siga a gente no Instagram', // 无翻译
            ins_desc: 'Ganhe {points} EcoCredits ao seguir pela primeira vez.',
        },
        date_of_event: 'Data do evento',
        expiration_date: 'Válido até',
        not_eligible: 'Você não é elegível para participar deste evento.',
        // 25年会员活动
        first_login_2025: 'Primeiro login',
        know_brand_2025: 'Learn more about EcoFlow',
        know_member_2025: 'Learn more about Membership',
        share_story_2025: 'Share my story',
        first_order_2025: 'Complete a purchase',
        repeat_order_2025: 'Make an additional purchase',
    },
    mx: {
        shop1: 'Gana cada vez que hagas un pedido.',
        warranty1: 'Obtuviste 1000 EcoCréditos por registrar un producto.',
        profile1: 'Obtuviste 1000 EcoCréditos por completar tu perfil.',
        referral1: 'Gana EcoCréditos por cada amigo que se registre correctamente.',
        ins: 'Obtuviste 100 EcoCréditos por seguirnos en Instagram.',
        x: 'Obtuviste 100 EcoCréditos por seguirnos en X.',
        youtube: 'Obtuviste 100 EcoCréditos por seguirnos en YouTube.',
        facebook: 'Obtuviste 100 EcoCréditos por seguirnos en Facebook.',
        line: 'Ganaste 100 EcoCréditos por registrarte como amigo en LINE.',
        joininfacebook: 'Obtuviste 100 EcoCréditos por unirte en Facebook.',
        clock_in: 'Registro',
        seo_title: 'Únete al programa de fidelidad EcoCréditos',
        seo_desc:
            'Únete hoy mismo al programa de fidelidad EcoCréditos de EcoFlow y empieza a ganar recompensas. Obtén una recompensa de 500 EcoCréditos solo por inscribirte.',
        join_title: 'Únete al programa de recompensas EcoCréditos',
        join_subTitle: 'Hazte socio ahora y consigue EcoCréditos para recibir deducciones en efectivo y recompensas exclusivas.',
        join_now: 'Únete ahora',
        login: 'INICIAR SESIÓN',
        login_capital_letters: 'Iniciar sesión',
        login_capital_letters1: 'Iniciar sesión',
        subscribe1: 'Obtuviste 500 EcoCréditos por suscribirte.',
        welcome_title: 'Hola, {username}',
        welcome_sub_title: 'Bienvenido al programa de recompensas EcoCréditos.',
        welcome_text: 'Gana más EcoCréditos y hazte socio PLUS para disfrutar de más premios exclusivos.',
        welcome_text_plus: 'Las ventajas exclusivas mejoradas te permiten ahorrar y vivir aún más experiencias con nosotros.',
        summary_text: 'Tu resumen de EcoCréditos',
        membership: 'MIEMBRO',
        current_tier: 'Nivel actual',
        points: 'EcoCredits',
        points_balance: 'Saldo de EcoCréditos',
        points_progress_tips: 'EcoCréditos necesarios para alcanzar {plus}: {points} EcoCréditos',
        coming_soon: 'Próximamente',
        expires_in_one_month: 'Caduca en un mes',
        redeem_now: 'CANJEAR AHORA',
        points_activity: 'ACTIVIDAD DE PUNTOS',
        how_it_works: 'Cómo funciona',
        sign_up: 'Regístrate',
        sign_up_desc: 'Crea una cuenta gratis y comienza tu viaje como miembro.',
        earn_points: 'Gana y usa',
        earn_points_desc: 'Completa tareas para ganar EcoCréditos que puedes usar como efectivo o canjear por recompensas.',
        redeem_points: 'Disfruta más',
        redeem_points_desc: 'Obtén 6000 EcoCréditos y actualiza a Membresía PLUS para más beneficios.',
        more_benefits: 'MÁS BENEFICIOS',
        more_benefits_desc: 'Cámbiate a Miembro PLUS para ahorrar más.',
        more_benefits_question: 'Una vez que tengas 6000 EcoCréditos en tu cuenta, podrás actualizar a la Membresía PLUS.',
        sign_up_desc_1: 'Crea una cuenta y consigue 800 EcoCréditos de recompensa.',
        already_member: '¿Ya eres miembro?',
        already_member1: '¿Ya eres miembro?',
        sign_up1: 'Obtuviste 500 EcoCréditos por registrarte.',
        sign_up1_1: 'Obtuviste 500 EcoCréditos por registrarte.',
        sign_up_desc_h: 'Regístrate como miembro y recibe 500 EcoCréditos.',
        sign_up_desc_h_1: '800 EcoCréditos cuando te inscribas.',
        earn_points_title: 'Formas de ganar EcoCréditos',
        sign_up_text: '500 EcoCréditos al inscribirte',
        completed_text: 'Ya conseguiste esta recompensa.',
        subscribe: 'Suscribirse',
        subscribe_capital_letters: 'Suscribirse',
        subscribe_text: 'Suscríbete para recibir las últimas noticias de EcoFlow.',
        subscribe_hover: 'Gana 500 EcoCréditos al suscribirte.',
        subscribe_now: 'Suscribirse ahora',
        email_address: 'Dirección de correo electrónico',
        shop: 'Tienda',
        shop_capital_letters: 'Tienda',
        earn_point_by_order: 'Gana EcoCréditos con cada compra. (MXN 20 = 1 EcoCrédito)',
        earn_point_rule_shop: 'Consigue 1 EcoCréditos por cada $1 que gastes.',
        shop_to_earn_points: 'Compra para ganar EcoCréditos',
        warranty: 'Garantía',
        warranty_capital_letters: 'Registro de garantía',
        warranty_desc1: 'Registra un producto recién recibido y gana 1000 EcoCréditos.',
        warranty_desc2: 'Registra un producto recién recibido y gana 1000 EcoCréditos.',
        profile: 'Completar perfil',
        profile_desc1: 'Gana hasta 1000 EcoCréditos por completar tu perfil.',
        profile_desc2: 'Gana hasta 1000 EcoCréditos por agregar tus datos.',
        complete_profile: 'Completar perfil',
        referral: 'Invitar a un amigo',
        referral_desc: 'Gana EcoCréditos por cada amigo que se registre correctamente.',
        referral_btn: 'Únete ahora',
        birthday: 'CUMPLEAÑOS',

        birthday_desc1: 'Agrega tu cumpleaños para obtener EcoCréditos.',
        birthday_desc2: 'Agrega tu fecha de nacimiento para ganar {points} EcoCréditos.',
        add_your_birthday: 'Agrega tu cumpleaños',
        birthday_placeholder: 'DD/MM/AA',
        add_my_birthday: 'Agregar mi cumpleaños',
        ins_title: 'Síguenos en Instagram',
        ins_desc1: 'Gana {points} EcoCréditos cuando nos sigas por primera vez.',
        ins_desc2: 'Gana {points} EcoCréditos cuando nos sigas por primera vez.',
        follow_button: 'Seguir ahora',
        follow_button_ins: '',
        follow_button_x: '',
        follow_button_youtube: '',
        follow_button_facebook: '',
        x_title: 'Síguenos en X',
        x_desc1: 'Gana {points} EcoCréditos cuando nos sigas por primera vez.',
        x_desc2: 'Gana {points} EcoCréditos cuando nos sigas por primera vez.',
        youtube_title: 'Síguenos en YouTube',
        youtube_desc1: 'Gana {points} EcoCréditos cuando nos sigas por primera vez.',
        youtube_desc2: 'Gana {points} EcoCréditos cuando nos sigas por primera vez.',
        facebook_title: 'Síguenos en Facebook',
        facebook_desc1: 'Gana {points} EcoCréditos cuando nos sigas por primera vez.',
        facebook_desc2: 'Gana {points} EcoCréditos cuando nos sigas por primera vez.',
        joininfacebook_title: 'Únete a nosotros en Facebook',
        joininfacebook_desc1: 'Gane {points} EcoCréditos cuando te unas por primera vez.',
        joininfacebook_desc2: 'Gane {points} EcoCréditos cuando te unas por primera vez.',

        redeem_ecocredits_title: 'Canjear recompensas de EcoCréditos',
        have_points: 'Tienes <code>{points} EcoCréditos</code>',
        view_all: 'Ver todo',
        coupon: 'Código de descuento',
        discount: 'Descuento',
        gift_card: 'Tarjetas de regalo',
        redeemed_succ: 'Canjeado correctamente',
        copy_desc: 'Copió el código. Vaya a la tienda para usarlo.',
        store: 'Comprar ahora',
        coupon_used_desc: 'Utilice este código al pagar para canjear su tarjeta de regalo de {amount}',
        rules: 'Reglas',
        off: 'DE DESCUENTO',
        site_rules: 'Solo para tienda de MX.',
        days_rules: 'Válido durante {days} días a partir del canje.',
        product_rules: 'Solo para {product}.',
        days_rules2: 'Válido a partir de {data}.',
        rewards_redeemed: 'Mis recompensas',
        lucky_rewards_list: 'Lista de recompensas',
        redeedmed_tab_name: 'Canjeado',
        issued_tab_name: 'Emitido',
        available: 'Disponible',
        redeemed: 'Canjeado',
        expired: 'Caducado',
        edeemed_rewards_note: 'Sus recompensas canjeadas aparecerán aquí.',
        browse_ecocredits_rewards: 'Ver recompensas de EcoCredits',
        used: 'Utilizado',
        give_away: 'Regalar',
        or_text: 'O',
        send_your_friend: 'Enviar su tarjeta de regalo de {amont} a un amigo.',
        points_activity_a: 'Mi actividad',
        check_more: 'Ver más',
        points_tab_name: 'Actividad de EcoCredits',
        rewards_tab_name: 'Actividad de recompensas',
        date: 'Fecha',
        action: 'Acción',
        email: 'Email',
        rewards_title: 'Recompensas',
        type_title: 'Tipo',
        discount_type: 'Descuento',
        purchase: 'Compra',
        profile_a: 'Perfil',
        refund: 'Reembolso',
        registered: 'Registrado',
        points_capital_letters: 'EcoCredits',
        status: 'Estado',
        pending: 'Pendiente',
        received: 'Recibido',
        deducted: 'Descontado',
        view_more: 'Ver más',
        history_note: 'Su actividad de EcoCredits aparecerá aquí. ¿Todavía no ve sus EcoCredits? Su actividad se actualizará dentro de 24 horas.',
        lucky_flop_start: 'Join Now',
        lucky_flop_congrat: 'Felicitaciones',
        lucky_flop_get: 'Reclamar',
        lucky_flop_open: 'ABRIR',
        ecoflow_benefits: 'Beneficios de EcoCredits',
        membership_includes: 'LA MEMBRESÍA INCLUYE',
        benefits_item1: 'Earn EcoCredits for Every Purchase',
        benefits_item2: 'Redeem EcoCredits for Coupon',
        benefits_item3: 'Free Shipping on Most Products',
        benefits_item4: 'Redeem EcoCredits for Special Gifts',
        benefits_item5: 'Extended Warranty for Selected Products',
        benefits_item6: 'Member-Only Event',
        benefits_item7: 'Earn EcoCredits From Successful Friend Sign-ups',
        benefits_item8: 'Benefits From Our Partners',
        benefits_item9: 'Refer & Earn Up To $500 Cash Reward!',
        benefits_link_btn: 'Refer Now',
        see_t_c: 'Ver términos y condiciones',
        manually_added: 'Agregado manualmente',
        manually_deducted: 'Deducido manualmente',
        faq_title: 'Preguntas frecuentes',
        earning_points: 'CANJE de EcoCredits',
        network_error: 'Error de red',
        confirm_text: '¿Está seguro de que desea canjear? No se puede deshacer.',
        confirm_btn: 'Confirmar',
        no_enough_points: 'Error de canje, sus EcoCredits no son suficientes',
        no_history_note: '¿Todavía no ve sus EcoCredits? Su actividad se actualizará en 24 horas.',
        no_coupon_note: 'Aún no se ha canjeado ninguna recompensa.',
        minimum_price: 'Importe mínimo de compra ({price}).',
        minimum_num: 'Cantidad mínima de artículos({num} uds.).',
        stay_too_long: 'Su sesión ha expirado. Actualice la página e inténtelo de nuevo.',
        order_rule: 'Solo un código de descuento por pedido.',
        purchas_rule: 'Si compra un artículo por un precio inferior al del cupón, perderá la diferencia.',
        profile_birthday: 'Perfil - Cumpleaños',
        profile_address: 'Perfil - Dirección',
        profile_username: 'Perfil - Nombre de usuario',
        profile_picture: 'Perfil - Foto',
        profile_contact: 'Perfil - Información de contacto',
        learn_more: 'Más información',
        profile_detail:
            'Complete su perfil para obtener hasta 1000 EcoCredits, lo que incluye foto de perfil (200), nombre de usuario (100), información de contacto (300), dirección (200) y cumpleaños (200).',
        exceeded_counts: 'No se pudo canjear. Ha superado el límite de canje.',
        grab_title: 'Obtenga una bonificación de EcoCredits',
        grab_sub_title: 'Ofertas exclusivas por tiempo limitado para miembros de EcoCredit. Haga clic para canjear ahora',
        grab_btn_text: 'Obtener mi bonificación',
        grab_success_title: 'Felicitaciones',
        grab_success_text1: 'Ha conseguido su bonificación\nPegue el código al comprar para obtener su descuento.',
        grab_success_text2: 'Revise sus bonos en <code>Mis Recompensas</code>.',
        'no-grab-content-note': 'Próximamente habrán más ofertas',
        copy_desc_2: 'Ha copiado el código.',
        city_validatino_error: 'Ciudad no válida',
        product_text: 'Producto',
        shipping_address_text: 'Dirección de envío',
        saved_address_text: 'Direcciones guardadas',
        use_new_address: 'utilizar una nueva dirección',
        spend_now: 'Gastar ahora',
        stock_left: '{stock} restante',
        no_stock_tip: 'Próximamente… Esté atento.',
        order_text: 'Pedido',
        campaign_time_limit_text: 'Período de canje válido: {startTime} - {endTime}.',
        event_action_text: 'Evento',
        warranty_minus_action_text: 'Garantía eliminada',
        question_correctly: 'Responda correctamente a la pregunta',
        follow_instagram_text: 'Seguir en Instagram',
        follow_x_text: 'Seguir en X',
        follow_youtube_text: 'Seguir en YouTube',
        follow_facebook_text: 'Seguir en Facebook',
        join_facebook_text: 'Únete a nosotros en Facebook',
        referral_correctly: 'Programa de recomendación',
        confirm_btn_text: 'Cerrar',
        lucky_turntable_title: 'Tirada de la suerte',
        join_lucky_with_points: 'Una partida de tirada de la suerte cuesta {points} EcoCredits.',
        join_lucky_with_points2: 'Una partida cuesta {points} EcoCredits.',
        join_lucky_desc: '¡Gire la rueda y gane un premio!',
        remaining_number: '<code></code> giros restantes',
        remaining_number2: '<code></code> vueltas restantes',
        learn_lucky_rule: 'Conozca más sobre las reglas',
        prize_coupon_title: 'Felicitaciones',
        prize_coupon_sub_title: '¡El premio ha sido reclamado con éxito! Utilice el código al pagar para ahorrar.',
        prize_coupon_action: 'Vea sus premios en <code>Mis premios</code>.',
        prize_coupon_button: 'Comprar ahora',
        prize_points_title: 'Felicitaciones',
        prize_points_desc: 'Compruebe los EcoCredits recién agregados en <code>Mi Actividad</code>.',
        limit_times_in_day: 'Puede girar las ruletas <count></count> veces en <day></day> días.',
        limit_times_in_day2: 'Puede voltear las cartas <count></count> veces en <day></day> días',
        limit_times_in_active: 'Durante el evento, puede girar las ruletas hasta <count></count> veces.',
        without_limit_times: 'Puede girar las ruedas <count></count> veces en cualquier momento.',
        without_limit_times2: 'Puede voltear las cartas <count></count> veces en cualquier momento.',
        active_is_unstart: 'Este evento se celebrará próximamente.',
        active_is_ended: 'Este evento ha finalizado.',
        over_max_count: 'Ha superado el número de giros disponibles.',
        notice_title: 'Aviso',
        points_cash: 'Canje de puntos',
        Pending1: 'Pendiente',
        rollback: 'Devuelto',
        level_change_log: 'Nivel de actividad',
        deadline: 'Válido hasta',
        history_refresh_member: 'Nivel actual: Miembro',
        history_refresh_plus_member: 'Nivel actual: Miembro PLUSr',
        register: 'Registrarse como miembro',
        upgrade: 'Cambiar a Miembro PLUS',
        demotion: 'Cambiar a Miembro',
        relegation: 'Mantenerse como Miembro PLUS',
        ecocredits_notice1:
            'Hemos actualizado las normas de los EcoCredits el 17 de octubre de 2024. Lea atentamente nuestras [<line1>Normas de EcoCredits</line1>] actualizadas antes de utilizar sus EcoCredits.',

        ecoflowbenefits_title: 'Beneficios exclusivos de EcoCréditos',
        ecoflowbenefits_savings: 'Más ahorro',
        ecoflowbenefits_support: 'Más soporte',
        ecoflowbenefits_experiences: 'Más experiencias',
        ecoflowbenefits_tab_benefits: 'Beneficios',
        ecoflowbenefits_tab_tier: 'Nivel',
        ecoflowbenefits_tab_plus: 'MIEMBRO PLUS',
        ecoflowbenefits_tab_normal: 'MIEMBRO',
        ecoflowbenefits_savings1: 'Obtén EcoCréditos con cada compra',
        ecoflowbenefits_savings2: 'Obtén EcoCréditos cuando tus amigos se registren',
        ecoflowbenefits_savings3: 'Canjea EcoCréditos por descuentos',
        ecoflowbenefits_savings4: 'Canjea EcoCréditos por regalos especiales',
        ecoflowbenefits_savings5: 'Obtenga un 25 % de descuento en Harvest Hosts',
        ecoflowbenefits_savings5_link: 'Obtenga el código',
        ecoflowbenefits_savings6: 'Ahorre un 10 % en equipos de Winnebago',
        ecoflowbenefits_savings6_link: 'Obtenga el código',
        ecoflowbenefits_savings7: '¡Recomienda y gana una recompensa en efectivo de hasta $6000 en efectivo!',
        ecoflowbenefits_savings7_link: 'Recomendar ahora',
        ecoflowbenefits_savings8: 'Cupón de cumpleaños exclusivo',
        ecoflowbenefits_savings9: 'Cupón de subida de nivel PLUS',
        ecoflowbenefits_savings10: 'Regalos exclusivos PLUS ',
        ecoflowbenefits_savings11: 'Paquete de cupones mensual',
        ecoflowbenefits_savings21: 'Disfruta de precios especiales exclusivos para miembros (cuando estén disponibles)',
        ecoflowbenefits_savings22: 'Usa EcoCréditos como efectivo en tus compras.',
        ecoflowbenefits_savings_tips1: 'Disfrute de una devolución gratuita en el plazo de un mes desde la compra.',
        ecoflowbenefits_savings_tips2:
            'Reciba un descuento especial en los cargos de servicio por reparaciones fuera de garantía.\n EcoFlow se reserva el derecho de determinar el alcance de las reparaciones en función de la situación real.',
        ecoflowbenefits_savings_tips3: 'Extienda su periodo de reemplazo a un total de 5 meses, permitiendo que reemplace productos defectuosos con nuevos.',
        ecoflowbenefits_savings_tips4:
            'Si su producto tiene una avería irreparable, puede utilizar este servicio. Después de enviar su producto averiado y proporcionar el certificado, le enviaremos inmediatamente un nuevo producto sin esperar a recibir el averiado. \nNota: Este servicio no se puede usar en conjunto con el beneficio de reemplazo de los 4 meses extra.',
        ecoflowbenefits_support1: 'Envío gratuito para la mayoría de los productos',
        ecoflowbenefits_support2: 'Garantía ampliada en productos seleccionados',

        ecoflowbenefits_support3: 'Devolución incondicional gratuita (1 pedido)',
        ecoflowbenefits_support4: 'Devolución incondicional gratuita (1 pedido)',
        ecoflowbenefits_support5: 'Reemplazo de garantía de 4 meses extendida',
        ecoflowbenefits_support6: 'Servicio de sustitución exprés',

        ecoflowbenefits_experiences1: 'Beneficios de nuestros socios',
        ecoflowbenefits_experiences2: 'Evento exclusivo para miembros',
        ecoflowbenefits_experiences3: 'Prueba de nuevos productos (próximamente)',
        ecoflowbenefits_experiences4: 'Acceso anticipado exclusivo (próximamente)',
        ecoflowbenefits_savings_message: 'Consulta <line>aquí</line> para ver cómo reclamar los vales para MIEMBRO PLUS.',
        ecoflowbenefits_savings_message_pop1: '1. No olvide iniciar sesión en su cuenta EcoFlow en la página de EcoCredits.',
        ecoflowbenefits_savings_message_pop2: '2. Verá la ventana emergente de inmediato si tiene un nuevo vale para reclamar.',
        ecoflowbenefits_savings_message_pop3:
            '3. No se preocupe si no lo ha visto. Vaya al ícono “regalo” y verifique el vale en “Mis recompensas”. No olvide utilizarlo dentro del plazo de validez.',
        ecoflowbenefits_support_message: 'Comunícate con <email>support.mx@ecoflow.com</email> si necesitas ayuda para utilizar tus beneficios.',
        ecoflowbenefits_experiences_message: '¡Permanece conectado!',
        only_plus_member: 'Solo los miembros PLUS pueden canjear la recompensa.',
        only_member: 'Solo los miembros pueden canjear la recompensa.',

        plusbenefit: {
            // 无翻译
            ins_title: 'Síguenos en Instagram',
            ins_desc: 'Gana {points} EcoCréditos cuando nos sigas por primera vez.',
        },
        date_of_event: 'Fecha del evento',
        expiration_date: 'Fecha de caducidad',
        not_eligible: 'No aplica para participar en este evento.',
        // 25年会员活动
        first_login_2025: 'Primer inicio de sesión',
        know_brand_2025: 'Learn more about EcoFlow',
        know_member_2025: 'Learn more about Membership',
        share_story_2025: 'Share my story',
        first_order_2025: 'Complete a purchase',
        repeat_order_2025: 'Make an additional purchase',
    },
    ph: {
        shop1: 'Earn every time you order.',
        warranty1: 'You got 1000 EcoCredits by registering a product.',
        profile1: 'You got 1000 EcoCredits by completing your profile.',
        referral1: "Get EcoCredits for each friend's successful registration.",
        ins: 'You got 100 EcoCredits by following us on Instagram.',
        x: 'You got 100 EcoCredits by following us on X.',
        youtube: 'You got 100 EcoCredits by following us on YouTube.',
        facebook: 'You got 100 EcoCredits by following us on Facebook.',
        line: 'You earned 100 EcoCredits by registering as a friend on LINE.',
        joininfacebook: 'You got 100 EcoCredits by joining us on Facebook.',
        clock_in: 'Check-in',
        seo_title: 'Join The EcoCredits Loyalty Program',
        seo_desc: 'Join the EcoCredits Loyalty Program at EcoFlow today and start earning rewards now! Get a 500-EcoCredits reward just for signing up.',
        join_title: 'Join the EcoCredits reward program',
        join_subTitle: 'Become a member now and get EcoCredits for cash deductions and exclusive rewards.',
        join_now: 'JOIN NOW',
        login: 'LOG IN',
        login_capital_letters: 'Log in',
        login_capital_letters1: 'Log in',
        subscribe1: 'You got 500 EcoCredits by subscribing.',
        welcome_title: 'Hi {username}',
        welcome_sub_title: 'Welcome to the EcoCredits reward program.',
        welcome_text: 'Earn more EcoCredits and upgrade to PLUS Membership to enjoy more exclusive rewards.',
        welcome_text_plus: 'The upgraded exclusive benefits allow you to save and experience even more with us!',
        summary_text: 'Your EcoCredits Summary',
        membership: 'MEMBER',
        current_tier: 'Current Tier',
        points: 'EcoCredits',
        points_balance: 'EcoCredits Balance',
        points_progress_tips: 'EcoCredits Needed to Reach {plus}: {points} EcoCredits',
        coming_soon: 'Coming Soon',
        expires_in_one_month: 'Expires in One Month',
        redeem_now: 'REDEEM NOW',
        points_activity: 'POINTS ACTIVITY',
        how_it_works: 'How It Works',
        sign_up: 'Sign Up',
        sign_up_desc: 'Create an account for free and start your membership journey.',
        earn_points: 'Earn & Use',
        earn_points_desc: 'Complete tasks for EcoCredits to use as cash or redeem rewards.',
        redeem_points: 'Enjoy More',
        redeem_points_desc: 'Get 6000 EcoCredits and upgrade to a PLUS Membership for more.',
        more_benefits: 'MORE BENEFITS',
        more_benefits_desc: 'Upgrade to PLUS Member to save more.',
        more_benefits_question: 'Once you have 6,000 EcoCredits in your account, you can upgrade to PLUS Membership.',
        sign_up_desc_1: 'Create an account and get 800 EcoCredits reward.',
        already_member: 'Already a member?',
        already_member1: 'Already a member?',
        sign_up1: 'You got 500 EcoCredits by signing up.',
        sign_up1_1: 'You got 800 EcoCredits by signing up.',
        sign_up_desc_h: 'Sign up for Membership for 500 EcoCredits.',
        sign_up_desc_h_1: '800 EcoCredits when you join.',
        earn_points_title: 'Ways to Earn EcoCredits',
        sign_up_text: '500 EcoCredits upon joining',
        completed_text: 'You have already achieved this reward.',
        subscribe: 'Subscribe',
        subscribe_capital_letters: 'Subscribe',
        subscribe_text: 'Subscribe to get the latest EcoFlow news.',
        subscribe_hover: 'Earn 500 EcoCredits when you join.',
        subscribe_now: 'Subscribe Now',
        email_address: 'Email Address',
        shop: 'Shop',
        shop_capital_letters: 'Shop',
        earn_point_by_order: 'Earn EcoCredits every time you shop. （₱ 60=1EcoCredits）',
        earn_point_rule_shop: 'Get 1 EcoCredits for every ₱60 you spend.',
        shop_to_earn_points: 'Shop To Earn EcoCredits',
        warranty: 'Warranty',
        warranty_capital_letters: 'Warranty Registration',
        warranty_desc1: 'Register a newly received product for 1000 EcoCredits.',
        warranty_desc2: 'Register a newly received product for 1000 EcoCredits.',
        profile: 'Complete Profile',
        profile_desc1: 'Completing your profile for up to 1000 EcoCredits.',
        profile_desc2: 'Get up to 1000 EcoCredits for adding your details.',
        complete_profile: 'Complete Profile',
        referral: 'Invited A Friend',
        referral_desc: "Get EcoCredits for each friend's successful registration.",
        referral_btn: 'Join Now',
        birthday: 'BIRTHDAY',
        birthday_desc1: 'Add your birthday for EcoCredits.',
        birthday_desc2: 'Earn {points} EcoCredits when you add your date of birth.',
        add_your_birthday: 'Add Your Birthday',
        birthday_placeholder: 'MM / DD / YY',
        add_my_birthday: 'Add My Birthday',
        ins_title: 'Follow Us On Instagram',
        ins_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        ins_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        follow_button: 'Follow Now',
        follow_button_ins: '',
        follow_button_x: '',
        follow_button_youtube: '',
        follow_button_facebook: '',
        x_title: 'Follow Us On X',
        x_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        x_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        youtube_title: 'Follow Us On YouTube',
        youtube_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        youtube_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        facebook_title: 'Follow Us On Facebook',
        facebook_desc1: 'Earn {points} EcoCredits when you follow for the first time.',
        facebook_desc2: 'Earn {points} EcoCredits when you follow for the first time.',
        joininfacebook_title: 'Join Us On Facebook',
        joininfacebook_desc1: 'Earn {points} EcoCredits when you join for the first time.',
        joininfacebook_desc2: 'Earn {points} EcoCredits when you join for the first time.',
        redeem_ecocredits_title: 'Redeem EcoCredits Rewards',
        have_points: 'You have <code>{points} EcoCredits</code>',
        view_all: 'View all',
        coupon: 'Discount code',
        discount: 'Discount',
        gift_card: 'Gift Card',
        redeemed_succ: 'Redeemed successfully!',
        copy_desc: 'You have copied the code, please go to the store to use it.',
        store: 'Shop Now',
        coupon_used_desc: 'Use this code at checkout to redeem your {amont} gift card.',
        rules: 'Rules',
        off: 'OFF',
        site_rules: 'For PH store only.',
        days_rules: 'Valid for {days} days from redemption.',
        product_rules: 'For {product} only.',
        days_rules2: 'Valid from {data}.',
        rewards_redeemed: 'My Rewards',
        lucky_rewards_list: 'Rewards List',
        redeedmed_tab_name: 'Redeemed',
        issued_tab_name: 'Issued',
        available: 'Available',
        redeemed: 'Redeemed',
        expired: 'Expired',
        edeemed_rewards_note: 'Your redeemed rewards will appear here.',
        browse_ecocredits_rewards: 'Browse EcoCredits Rewards',
        used: 'Used',
        give_away: 'Give away',
        or_text: 'OR',
        send_your_friend: 'Send your {amont} gift card to a friend.',
        points_activity_a: 'My Activity',
        check_more: 'Check More',
        points_tab_name: 'EcoCredits Activity',
        rewards_tab_name: 'Rewards Activity',
        date: 'Date',
        action: 'Action',
        email: 'Email',
        rewards_title: 'Rewards',
        type_title: 'Type',
        discount_type: 'Discount',
        purchase: 'Purchase',
        profile_a: 'Profile',
        refund: 'Refund',
        registered: 'Registered',
        points_capital_letters: 'EcoCredits',
        status: 'Status',
        pending: 'Pending',
        received: 'Received',
        deducted: 'Deducted',
        view_more: 'View More',
        history_note: 'Your EcoCredits activity will appear here. Don’t see your EcoCredits yet? Your activity will update within 24 hours.',
        lucky_flop_start: 'Join Now',
        lucky_flop_congrat: 'Congratulations',
        lucky_flop_get: 'Claim',
        lucky_flop_open: 'OPEN',
        ecoflow_benefits: 'EcoCredits Benefits',
        membership_includes: 'MEMBERSHIP INCLUDES',
        benefits_item1: 'Earn EcoCredits for Every Purchase',
        benefits_item2: 'Redeem EcoCredits for Coupon',
        benefits_item3: 'Free Shipping on Most Products',
        benefits_item4: 'Redeem EcoCredits for Special Gifts',
        benefits_item5: 'Extended Warranty for Selected Products',
        benefits_item6: 'Member-Only Event',
        benefits_item7: 'Earn EcoCredits From Successful Friend Sign-ups',
        benefits_item8: 'Benefits From Our Partners',
        benefits_item9: 'Refer & Earn Up To $500 Cash Reward!',
        benefits_link_btn: 'Refer Now',
        see_t_c: 'See Terms and Conditions',
        manually_added: 'Manually Added',
        manually_deducted: 'Manually Deducted',
        faq_title: 'FAQ',
        earning_points: 'EARNING EcoCredits',
        network_error: 'Network Error',
        confirm_text: 'Are you sure you want to redeem? Cannot be undone.',
        confirm_btn: 'Confirm',
        no_enough_points: 'Redemption failed, your EcoCredits are not enough',
        no_history_note: 'Don’t see your EcoCredits yet? Your activity will update with in 24 hours.',
        no_coupon_note: 'No rewards redeemed yet.',
        minimum_price: 'Minimum purchase amount ({price}).',
        minimum_num: 'Minimum quantity of items({num} pcs).',
        stay_too_long: 'Your session has expired. Please refresh the page and try again.',
        order_rule: 'Only one discount code per order.',
        purchas_rule: 'Purchasing an item for less than the coupon(s), will forfeit the difference.',
        profile_birthday: 'Profile - birthday',
        profile_address: 'Profile - address',
        profile_username: 'Profile - username',
        profile_picture: 'Profile - picture',
        profile_contact: 'Profile - contact info',
        learn_more: 'Learn more',
        profile_detail:
            'Complete your profile for up to 1000 EcoCredits, including profile pic (200), user name (100), contact info (300), address (200), and birthday (200).',
        exceeded_counts: 'Failed to redeem. You have exceeded the redemption limit.',
        grab_title: 'Grab an EcoCredits Bonus',
        grab_sub_title: 'Exclusive limited-time offers for EcoCredit members. Click to claim now!',
        grab_btn_text: 'Grab My Bonus',
        grab_success_title: 'Congratulations',
        grab_success_text1: 'Bonus claimed successfully!\n Paste the code at checkout to get your discount.',
        grab_success_text2: 'Check your bonuses in <code>My Rewards</code>.',
        'no-grab-content-note': 'More offers coming soon!',
        copy_desc_2: 'You have copied the code.',
        city_validatino_error: 'Invalid city',
        product_text: 'Product',
        shipping_address_text: 'Shipping address',
        saved_address_text: 'Saved addresses',
        use_new_address: 'use a new address',
        spend_now: 'Spend Now',
        stock_left: '{stock} Left',
        no_stock_tip: 'Coming soon... Stay tuned!',
        order_text: 'Order',
        campaign_time_limit_text: 'Valid redemption period: {startTime} - {endTime}.',
        event_action_text: 'Event',
        warranty_minus_action_text: 'Warranty Deleted',
        question_correctly: 'Answer the question correctly',
        follow_instagram_text: 'Follow Instagram',
        follow_x_text: 'Follow X',
        follow_youtube_text: 'Follow YouTube',
        follow_facebook_text: 'Follow Facebook',
        join_facebook_text: 'Join Us On Facebook',
        referral_correctly: 'Referral program',
        confirm_btn_text: 'Close',
        lucky_turntable_title: 'Lucky Spin',
        join_lucky_with_points: 'It costs you {points} EcoCredits to do one round of Lucky Spin.',
        join_lucky_with_points2: 'It costs you {points} EcoCredits to play a round.',
        join_lucky_desc: 'Spin the wheel and get a great prize!',
        remaining_number: '<code></code> spins left',
        remaining_number2: '<code></code> flips left',
        learn_lucky_rule: 'Learn more about the rules',
        prize_coupon_title: 'Congratulations',
        prize_coupon_sub_title: 'The prize was claimed successfully! Use the code at checkout to save.',
        prize_coupon_action: 'Check your prizes in <code>My Rewards</code>.',
        prize_coupon_button: 'Shop Now',
        prize_points_title: 'Congratulations',
        prize_points_desc: 'Check the just-added EcoCredits in <code>My Activity</code>.',
        limit_times_in_day: 'You can spin the wheels <count></count> times in <day></day> days',
        limit_times_in_day2: 'You can flip the cards <count></count> times in <day></day> days',
        limit_times_in_active: 'During the event, you can spin the wheels up to <count></count> times.',
        without_limit_times: 'You can spin the wheels <count></count> times at any time.',
        without_limit_times2: 'You can flip the cards <count></count> times at any time.',
        active_is_unstart: 'This event is coming soon.',
        active_is_ended: 'This event has ended.',
        over_max_count: 'You have exceeded the number of spins available.',
        notice_title: 'Notice',
        points_cash: 'Points Redemption',
        Pending1: 'Pending',
        rollback: 'Returned',
        level_change_log: 'Tier Activity',
        deadline: 'Valid Until',
        history_refresh_member: 'Current Tier: Member',
        history_refresh_plus_member: 'Current Tier: PLUS Member',
        register: 'Register as a Member',
        upgrade: 'Upgrade to PLUS Member',
        demotion: 'Downgrade to Member',
        relegation: 'Maintain as PLUS Member',
        ecocredits_notice1:
            'We have updated the EcoCredits rules on Oct 17, 2024. Please carefully read our updated [<line1>EcoCredits rules</line1>] before using your EcoCredits.',

        ecoflowbenefits_title: 'EcoCredits Exclusive Benefits',
        ecoflowbenefits_savings: 'More Savings',
        ecoflowbenefits_support: 'More Support',
        ecoflowbenefits_experiences: 'More Experiences',
        ecoflowbenefits_tab_benefits: 'Benefits',
        ecoflowbenefits_tab_tier: 'Tier',
        ecoflowbenefits_tab_plus: 'PLUS MEMBER',
        ecoflowbenefits_tab_normal: 'MEMBER',
        ecoflowbenefits_savings1: 'Earn EcoCredits for Every Purchase',
        ecoflowbenefits_savings2: 'Earn EcoCredits From Successful Friend Sign-ups',
        ecoflowbenefits_savings3: 'Redeem EcoCredits for Discounts',
        ecoflowbenefits_savings4: 'Redeem EcoCredits for Special Gifts',
        ecoflowbenefits_savings5: 'Save 25% OFF at Harvest Hosts',
        ecoflowbenefits_savings5_link: 'Get the Code',
        ecoflowbenefits_savings6: 'Save 10% OFF at Winnebago gears',
        ecoflowbenefits_savings6_link: 'Get the Code',
        ecoflowbenefits_savings7: 'Refer & Earn Up To $500 Cash Reward!',
        ecoflowbenefits_savings7_link: 'Refer Now',
        ecoflowbenefits_savings8: 'Exclusive Birthday Coupon',
        ecoflowbenefits_savings9: 'PLUS Level-up Coupon',
        ecoflowbenefits_savings10: 'PLUS Exclusive Gifts ',
        ecoflowbenefits_savings11: 'Monthly Coupon Pack',
        ecoflowbenefits_savings21: 'Enjoy special Member-only prices (when available)',
        ecoflowbenefits_savings22: 'Use EcoCredits as cash for orders.',
        ecoflowbenefits_savings_tips1: 'Enjoy one free return within one month of purchase.',
        ecoflowbenefits_savings_tips2:
            'Receive a special discount on service charges for out-of-warranty repairs.\nEcoFlow reserves the right to determine the scope of repairs based on the actual situation.',
        ecoflowbenefits_savings_tips3:
            'If your product is irreparably damaged, you’re eligible for this exclusive benefit. Simply provide proof of shipment for the damaged item along with a screenshot of your PLUS Membership status. Once verified, we’ll send you a replacement right away—no need to wait for us to receive the broken item.',
        ecoflowbenefits_savings_tips4:
            'If your product is irreparably damaged, you’re eligible for this exclusive benefit. Simply provide proof of shipment for the damaged item along with a screenshot of your PLUS Membership status. Once verified, we’ll send you a replacement right away—no need to wait for us to receive the broken item. \nNote: This service cannot be used together with the extra 4-month replacement benefit.',
        ecoflowbenefits_support1: 'Free Shipping on Most Products',
        ecoflowbenefits_support2: 'Extended Warranty for Selected Products',

        ecoflowbenefits_support3: 'Free Unconditional Return (1 Order)',
        ecoflowbenefits_support4: '12% Discount on Out-of-Warranty Service Charges',
        ecoflowbenefits_support5: 'Express Replacement Service',
        ecoflowbenefits_support6: 'Express Replacement Service',

        ecoflowbenefits_experiences1: 'Benefits From Our Partners',
        ecoflowbenefits_experiences2: 'Member-Only Event',
        ecoflowbenefits_experiences3: 'New Product Trial Event (Coming Soon)',
        ecoflowbenefits_experiences4: 'Exclusive Early Bird Access (Coming Soon)',
        ecoflowbenefits_savings_message: 'Please check <line>here</line> to see how to claim vouchers for PLUS MEMBER.',
        ecoflowbenefits_savings_message_pop1: "1. Don't forget to log into your EcoFlow Account on the EcoCredits page.",
        ecoflowbenefits_savings_message_pop2: '2. You will see the pop-up right away if you have a new voucher to claim.',
        ecoflowbenefits_savings_message_pop3:
            "3. Don't worry if you missed it. Go to the 'gift' icon and check the voucher in \"My Rewards\". Don't forget to use it within the valid time.",
        ecoflowbenefits_support_message: 'Please contact <email>support.sea@ecoflow.com</email> for assistance in using your benefits.',
        ecoflowbenefits_experiences_message: 'Stay tuned with us!',
        only_plus_member: 'Only PLUS Members can redeem the reward.',
        only_member: 'Only Members can redeem the reward.',

        plusbenefit: {
            ins_title: 'Follow Us On Instagram',
            ins_desc: 'Earn XX EcoCredits when you follow for the first time.',
        },
        date_of_event: 'Date of Event',
        expiration_date: 'Expiration Date',
        not_eligible: 'You are not eligible to participate in this event.',
        // 25年会员活动
        first_login_2025: 'First time logging in',
        know_brand_2025: 'Learn more about EcoFlow',
        know_member_2025: 'Learn more about Membership',
        share_story_2025: 'Share my story',
        first_order_2025: 'Complete a purchase',
        repeat_order_2025: 'Make an additional purchase',
    },
};
